/**
 * Copyright IBM Corp. 2019, 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import { _ as _objectWithoutProperties, I as Icon, a as _extends } from '../Icon-9ecdf98c.js';
import React from 'react';
import '@carbon/icon-helpers';
import 'prop-types';

var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _circle, _path31, _path32, _circle2, _path33, _path34, _circle3, _path35, _path36, _circle4, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _circle5, _path229, _path230, _circle6, _path231, _path232, _circle7, _path233, _path234, _circle8, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _path244, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _path245, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _path246, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _path247, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _path248, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _path249, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _circle92, _circle93, _circle94, _circle95, _path250, _circle96, _circle97, _circle98, _circle99, _circle100, _circle101, _circle102, _circle103, _circle104, _circle105, _circle106, _circle107, _circle108, _circle109, _circle110, _circle111, _circle112, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _circle113, _path267, _circle114, _path268, _circle115, _path269, _circle116, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _circle117, _path279, _circle118, _path280, _circle119, _path281, _circle120, _path282, _circle121, _path283, _circle122, _path284, _circle123, _path285, _circle124, _path286, _circle125, _path287, _circle126, _path288, _circle127, _path289, _circle128, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _circle129, _circle130, _circle131, _path323, _circle132, _circle133, _circle134, _path324, _circle135, _circle136, _circle137, _path325, _circle138, _circle139, _circle140, _path326, _circle141, _path327, _circle142, _circle143, _path328, _circle144, _path329, _circle145, _circle146, _path330, _circle147, _path331, _circle148, _circle149, _path332, _circle150, _path333, _circle151, _circle152, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387;

var _excluded = ["children"],
    _excluded2 = ["children"],
    _excluded3 = ["children"],
    _excluded4 = ["children"],
    _excluded5 = ["children"],
    _excluded6 = ["children"],
    _excluded7 = ["children"],
    _excluded8 = ["children"],
    _excluded9 = ["children"],
    _excluded10 = ["children"],
    _excluded11 = ["children"],
    _excluded12 = ["children"],
    _excluded13 = ["children"],
    _excluded14 = ["children"],
    _excluded15 = ["children"],
    _excluded16 = ["children"],
    _excluded17 = ["children"],
    _excluded18 = ["children"],
    _excluded19 = ["children"],
    _excluded20 = ["children"],
    _excluded21 = ["children"],
    _excluded22 = ["children"],
    _excluded23 = ["children"],
    _excluded24 = ["children"],
    _excluded25 = ["children"],
    _excluded26 = ["children"],
    _excluded27 = ["children"],
    _excluded28 = ["children"],
    _excluded29 = ["children"],
    _excluded30 = ["children"],
    _excluded31 = ["children"],
    _excluded32 = ["children"],
    _excluded33 = ["children"],
    _excluded34 = ["children"],
    _excluded35 = ["children"],
    _excluded36 = ["children"],
    _excluded37 = ["children"],
    _excluded38 = ["children"],
    _excluded39 = ["children"],
    _excluded40 = ["children"],
    _excluded41 = ["children"],
    _excluded42 = ["children"],
    _excluded43 = ["children"],
    _excluded44 = ["children"],
    _excluded45 = ["children"],
    _excluded46 = ["children"],
    _excluded47 = ["children"],
    _excluded48 = ["children"],
    _excluded49 = ["children"],
    _excluded50 = ["children"],
    _excluded51 = ["children"],
    _excluded52 = ["children"],
    _excluded53 = ["children"],
    _excluded54 = ["children"],
    _excluded55 = ["children"],
    _excluded56 = ["children"],
    _excluded57 = ["children"],
    _excluded58 = ["children"],
    _excluded59 = ["children"],
    _excluded60 = ["children"],
    _excluded61 = ["children"],
    _excluded62 = ["children"],
    _excluded63 = ["children"],
    _excluded64 = ["children"],
    _excluded65 = ["children"],
    _excluded66 = ["children"],
    _excluded67 = ["children"],
    _excluded68 = ["children"],
    _excluded69 = ["children"],
    _excluded70 = ["children"],
    _excluded71 = ["children"],
    _excluded72 = ["children"],
    _excluded73 = ["children"],
    _excluded74 = ["children"],
    _excluded75 = ["children"],
    _excluded76 = ["children"],
    _excluded77 = ["children"],
    _excluded78 = ["children"],
    _excluded79 = ["children"],
    _excluded80 = ["children"],
    _excluded81 = ["children"],
    _excluded82 = ["children"],
    _excluded83 = ["children"],
    _excluded84 = ["children"],
    _excluded85 = ["children"],
    _excluded86 = ["children"],
    _excluded87 = ["children"],
    _excluded88 = ["children"],
    _excluded89 = ["children"],
    _excluded90 = ["children"],
    _excluded91 = ["children"],
    _excluded92 = ["children"],
    _excluded93 = ["children"],
    _excluded94 = ["children"],
    _excluded95 = ["children"],
    _excluded96 = ["children"],
    _excluded97 = ["children"],
    _excluded98 = ["children"],
    _excluded99 = ["children"],
    _excluded100 = ["children"],
    _excluded101 = ["children"],
    _excluded102 = ["children"],
    _excluded103 = ["children"],
    _excluded104 = ["children"],
    _excluded105 = ["children"],
    _excluded106 = ["children"],
    _excluded107 = ["children"],
    _excluded108 = ["children"],
    _excluded109 = ["children"],
    _excluded110 = ["children"],
    _excluded111 = ["children"],
    _excluded112 = ["children"],
    _excluded113 = ["children"],
    _excluded114 = ["children"],
    _excluded115 = ["children"],
    _excluded116 = ["children"],
    _excluded117 = ["children"],
    _excluded118 = ["children"],
    _excluded119 = ["children"],
    _excluded120 = ["children"],
    _excluded121 = ["children"],
    _excluded122 = ["children"],
    _excluded123 = ["children"],
    _excluded124 = ["children"],
    _excluded125 = ["children"],
    _excluded126 = ["children"],
    _excluded127 = ["children"],
    _excluded128 = ["children"],
    _excluded129 = ["children"],
    _excluded130 = ["children"],
    _excluded131 = ["children"],
    _excluded132 = ["children"],
    _excluded133 = ["children"],
    _excluded134 = ["children"],
    _excluded135 = ["children"],
    _excluded136 = ["children"],
    _excluded137 = ["children"],
    _excluded138 = ["children"],
    _excluded139 = ["children"],
    _excluded140 = ["children"],
    _excluded141 = ["children"],
    _excluded142 = ["children"],
    _excluded143 = ["children"],
    _excluded144 = ["children"],
    _excluded145 = ["children"],
    _excluded146 = ["children"],
    _excluded147 = ["children"],
    _excluded148 = ["children"],
    _excluded149 = ["children"],
    _excluded150 = ["children"],
    _excluded151 = ["children"],
    _excluded152 = ["children"],
    _excluded153 = ["children"],
    _excluded154 = ["children"],
    _excluded155 = ["children"],
    _excluded156 = ["children"],
    _excluded157 = ["children"],
    _excluded158 = ["children"],
    _excluded159 = ["children"],
    _excluded160 = ["children"],
    _excluded161 = ["children"],
    _excluded162 = ["children"],
    _excluded163 = ["children"],
    _excluded164 = ["children"],
    _excluded165 = ["children"],
    _excluded166 = ["children"],
    _excluded167 = ["children"],
    _excluded168 = ["children"],
    _excluded169 = ["children"],
    _excluded170 = ["children"],
    _excluded171 = ["children"],
    _excluded172 = ["children"],
    _excluded173 = ["children"],
    _excluded174 = ["children"],
    _excluded175 = ["children"],
    _excluded176 = ["children"],
    _excluded177 = ["children"],
    _excluded178 = ["children"],
    _excluded179 = ["children"],
    _excluded180 = ["children"],
    _excluded181 = ["children"],
    _excluded182 = ["children"],
    _excluded183 = ["children"],
    _excluded184 = ["children"],
    _excluded185 = ["children"],
    _excluded186 = ["children"],
    _excluded187 = ["children"],
    _excluded188 = ["children"],
    _excluded189 = ["children"],
    _excluded190 = ["children"],
    _excluded191 = ["children"],
    _excluded192 = ["children"],
    _excluded193 = ["children"],
    _excluded194 = ["children"],
    _excluded195 = ["children"],
    _excluded196 = ["children"],
    _excluded197 = ["children"],
    _excluded198 = ["children"],
    _excluded199 = ["children"],
    _excluded200 = ["children"],
    _excluded201 = ["children"],
    _excluded202 = ["children"],
    _excluded203 = ["children"],
    _excluded204 = ["children"],
    _excluded205 = ["children"],
    _excluded206 = ["children"],
    _excluded207 = ["children"],
    _excluded208 = ["children"],
    _excluded209 = ["children"],
    _excluded210 = ["children"],
    _excluded211 = ["children"],
    _excluded212 = ["children"],
    _excluded213 = ["children"],
    _excluded214 = ["children"],
    _excluded215 = ["children"],
    _excluded216 = ["children"],
    _excluded217 = ["children"],
    _excluded218 = ["children"],
    _excluded219 = ["children"],
    _excluded220 = ["children"],
    _excluded221 = ["children"],
    _excluded222 = ["children"],
    _excluded223 = ["children"],
    _excluded224 = ["children"],
    _excluded225 = ["children"],
    _excluded226 = ["children"],
    _excluded227 = ["children"],
    _excluded228 = ["children"],
    _excluded229 = ["children"],
    _excluded230 = ["children"],
    _excluded231 = ["children"],
    _excluded232 = ["children"],
    _excluded233 = ["children"],
    _excluded234 = ["children"],
    _excluded235 = ["children"],
    _excluded236 = ["children"],
    _excluded237 = ["children"],
    _excluded238 = ["children"],
    _excluded239 = ["children"],
    _excluded240 = ["children"],
    _excluded241 = ["children"],
    _excluded242 = ["children"],
    _excluded243 = ["children"],
    _excluded244 = ["children"],
    _excluded245 = ["children"],
    _excluded246 = ["children"],
    _excluded247 = ["children"],
    _excluded248 = ["children"],
    _excluded249 = ["children"],
    _excluded250 = ["children"];
var MobileDownload24 = /*#__PURE__*/React.forwardRef(function MobileDownload24(_ref, ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 25L26.586 23.586 24 26.172 24 18 22 18 22 26.172 19.414 23.586 18 25 23 30 28 25z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10,28V10H22v5h2V6a2.0023,2.0023,0,0,0-2-2H10A2.002,2.002,0,0,0,8,6V28a2.0023,2.0023,0,0,0,2,2h6V28ZM10,6H22l0,2H10Z"
  })), children);
});
var MobileDownload20 = /*#__PURE__*/React.forwardRef(function MobileDownload20(_ref2, ref) {
  var children = _ref2.children,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 25L26.586 23.586 24 26.172 24 18 22 18 22 26.172 19.414 23.586 18 25 23 30 28 25z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10,28V10H22v5h2V6a2.0023,2.0023,0,0,0-2-2H10A2.002,2.002,0,0,0,8,6V28a2.0023,2.0023,0,0,0,2,2h6V28ZM10,6H22l0,2H10Z"
  })), children);
});
var MobileDownload16 = /*#__PURE__*/React.forwardRef(function MobileDownload16(_ref3, ref) {
  var children = _ref3.children,
      rest = _objectWithoutProperties(_ref3, _excluded3);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28 25L26.586 23.586 24 26.172 24 18 22 18 22 26.172 19.414 23.586 18 25 23 30 28 25z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10,28V10H22v5h2V6a2.0023,2.0023,0,0,0-2-2H10A2.002,2.002,0,0,0,8,6V28a2.0023,2.0023,0,0,0,2,2h6V28ZM10,6H22l0,2H10Z"
  })), children);
});
var MobileEvent32 = /*#__PURE__*/React.forwardRef(function MobileEvent32(_ref4, ref) {
  var children = _ref4.children,
      rest = _objectWithoutProperties(_ref4, _excluded4);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3803 28h-6.7625l3.3822-6.7642 3.3803 6.7642zm-3.3803-10c-.3915 0-.7305.2251-.8947.5527l-5 10c-.0674.1348-.1053.2866-.1053.4473 0 .5522.4477 1 1 1h10c.5523 0 1-.4478 1-1 0-.1382-.028-.2695-.0786-.3892l-5.0269-10.0581c-.1641-.3276-.5031-.5527-.8946-.5527h0zM15 28h-6V8h14v7h2V4c0-1.103-.8975-2-2-2h-14c-1.103 0-2 .897-2 2v24c0 1.1025.897 2 2 2h6v-2zM9 4h14v2h-14v-2z"
  })), children);
});
var MobileEvent24 = /*#__PURE__*/React.forwardRef(function MobileEvent24(_ref5, ref) {
  var children = _ref5.children,
      rest = _objectWithoutProperties(_ref5, _excluded5);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3803 28h-6.7625l3.3822-6.7642 3.3803 6.7642zm-3.3803-10c-.3915 0-.7305.2251-.8947.5527l-5 10c-.0674.1348-.1053.2866-.1053.4473 0 .5522.4477 1 1 1h10c.5523 0 1-.4478 1-1 0-.1382-.028-.2695-.0786-.3892l-5.0269-10.0581c-.1641-.3276-.5031-.5527-.8946-.5527h0zM15 28h-6V8h14v7h2V4c0-1.103-.8975-2-2-2h-14c-1.103 0-2 .897-2 2v24c0 1.1025.897 2 2 2h6v-2zM9 4h14v2h-14v-2z"
  })), children);
});
var MobileEvent20 = /*#__PURE__*/React.forwardRef(function MobileEvent20(_ref6, ref) {
  var children = _ref6.children,
      rest = _objectWithoutProperties(_ref6, _excluded6);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3803 28h-6.7625l3.3822-6.7642 3.3803 6.7642zm-3.3803-10c-.3915 0-.7305.2251-.8947.5527l-5 10c-.0674.1348-.1053.2866-.1053.4473 0 .5522.4477 1 1 1h10c.5523 0 1-.4478 1-1 0-.1382-.028-.2695-.0786-.3892l-5.0269-10.0581c-.1641-.3276-.5031-.5527-.8946-.5527h0zM15 28h-6V8h14v7h2V4c0-1.103-.8975-2-2-2h-14c-1.103 0-2 .897-2 2v24c0 1.1025.897 2 2 2h6v-2zM9 4h14v2h-14v-2z"
  })), children);
});
var MobileEvent16 = /*#__PURE__*/React.forwardRef(function MobileEvent16(_ref7, ref) {
  var children = _ref7.children,
      rest = _objectWithoutProperties(_ref7, _excluded7);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3803 28h-6.7625l3.3822-6.7642 3.3803 6.7642zm-3.3803-10c-.3915 0-.7305.2251-.8947.5527l-5 10c-.0674.1348-.1053.2866-.1053.4473 0 .5522.4477 1 1 1h10c.5523 0 1-.4478 1-1 0-.1382-.028-.2695-.0786-.3892l-5.0269-10.0581c-.1641-.3276-.5031-.5527-.8946-.5527h0zM15 28h-6V8h14v7h2V4c0-1.103-.8975-2-2-2h-14c-1.103 0-2 .897-2 2v24c0 1.1025.897 2 2 2h6v-2zM9 4h14v2h-14v-2z"
  })), children);
});
var MobileLandscape32 = /*#__PURE__*/React.forwardRef(function MobileLandscape32(_ref8, ref) {
  var children = _ref8.children,
      rest = _objectWithoutProperties(_ref8, _excluded8);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3,10V22a2.002,2.002,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V10a2.0027,2.0027,0,0,0-2-2H5A2.0023,2.0023,0,0,0,3,10Zm2,0,2,0V22H5ZM27,22H9V10H27Z"
  })), children);
});
var MobileLandscape24 = /*#__PURE__*/React.forwardRef(function MobileLandscape24(_ref9, ref) {
  var children = _ref9.children,
      rest = _objectWithoutProperties(_ref9, _excluded9);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3,10V22a2.002,2.002,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V10a2.0027,2.0027,0,0,0-2-2H5A2.0023,2.0023,0,0,0,3,10Zm2,0,2,0V22H5ZM27,22H9V10H27Z"
  })), children);
});
var MobileLandscape20 = /*#__PURE__*/React.forwardRef(function MobileLandscape20(_ref10, ref) {
  var children = _ref10.children,
      rest = _objectWithoutProperties(_ref10, _excluded10);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3,10V22a2.002,2.002,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V10a2.0027,2.0027,0,0,0-2-2H5A2.0023,2.0023,0,0,0,3,10Zm2,0,2,0V22H5ZM27,22H9V10H27Z"
  })), children);
});
var MobileLandscape16 = /*#__PURE__*/React.forwardRef(function MobileLandscape16(_ref11, ref) {
  var children = _ref11.children,
      rest = _objectWithoutProperties(_ref11, _excluded11);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M3,10V22a2.002,2.002,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V10a2.0027,2.0027,0,0,0-2-2H5A2.0023,2.0023,0,0,0,3,10Zm2,0,2,0V22H5ZM27,22H9V10H27Z"
  })), children);
});
var MobileRequest32 = /*#__PURE__*/React.forwardRef(function MobileRequest32(_ref12, ref) {
  var children = _ref12.children,
      rest = _objectWithoutProperties(_ref12, _excluded12);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m30,28c0-2.9668-2.167-5.4312-5-5.9097v-1.0903h1v-2h-4v2h1v1.0903c-2.833.4785-5,2.9429-5,5.9097h-1v2h14v-2h-1Zm-10,0c0-2.2056,1.7944-4,4-4s4,1.7944,4,4h-8Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m14,28h-5V8h14v8h2V4c0-1.103-.8975-2-2-2h-14c-1.103,0-2,.897-2,2v24c0,1.1025.897,2,2,2h5v-2ZM9,4h14v2h-14v-2Z"
  })), children);
});
var MobileRequest24 = /*#__PURE__*/React.forwardRef(function MobileRequest24(_ref13, ref) {
  var children = _ref13.children,
      rest = _objectWithoutProperties(_ref13, _excluded13);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m30,28c0-2.9668-2.167-5.4312-5-5.9097v-1.0903h1v-2h-4v2h1v1.0903c-2.833.4785-5,2.9429-5,5.9097h-1v2h14v-2h-1Zm-10,0c0-2.2056,1.7944-4,4-4s4,1.7944,4,4h-8Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m14,28h-5V8h14v8h2V4c0-1.103-.8975-2-2-2h-14c-1.103,0-2,.897-2,2v24c0,1.1025.897,2,2,2h5v-2ZM9,4h14v2h-14v-2Z"
  })), children);
});
var MobileRequest20 = /*#__PURE__*/React.forwardRef(function MobileRequest20(_ref14, ref) {
  var children = _ref14.children,
      rest = _objectWithoutProperties(_ref14, _excluded14);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m30,28c0-2.9668-2.167-5.4312-5-5.9097v-1.0903h1v-2h-4v2h1v1.0903c-2.833.4785-5,2.9429-5,5.9097h-1v2h14v-2h-1Zm-10,0c0-2.2056,1.7944-4,4-4s4,1.7944,4,4h-8Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m14,28h-5V8h14v8h2V4c0-1.103-.8975-2-2-2h-14c-1.103,0-2,.897-2,2v24c0,1.1025.897,2,2,2h5v-2ZM9,4h14v2h-14v-2Z"
  })), children);
});
var MobileRequest16 = /*#__PURE__*/React.forwardRef(function MobileRequest16(_ref15, ref) {
  var children = _ref15.children,
      rest = _objectWithoutProperties(_ref15, _excluded15);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m30,28c0-2.9668-2.167-5.4312-5-5.9097v-1.0903h1v-2h-4v2h1v1.0903c-2.833.4785-5,2.9429-5,5.9097h-1v2h14v-2h-1Zm-10,0c0-2.2056,1.7944-4,4-4s4,1.7944,4,4h-8Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m14,28h-5V8h14v8h2V4c0-1.103-.8975-2-2-2h-14c-1.103,0-2,.897-2,2v24c0,1.1025.897,2,2,2h5v-2ZM9,4h14v2h-14v-2Z"
  })), children);
});
var MobileSession32 = /*#__PURE__*/React.forwardRef(function MobileSession32(_ref16, ref) {
  var children = _ref16.children,
      rest = _objectWithoutProperties(_ref16, _excluded16);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m24,18c-3.3083,0-6,2.6914-6,6s2.6917,6,6,6,6-2.6914,6-6-2.6917-6-6-6Zm0,10c-2.2056,0-4-1.7944-4-4s1.7944-4,4-4v4h4c0,2.2056-1.7944,4-4,4Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m16,28h-7V8h14v7h2V4c0-1.103-.8975-2-2-2h-14c-1.103,0-2,.897-2,2v24c0,1.1025.897,2,2,2h7v-2ZM9,4h14v2h-14v-2Z"
  })), children);
});
var MobileSession24 = /*#__PURE__*/React.forwardRef(function MobileSession24(_ref17, ref) {
  var children = _ref17.children,
      rest = _objectWithoutProperties(_ref17, _excluded17);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m24,18c-3.3083,0-6,2.6914-6,6s2.6917,6,6,6,6-2.6914,6-6-2.6917-6-6-6Zm0,10c-2.2056,0-4-1.7944-4-4s1.7944-4,4-4v4h4c0,2.2056-1.7944,4-4,4Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m16,28h-7V8h14v7h2V4c0-1.103-.8975-2-2-2h-14c-1.103,0-2,.897-2,2v24c0,1.1025.897,2,2,2h7v-2ZM9,4h14v2h-14v-2Z"
  })), children);
});
var MobileSession20 = /*#__PURE__*/React.forwardRef(function MobileSession20(_ref18, ref) {
  var children = _ref18.children,
      rest = _objectWithoutProperties(_ref18, _excluded18);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m24,18c-3.3083,0-6,2.6914-6,6s2.6917,6,6,6,6-2.6914,6-6-2.6917-6-6-6Zm0,10c-2.2056,0-4-1.7944-4-4s1.7944-4,4-4v4h4c0,2.2056-1.7944,4-4,4Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m16,28h-7V8h14v7h2V4c0-1.103-.8975-2-2-2h-14c-1.103,0-2,.897-2,2v24c0,1.1025.897,2,2,2h7v-2ZM9,4h14v2h-14v-2Z"
  })), children);
});
var MobileSession16 = /*#__PURE__*/React.forwardRef(function MobileSession16(_ref19, ref) {
  var children = _ref19.children,
      rest = _objectWithoutProperties(_ref19, _excluded19);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m24,18c-3.3083,0-6,2.6914-6,6s2.6917,6,6,6,6-2.6914,6-6-2.6917-6-6-6Zm0,10c-2.2056,0-4-1.7944-4-4s1.7944-4,4-4v4h4c0,2.2056-1.7944,4-4,4Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m16,28h-7V8h14v7h2V4c0-1.103-.8975-2-2-2h-14c-1.103,0-2,.897-2,2v24c0,1.1025.897,2,2,2h7v-2ZM9,4h14v2h-14v-2Z"
  })), children);
});
var MobileView32 = /*#__PURE__*/React.forwardRef(function MobileView32(_ref20, ref) {
  var children = _ref20.children,
      rest = _objectWithoutProperties(_ref20, _excluded20);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "24",
    r: "2"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m30.7769,23.4785c-1.4229-3.3287-4.4761-5.4785-7.7769-5.4785s-6.3538,2.1499-7.7769,5.4785l-.2231.5215.2231.5215c1.4231,3.3287,4.4761,5.4785,7.7769,5.4785s6.354-2.1499,7.7769-5.4785l.2231-.5215-.2231-.5215Zm-7.7769,4.5215c-2.2056,0-4-1.7944-4-4s1.7944-4,4-4,4,1.7944,4,4-1.7944,4-4,4Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m14,28h-5V8h14v7h2V4c0-1.103-.8975-2-2-2h-14c-1.103,0-2,.897-2,2v24c0,1.1025.897,2,2,2h5v-2ZM9,4h14v2h-14v-2Z"
  })), children);
});
var MobileView24 = /*#__PURE__*/React.forwardRef(function MobileView24(_ref21, ref) {
  var children = _ref21.children,
      rest = _objectWithoutProperties(_ref21, _excluded21);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "24",
    r: "2"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m30.7769,23.4785c-1.4229-3.3287-4.4761-5.4785-7.7769-5.4785s-6.3538,2.1499-7.7769,5.4785l-.2231.5215.2231.5215c1.4231,3.3287,4.4761,5.4785,7.7769,5.4785s6.354-2.1499,7.7769-5.4785l.2231-.5215-.2231-.5215Zm-7.7769,4.5215c-2.2056,0-4-1.7944-4-4s1.7944-4,4-4,4,1.7944,4,4-1.7944,4-4,4Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m14,28h-5V8h14v7h2V4c0-1.103-.8975-2-2-2h-14c-1.103,0-2,.897-2,2v24c0,1.1025.897,2,2,2h5v-2ZM9,4h14v2h-14v-2Z"
  })), children);
});
var MobileView20 = /*#__PURE__*/React.forwardRef(function MobileView20(_ref22, ref) {
  var children = _ref22.children,
      rest = _objectWithoutProperties(_ref22, _excluded22);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "24",
    r: "2"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m30.7769,23.4785c-1.4229-3.3287-4.4761-5.4785-7.7769-5.4785s-6.3538,2.1499-7.7769,5.4785l-.2231.5215.2231.5215c1.4231,3.3287,4.4761,5.4785,7.7769,5.4785s6.354-2.1499,7.7769-5.4785l.2231-.5215-.2231-.5215Zm-7.7769,4.5215c-2.2056,0-4-1.7944-4-4s1.7944-4,4-4,4,1.7944,4,4-1.7944,4-4,4Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m14,28h-5V8h14v7h2V4c0-1.103-.8975-2-2-2h-14c-1.103,0-2,.897-2,2v24c0,1.1025.897,2,2,2h5v-2ZM9,4h14v2h-14v-2Z"
  })), children);
});
var MobileView16 = /*#__PURE__*/React.forwardRef(function MobileView16(_ref23, ref) {
  var children = _ref23.children,
      rest = _objectWithoutProperties(_ref23, _excluded23);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "24",
    r: "2"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m30.7769,23.4785c-1.4229-3.3287-4.4761-5.4785-7.7769-5.4785s-6.3538,2.1499-7.7769,5.4785l-.2231.5215.2231.5215c1.4231,3.3287,4.4761,5.4785,7.7769,5.4785s6.354-2.1499,7.7769-5.4785l.2231-.5215-.2231-.5215Zm-7.7769,4.5215c-2.2056,0-4-1.7944-4-4s1.7944-4,4-4,4,1.7944,4,4-1.7944,4-4,4Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m14,28h-5V8h14v7h2V4c0-1.103-.8975-2-2-2h-14c-1.103,0-2,.897-2,2v24c0,1.1025.897,2,2,2h5v-2ZM9,4h14v2h-14v-2Z"
  })), children);
});
var MobileViewOrientation32 = /*#__PURE__*/React.forwardRef(function MobileViewOrientation32(_ref24, ref) {
  var children = _ref24.children,
      rest = _objectWithoutProperties(_ref24, _excluded24);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m28,12h-8v2h8v14h-8v2h8c1.1025,0,2-.897,2-2v-14c0-1.1025-.8975-2-2-2Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m19,16l-1.4141,1.4141,2.5859,2.5859h-4.1719c-2.2056,0-4-1.7944-4-4v-2h-2v2c0,3.3086,2.6917,6,6,6h4.1719l-2.5859,2.5859,1.4141,1.4141,5-5-5-5Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m12,28h-6V8h16v-4c0-1.103-.8975-2-2-2H6c-1.103,0-2,.897-2,2v24c0,1.1025.897,2,2,2h6v-2ZM6,4h14v2H6v-2Z"
  })), children);
});
var MobileViewOrientation24 = /*#__PURE__*/React.forwardRef(function MobileViewOrientation24(_ref25, ref) {
  var children = _ref25.children,
      rest = _objectWithoutProperties(_ref25, _excluded25);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m28,12h-8v2h8v14h-8v2h8c1.1025,0,2-.897,2-2v-14c0-1.1025-.8975-2-2-2Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m19,16l-1.4141,1.4141,2.5859,2.5859h-4.1719c-2.2056,0-4-1.7944-4-4v-2h-2v2c0,3.3086,2.6917,6,6,6h4.1719l-2.5859,2.5859,1.4141,1.4141,5-5-5-5Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m12,28h-6V8h16v-4c0-1.103-.8975-2-2-2H6c-1.103,0-2,.897-2,2v24c0,1.1025.897,2,2,2h6v-2ZM6,4h14v2H6v-2Z"
  })), children);
});
var MobileViewOrientation20 = /*#__PURE__*/React.forwardRef(function MobileViewOrientation20(_ref26, ref) {
  var children = _ref26.children,
      rest = _objectWithoutProperties(_ref26, _excluded26);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m28,12h-8v2h8v14h-8v2h8c1.1025,0,2-.897,2-2v-14c0-1.1025-.8975-2-2-2Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m19,16l-1.4141,1.4141,2.5859,2.5859h-4.1719c-2.2056,0-4-1.7944-4-4v-2h-2v2c0,3.3086,2.6917,6,6,6h4.1719l-2.5859,2.5859,1.4141,1.4141,5-5-5-5Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m12,28h-6V8h16v-4c0-1.103-.8975-2-2-2H6c-1.103,0-2,.897-2,2v24c0,1.1025.897,2,2,2h6v-2ZM6,4h14v2H6v-2Z"
  })), children);
});
var MobileViewOrientation16 = /*#__PURE__*/React.forwardRef(function MobileViewOrientation16(_ref27, ref) {
  var children = _ref27.children,
      rest = _objectWithoutProperties(_ref27, _excluded27);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m28,12h-8v2h8v14h-8v2h8c1.1025,0,2-.897,2-2v-14c0-1.1025-.8975-2-2-2Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m19,16l-1.4141,1.4141,2.5859,2.5859h-4.1719c-2.2056,0-4-1.7944-4-4v-2h-2v2c0,3.3086,2.6917,6,6,6h4.1719l-2.5859,2.5859,1.4141,1.4141,5-5-5-5Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m12,28h-6V8h16v-4c0-1.103-.8975-2-2-2H6c-1.103,0-2,.897-2,2v24c0,1.1025.897,2,2,2h6v-2ZM6,4h14v2H6v-2Z"
  })), children);
});
var MobilityServices32 = /*#__PURE__*/React.forwardRef(function MobilityServices32(_ref28, ref) {
  var children = _ref28.children,
      rest = _objectWithoutProperties(_ref28, _excluded28);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3379 19.9336l-7.7324-2.7783L18.374 13.0967A2.99 2.99 0 0016.0537 12H8.0576a2.9982 2.9982 0 00-2.48 1.3115L2.8662 17.2949A4.9884 4.9884 0 002 20.1074V26a1 1 0 001 1H5.1421a3.9806 3.9806 0 007.7158 0h6.2842a3.9806 3.9806 0 007.7158 0H29a1 1 0 001-1V20.875A1 1 0 0029.3379 19.9336zM9 28a2 2 0 112-2A2.0027 2.0027 0 019 28zm14 0a2 2 0 112-2A2.0025 2.0025 0 0123 28zm5-3H26.8579a3.9806 3.9806 0 00-7.7158 0H12.8579a3.9806 3.9806 0 00-7.7158 0H4V20.1074A2.9977 2.9977 0 014.52 18.4189l2.711-3.9814A.9992.9992 0 018.0576 14h7.9961a.9928.9928 0 01.7647.3545l3.3994 4.2685a1.0007 1.0007 0 00.4443.3184L28 21.5781zM28 2H24a2.0023 2.0023 0 00-2 2v8a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V4A2.0023 2.0023 0 0028 2zm0 2V6H24V4zm-4 8V8h4v4z"
  })), children);
});
var MobilityServices24 = /*#__PURE__*/React.forwardRef(function MobilityServices24(_ref29, ref) {
  var children = _ref29.children,
      rest = _objectWithoutProperties(_ref29, _excluded29);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3379 19.9336l-7.7324-2.7783L18.374 13.0967A2.99 2.99 0 0016.0537 12H8.0576a2.9982 2.9982 0 00-2.48 1.3115L2.8662 17.2949A4.9884 4.9884 0 002 20.1074V26a1 1 0 001 1H5.1421a3.9806 3.9806 0 007.7158 0h6.2842a3.9806 3.9806 0 007.7158 0H29a1 1 0 001-1V20.875A1 1 0 0029.3379 19.9336zM9 28a2 2 0 112-2A2.0027 2.0027 0 019 28zm14 0a2 2 0 112-2A2.0025 2.0025 0 0123 28zm5-3H26.8579a3.9806 3.9806 0 00-7.7158 0H12.8579a3.9806 3.9806 0 00-7.7158 0H4V20.1074A2.9977 2.9977 0 014.52 18.4189l2.711-3.9814A.9992.9992 0 018.0576 14h7.9961a.9928.9928 0 01.7647.3545l3.3994 4.2685a1.0007 1.0007 0 00.4443.3184L28 21.5781zM28 2H24a2.0023 2.0023 0 00-2 2v8a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V4A2.0023 2.0023 0 0028 2zm0 2V6H24V4zm-4 8V8h4v4z"
  })), children);
});
var MobilityServices20 = /*#__PURE__*/React.forwardRef(function MobilityServices20(_ref30, ref) {
  var children = _ref30.children,
      rest = _objectWithoutProperties(_ref30, _excluded30);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3379 19.9336l-7.7324-2.7783L18.374 13.0967A2.99 2.99 0 0016.0537 12H8.0576a2.9982 2.9982 0 00-2.48 1.3115L2.8662 17.2949A4.9884 4.9884 0 002 20.1074V26a1 1 0 001 1H5.1421a3.9806 3.9806 0 007.7158 0h6.2842a3.9806 3.9806 0 007.7158 0H29a1 1 0 001-1V20.875A1 1 0 0029.3379 19.9336zM9 28a2 2 0 112-2A2.0027 2.0027 0 019 28zm14 0a2 2 0 112-2A2.0025 2.0025 0 0123 28zm5-3H26.8579a3.9806 3.9806 0 00-7.7158 0H12.8579a3.9806 3.9806 0 00-7.7158 0H4V20.1074A2.9977 2.9977 0 014.52 18.4189l2.711-3.9814A.9992.9992 0 018.0576 14h7.9961a.9928.9928 0 01.7647.3545l3.3994 4.2685a1.0007 1.0007 0 00.4443.3184L28 21.5781zM28 2H24a2.0023 2.0023 0 00-2 2v8a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V4A2.0023 2.0023 0 0028 2zm0 2V6H24V4zm-4 8V8h4v4z"
  })), children);
});
var MobilityServices16 = /*#__PURE__*/React.forwardRef(function MobilityServices16(_ref31, ref) {
  var children = _ref31.children,
      rest = _objectWithoutProperties(_ref31, _excluded31);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3379 19.9336l-7.7324-2.7783L18.374 13.0967A2.99 2.99 0 0016.0537 12H8.0576a2.9982 2.9982 0 00-2.48 1.3115L2.8662 17.2949A4.9884 4.9884 0 002 20.1074V26a1 1 0 001 1H5.1421a3.9806 3.9806 0 007.7158 0h6.2842a3.9806 3.9806 0 007.7158 0H29a1 1 0 001-1V20.875A1 1 0 0029.3379 19.9336zM9 28a2 2 0 112-2A2.0027 2.0027 0 019 28zm14 0a2 2 0 112-2A2.0025 2.0025 0 0123 28zm5-3H26.8579a3.9806 3.9806 0 00-7.7158 0H12.8579a3.9806 3.9806 0 00-7.7158 0H4V20.1074A2.9977 2.9977 0 014.52 18.4189l2.711-3.9814A.9992.9992 0 018.0576 14h7.9961a.9928.9928 0 01.7647.3545l3.3994 4.2685a1.0007 1.0007 0 00.4443.3184L28 21.5781zM28 2H24a2.0023 2.0023 0 00-2 2v8a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V4A2.0023 2.0023 0 0028 2zm0 2V6H24V4zm-4 8V8h4v4z"
  })), children);
});
var Model32 = /*#__PURE__*/React.forwardRef(function Model32(_ref32, ref) {
  var children = _ref32.children,
      rest = _objectWithoutProperties(_ref32, _excluded32);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,4H8.5L1.7158,13.0454,16,29.5269,30.2842,13.0454ZM27,12H21.5543l-3.75-6H22.5ZM10.3021,14l3.7536,10.23L5.19,14Zm2.13,0H19.568l-3.569,9.7212Zm.3725-2L16,6.8867,19.1957,12Zm8.8935,2H26.81L17.9427,24.2314ZM9.5,6h4.6957l-3.75,6H5Z"
  })), children);
});
var Model24 = /*#__PURE__*/React.forwardRef(function Model24(_ref33, ref) {
  var children = _ref33.children,
      rest = _objectWithoutProperties(_ref33, _excluded33);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,4H8.5L1.7158,13.0454,16,29.5269,30.2842,13.0454ZM27,12H21.5543l-3.75-6H22.5ZM10.3021,14l3.7536,10.23L5.19,14Zm2.13,0H19.568l-3.569,9.7212Zm.3725-2L16,6.8867,19.1957,12Zm8.8935,2H26.81L17.9427,24.2314ZM9.5,6h4.6957l-3.75,6H5Z"
  })), children);
});
var Model20 = /*#__PURE__*/React.forwardRef(function Model20(_ref34, ref) {
  var children = _ref34.children,
      rest = _objectWithoutProperties(_ref34, _excluded34);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,4H8.5L1.7158,13.0454,16,29.5269,30.2842,13.0454ZM27,12H21.5543l-3.75-6H22.5ZM10.3021,14l3.7536,10.23L5.19,14Zm2.13,0H19.568l-3.569,9.7212Zm.3725-2L16,6.8867,19.1957,12Zm8.8935,2H26.81L17.9427,24.2314ZM9.5,6h4.6957l-3.75,6H5Z"
  })), children);
});
var Model16 = /*#__PURE__*/React.forwardRef(function Model16(_ref35, ref) {
  var children = _ref35.children,
      rest = _objectWithoutProperties(_ref35, _excluded35);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,4H8.5L1.7158,13.0454,16,29.5269,30.2842,13.0454ZM27,12H21.5543l-3.75-6H22.5ZM10.3021,14l3.7536,10.23L5.19,14Zm2.13,0H19.568l-3.569,9.7212Zm.3725-2L16,6.8867,19.1957,12Zm8.8935,2H26.81L17.9427,24.2314ZM9.5,6h4.6957l-3.75,6H5Z"
  })), children);
});
var ModelAlt32 = /*#__PURE__*/React.forwardRef(function ModelAlt32(_ref36, ref) {
  var children = _ref36.children,
      rest = _objectWithoutProperties(_ref36, _excluded36);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4473,16.1055,23,13.3818V7a1,1,0,0,0-.5527-.8945l-6-3a1.0008,1.0008,0,0,0-.8946,0l-6,3A1,1,0,0,0,9,7v6.3818L3.5527,16.1055A1,1,0,0,0,3,17v7a1,1,0,0,0,.5527.8945l6,3a1.001,1.001,0,0,0,.8946,0L16,25.1182l5.5527,2.7763a1.001,1.001,0,0,0,.8946,0l6-3A1,1,0,0,0,29,24V17A1,1,0,0,0,28.4473,16.1055ZM21,13.3818l-4,2V10.6182l4-2ZM16,5.1182,19.7637,7,16,8.8818,12.2363,7Zm-5,3.5,4,2v4.7636l-4-2ZM9,25.3818l-4-2V18.6182l4,2Zm1-6.5L6.2363,17,10,15.1182,13.7637,17Zm1,1.7364,4-2v4.7636l-4,2Zm10,4.7636-4-2V18.6182l4,2Zm1-6.5L18.2363,17,22,15.1182,25.7637,17Zm5,4.5-4,2V20.6182l4-2Z"
  })), children);
});
var ModelAlt24 = /*#__PURE__*/React.forwardRef(function ModelAlt24(_ref37, ref) {
  var children = _ref37.children,
      rest = _objectWithoutProperties(_ref37, _excluded37);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4473,16.1055,23,13.3818V7a1,1,0,0,0-.5527-.8945l-6-3a1.0008,1.0008,0,0,0-.8946,0l-6,3A1,1,0,0,0,9,7v6.3818L3.5527,16.1055A1,1,0,0,0,3,17v7a1,1,0,0,0,.5527.8945l6,3a1.001,1.001,0,0,0,.8946,0L16,25.1182l5.5527,2.7763a1.001,1.001,0,0,0,.8946,0l6-3A1,1,0,0,0,29,24V17A1,1,0,0,0,28.4473,16.1055ZM21,13.3818l-4,2V10.6182l4-2ZM16,5.1182,19.7637,7,16,8.8818,12.2363,7Zm-5,3.5,4,2v4.7636l-4-2ZM9,25.3818l-4-2V18.6182l4,2Zm1-6.5L6.2363,17,10,15.1182,13.7637,17Zm1,1.7364,4-2v4.7636l-4,2Zm10,4.7636-4-2V18.6182l4,2Zm1-6.5L18.2363,17,22,15.1182,25.7637,17Zm5,4.5-4,2V20.6182l4-2Z"
  })), children);
});
var ModelAlt20 = /*#__PURE__*/React.forwardRef(function ModelAlt20(_ref38, ref) {
  var children = _ref38.children,
      rest = _objectWithoutProperties(_ref38, _excluded38);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4473,16.1055,23,13.3818V7a1,1,0,0,0-.5527-.8945l-6-3a1.0008,1.0008,0,0,0-.8946,0l-6,3A1,1,0,0,0,9,7v6.3818L3.5527,16.1055A1,1,0,0,0,3,17v7a1,1,0,0,0,.5527.8945l6,3a1.001,1.001,0,0,0,.8946,0L16,25.1182l5.5527,2.7763a1.001,1.001,0,0,0,.8946,0l6-3A1,1,0,0,0,29,24V17A1,1,0,0,0,28.4473,16.1055ZM21,13.3818l-4,2V10.6182l4-2ZM16,5.1182,19.7637,7,16,8.8818,12.2363,7Zm-5,3.5,4,2v4.7636l-4-2ZM9,25.3818l-4-2V18.6182l4,2Zm1-6.5L6.2363,17,10,15.1182,13.7637,17Zm1,1.7364,4-2v4.7636l-4,2Zm10,4.7636-4-2V18.6182l4,2Zm1-6.5L18.2363,17,22,15.1182,25.7637,17Zm5,4.5-4,2V20.6182l4-2Z"
  })), children);
});
var ModelAlt16 = /*#__PURE__*/React.forwardRef(function ModelAlt16(_ref39, ref) {
  var children = _ref39.children,
      rest = _objectWithoutProperties(_ref39, _excluded39);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4473,16.1055,23,13.3818V7a1,1,0,0,0-.5527-.8945l-6-3a1.0008,1.0008,0,0,0-.8946,0l-6,3A1,1,0,0,0,9,7v6.3818L3.5527,16.1055A1,1,0,0,0,3,17v7a1,1,0,0,0,.5527.8945l6,3a1.001,1.001,0,0,0,.8946,0L16,25.1182l5.5527,2.7763a1.001,1.001,0,0,0,.8946,0l6-3A1,1,0,0,0,29,24V17A1,1,0,0,0,28.4473,16.1055ZM21,13.3818l-4,2V10.6182l4-2ZM16,5.1182,19.7637,7,16,8.8818,12.2363,7Zm-5,3.5,4,2v4.7636l-4-2ZM9,25.3818l-4-2V18.6182l4,2Zm1-6.5L6.2363,17,10,15.1182,13.7637,17Zm1,1.7364,4-2v4.7636l-4,2Zm10,4.7636-4-2V18.6182l4,2Zm1-6.5L18.2363,17,22,15.1182,25.7637,17Zm5,4.5-4,2V20.6182l4-2Z"
  })), children);
});
var ModelReference32 = /*#__PURE__*/React.forwardRef(function ModelReference32(_ref40, ref) {
  var children = _ref40.children,
      rest = _objectWithoutProperties(_ref40, _excluded40);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,4H8.5L1.7158,13.0454,6.01,18l1.5114-1.31L5.19,14h5.2554L16,22.8867,21.5544,14H26.81L15.8125,26.6919,17.3242,28l12.96-14.9546ZM5,12,9.5,6h4.6958l-3.75,6ZM16,6.8867,19.1958,12H12.8042Zm0,12.2266L12.8044,14h6.3912ZM21.5542,12l-3.75-6H22.5L27,12Z"
  })), children);
});
var ModelReference24 = /*#__PURE__*/React.forwardRef(function ModelReference24(_ref41, ref) {
  var children = _ref41.children,
      rest = _objectWithoutProperties(_ref41, _excluded41);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,4H8.5L1.7158,13.0454,6.01,18l1.5114-1.31L5.19,14h5.2554L16,22.8867,21.5544,14H26.81L15.8125,26.6919,17.3242,28l12.96-14.9546ZM5,12,9.5,6h4.6958l-3.75,6ZM16,6.8867,19.1958,12H12.8042Zm0,12.2266L12.8044,14h6.3912ZM21.5542,12l-3.75-6H22.5L27,12Z"
  })), children);
});
var ModelReference20 = /*#__PURE__*/React.forwardRef(function ModelReference20(_ref42, ref) {
  var children = _ref42.children,
      rest = _objectWithoutProperties(_ref42, _excluded42);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,4H8.5L1.7158,13.0454,6.01,18l1.5114-1.31L5.19,14h5.2554L16,22.8867,21.5544,14H26.81L15.8125,26.6919,17.3242,28l12.96-14.9546ZM5,12,9.5,6h4.6958l-3.75,6ZM16,6.8867,19.1958,12H12.8042Zm0,12.2266L12.8044,14h6.3912ZM21.5542,12l-3.75-6H22.5L27,12Z"
  })), children);
});
var ModelReference16 = /*#__PURE__*/React.forwardRef(function ModelReference16(_ref43, ref) {
  var children = _ref43.children,
      rest = _objectWithoutProperties(_ref43, _excluded43);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,4H8.5L1.7158,13.0454,6.01,18l1.5114-1.31L5.19,14h5.2554L16,22.8867,21.5544,14H26.81L15.8125,26.6919,17.3242,28l12.96-14.9546ZM5,12,9.5,6h4.6958l-3.75,6ZM16,6.8867,19.1958,12H12.8042Zm0,12.2266L12.8044,14h6.3912ZM21.5542,12l-3.75-6H22.5L27,12Z"
  })), children);
});
var ModelTuned32 = /*#__PURE__*/React.forwardRef(function ModelTuned32(_ref44, ref) {
  var children = _ref44.children,
      rest = _objectWithoutProperties(_ref44, _excluded44);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M32 25c0-1.3018-.8384-2.4014-2-2.8159v-4.1841h-2v4.1846c-1.1616.4141-2 1.5137-2 2.8154s.8384 2.4014 2 2.8154v2.1846h2v-2.1841c1.1616-.4146 2-1.5142 2-2.8159zm-3 1c-.5515 0-1-.4487-1-1s.4485-1 1-1 1 .4487 1 1-.4485 1-1 1zM24 23c0-1.3018-.8384-2.4014-2-2.8159v-2.1841h-2v2.1846c-1.1616.4141-2 1.5137-2 2.8154s.8384 2.4014 2 2.8154v4.1846h2v-4.1841c1.1616-.4146 2-1.5142 2-2.8159zm-3 1c-.5515 0-1-.4487-1-1s.4485-1 1-1 1 .4487 1 1-.4485 1-1 1z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "m.7158,11.0454l12.96,14.9546,1.5117-1.3081L4.1902,12h5.2554s5.5544,8.8867,5.5544,8.8867l5.5544-8.8867h5.2554s-2.3315,2.6904-2.3315,2.6904l1.5115,1.3096,4.2944-4.9546-6.7842-9.0454H7.5S.7158,11.0454.7158,11.0454Zm19.8384-1.0454l-3.75-6h4.6958s4.5,6,4.5,6h-5.4458Zm-2.3584,0h-6.3916s3.1958-5.1133,3.1958-5.1133l3.1958,5.1133Zm-6.3914,2h6.3911s-3.1956,5.1133-3.1956,5.1133l-3.1956-5.1133Zm-7.8044-2l4.5-6h4.6958s-3.75,6-3.75,6h-5.4458Z"
  })), children);
});
var ModelTuned24 = /*#__PURE__*/React.forwardRef(function ModelTuned24(_ref45, ref) {
  var children = _ref45.children,
      rest = _objectWithoutProperties(_ref45, _excluded45);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M32 25c0-1.3018-.8384-2.4014-2-2.8159v-4.1841h-2v4.1846c-1.1616.4141-2 1.5137-2 2.8154s.8384 2.4014 2 2.8154v2.1846h2v-2.1841c1.1616-.4146 2-1.5142 2-2.8159zm-3 1c-.5515 0-1-.4487-1-1s.4485-1 1-1 1 .4487 1 1-.4485 1-1 1zM24 23c0-1.3018-.8384-2.4014-2-2.8159v-2.1841h-2v2.1846c-1.1616.4141-2 1.5137-2 2.8154s.8384 2.4014 2 2.8154v4.1846h2v-4.1841c1.1616-.4146 2-1.5142 2-2.8159zm-3 1c-.5515 0-1-.4487-1-1s.4485-1 1-1 1 .4487 1 1-.4485 1-1 1z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "m.7158,11.0454l12.96,14.9546,1.5117-1.3081L4.1902,12h5.2554s5.5544,8.8867,5.5544,8.8867l5.5544-8.8867h5.2554s-2.3315,2.6904-2.3315,2.6904l1.5115,1.3096,4.2944-4.9546-6.7842-9.0454H7.5S.7158,11.0454.7158,11.0454Zm19.8384-1.0454l-3.75-6h4.6958s4.5,6,4.5,6h-5.4458Zm-2.3584,0h-6.3916s3.1958-5.1133,3.1958-5.1133l3.1958,5.1133Zm-6.3914,2h6.3911s-3.1956,5.1133-3.1956,5.1133l-3.1956-5.1133Zm-7.8044-2l4.5-6h4.6958s-3.75,6-3.75,6h-5.4458Z"
  })), children);
});
var ModelTuned20 = /*#__PURE__*/React.forwardRef(function ModelTuned20(_ref46, ref) {
  var children = _ref46.children,
      rest = _objectWithoutProperties(_ref46, _excluded46);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M32 25c0-1.3018-.8384-2.4014-2-2.8159v-4.1841h-2v4.1846c-1.1616.4141-2 1.5137-2 2.8154s.8384 2.4014 2 2.8154v2.1846h2v-2.1841c1.1616-.4146 2-1.5142 2-2.8159zm-3 1c-.5515 0-1-.4487-1-1s.4485-1 1-1 1 .4487 1 1-.4485 1-1 1zM24 23c0-1.3018-.8384-2.4014-2-2.8159v-2.1841h-2v2.1846c-1.1616.4141-2 1.5137-2 2.8154s.8384 2.4014 2 2.8154v4.1846h2v-4.1841c1.1616-.4146 2-1.5142 2-2.8159zm-3 1c-.5515 0-1-.4487-1-1s.4485-1 1-1 1 .4487 1 1-.4485 1-1 1z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "m.7158,11.0454l12.96,14.9546,1.5117-1.3081L4.1902,12h5.2554s5.5544,8.8867,5.5544,8.8867l5.5544-8.8867h5.2554s-2.3315,2.6904-2.3315,2.6904l1.5115,1.3096,4.2944-4.9546-6.7842-9.0454H7.5S.7158,11.0454.7158,11.0454Zm19.8384-1.0454l-3.75-6h4.6958s4.5,6,4.5,6h-5.4458Zm-2.3584,0h-6.3916s3.1958-5.1133,3.1958-5.1133l3.1958,5.1133Zm-6.3914,2h6.3911s-3.1956,5.1133-3.1956,5.1133l-3.1956-5.1133Zm-7.8044-2l4.5-6h4.6958s-3.75,6-3.75,6h-5.4458Z"
  })), children);
});
var ModelTuned16 = /*#__PURE__*/React.forwardRef(function ModelTuned16(_ref47, ref) {
  var children = _ref47.children,
      rest = _objectWithoutProperties(_ref47, _excluded47);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M32 25c0-1.3018-.8384-2.4014-2-2.8159v-4.1841h-2v4.1846c-1.1616.4141-2 1.5137-2 2.8154s.8384 2.4014 2 2.8154v2.1846h2v-2.1841c1.1616-.4146 2-1.5142 2-2.8159zm-3 1c-.5515 0-1-.4487-1-1s.4485-1 1-1 1 .4487 1 1-.4485 1-1 1zM24 23c0-1.3018-.8384-2.4014-2-2.8159v-2.1841h-2v2.1846c-1.1616.4141-2 1.5137-2 2.8154s.8384 2.4014 2 2.8154v4.1846h2v-4.1841c1.1616-.4146 2-1.5142 2-2.8159zm-3 1c-.5515 0-1-.4487-1-1s.4485-1 1-1 1 .4487 1 1-.4485 1-1 1z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "m.7158,11.0454l12.96,14.9546,1.5117-1.3081L4.1902,12h5.2554s5.5544,8.8867,5.5544,8.8867l5.5544-8.8867h5.2554s-2.3315,2.6904-2.3315,2.6904l1.5115,1.3096,4.2944-4.9546-6.7842-9.0454H7.5S.7158,11.0454.7158,11.0454Zm19.8384-1.0454l-3.75-6h4.6958s4.5,6,4.5,6h-5.4458Zm-2.3584,0h-6.3916s3.1958-5.1133,3.1958-5.1133l3.1958,5.1133Zm-6.3914,2h6.3911s-3.1956,5.1133-3.1956,5.1133l-3.1956-5.1133Zm-7.8044-2l4.5-6h4.6958s-3.75,6-3.75,6h-5.4458Z"
  })), children);
});
var ModelBuilder32 = /*#__PURE__*/React.forwardRef(function ModelBuilder32(_ref48, ref) {
  var children = _ref48.children,
      rest = _objectWithoutProperties(_ref48, _excluded48);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M22,4V7H10V4H2v8h8V9h7.0234A4.9463,4.9463,0,0,0,16,12v8A3.0037,3.0037,0,0,1,13,23H10V20H2v8h8V25H13A5.0062,5.0062,0,0,0,18,20V12a2.9982,2.9982,0,0,1,2.9971-3H22v3h8V4ZM8,10H4V6H8ZM8,26H4V22H8ZM28,10H24V6h4Z"
  })), children);
});
var ModelBuilder24 = /*#__PURE__*/React.forwardRef(function ModelBuilder24(_ref49, ref) {
  var children = _ref49.children,
      rest = _objectWithoutProperties(_ref49, _excluded49);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M22,4V7H10V4H2v8h8V9h7.0234A4.9463,4.9463,0,0,0,16,12v8A3.0037,3.0037,0,0,1,13,23H10V20H2v8h8V25H13A5.0062,5.0062,0,0,0,18,20V12a2.9982,2.9982,0,0,1,2.9971-3H22v3h8V4ZM8,10H4V6H8ZM8,26H4V22H8ZM28,10H24V6h4Z"
  })), children);
});
var ModelBuilder20 = /*#__PURE__*/React.forwardRef(function ModelBuilder20(_ref50, ref) {
  var children = _ref50.children,
      rest = _objectWithoutProperties(_ref50, _excluded50);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M22,4V7H10V4H2v8h8V9h7.0234A4.9463,4.9463,0,0,0,16,12v8A3.0037,3.0037,0,0,1,13,23H10V20H2v8h8V25H13A5.0062,5.0062,0,0,0,18,20V12a2.9982,2.9982,0,0,1,2.9971-3H22v3h8V4ZM8,10H4V6H8ZM8,26H4V22H8ZM28,10H24V6h4Z"
  })), children);
});
var ModelBuilder16 = /*#__PURE__*/React.forwardRef(function ModelBuilder16(_ref51, ref) {
  var children = _ref51.children,
      rest = _objectWithoutProperties(_ref51, _excluded51);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M22,4V7H10V4H2v8h8V9h7.0234A4.9463,4.9463,0,0,0,16,12v8A3.0037,3.0037,0,0,1,13,23H10V20H2v8h8V25H13A5.0062,5.0062,0,0,0,18,20V12a2.9982,2.9982,0,0,1,2.9971-3H22v3h8V4ZM8,10H4V6H8ZM8,26H4V22H8ZM28,10H24V6h4Z"
  })), children);
});
var ModelBuilderReference32 = /*#__PURE__*/React.forwardRef(function ModelBuilderReference32(_ref52, ref) {
  var children = _ref52.children,
      rest = _objectWithoutProperties(_ref52, _excluded52);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M22,4V7H10V4H2v8h8V9h7.0234A4.9463,4.9463,0,0,0,16,12V28h2V12a2.9982,2.9982,0,0,1,2.9971-3H22v3h8V4ZM8,10H4V6H8Zm20,0H24V6h4Z"
  })), children);
});
var ModelBuilderReference24 = /*#__PURE__*/React.forwardRef(function ModelBuilderReference24(_ref53, ref) {
  var children = _ref53.children,
      rest = _objectWithoutProperties(_ref53, _excluded53);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M22,4V7H10V4H2v8h8V9h7.0234A4.9463,4.9463,0,0,0,16,12V28h2V12a2.9982,2.9982,0,0,1,2.9971-3H22v3h8V4ZM8,10H4V6H8Zm20,0H24V6h4Z"
  })), children);
});
var ModelBuilderReference20 = /*#__PURE__*/React.forwardRef(function ModelBuilderReference20(_ref54, ref) {
  var children = _ref54.children,
      rest = _objectWithoutProperties(_ref54, _excluded54);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M22,4V7H10V4H2v8h8V9h7.0234A4.9463,4.9463,0,0,0,16,12V28h2V12a2.9982,2.9982,0,0,1,2.9971-3H22v3h8V4ZM8,10H4V6H8Zm20,0H24V6h4Z"
  })), children);
});
var ModelBuilderReference16 = /*#__PURE__*/React.forwardRef(function ModelBuilderReference16(_ref55, ref) {
  var children = _ref55.children,
      rest = _objectWithoutProperties(_ref55, _excluded55);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M22,4V7H10V4H2v8h8V9h7.0234A4.9463,4.9463,0,0,0,16,12V28h2V12a2.9982,2.9982,0,0,1,2.9971-3H22v3h8V4ZM8,10H4V6H8Zm20,0H24V6h4Z"
  })), children);
});
var Money32 = /*#__PURE__*/React.forwardRef(function Money32(_ref56, ref) {
  var children = _ref56.children,
      rest = _objectWithoutProperties(_ref56, _excluded56);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M2 22H30V24H2zM2 26H30V28H2zM24 10a2 2 0 102 2 2 2 0 00-2-2zM16 16a4 4 0 114-4A4.0045 4.0045 0 0116 16zm0-6a2 2 0 102 2A2.002 2.002 0 0016 10zM8 10a2 2 0 102 2 2 2 0 00-2-2z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H4a2.0051,2.0051,0,0,1-2-2V6A2.0051,2.0051,0,0,1,4,4H28a2.0051,2.0051,0,0,1,2,2V18A2.0027,2.0027,0,0,1,28,20ZM28,6H4V18H28Z"
  })), children);
});
var Money24 = /*#__PURE__*/React.forwardRef(function Money24(_ref57, ref) {
  var children = _ref57.children,
      rest = _objectWithoutProperties(_ref57, _excluded57);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M2 22H30V24H2zM2 26H30V28H2zM24 10a2 2 0 102 2 2 2 0 00-2-2zM16 16a4 4 0 114-4A4.0045 4.0045 0 0116 16zm0-6a2 2 0 102 2A2.002 2.002 0 0016 10zM8 10a2 2 0 102 2 2 2 0 00-2-2z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H4a2.0051,2.0051,0,0,1-2-2V6A2.0051,2.0051,0,0,1,4,4H28a2.0051,2.0051,0,0,1,2,2V18A2.0027,2.0027,0,0,1,28,20ZM28,6H4V18H28Z"
  })), children);
});
var Money20 = /*#__PURE__*/React.forwardRef(function Money20(_ref58, ref) {
  var children = _ref58.children,
      rest = _objectWithoutProperties(_ref58, _excluded58);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M2 22H30V24H2zM2 26H30V28H2zM24 10a2 2 0 102 2 2 2 0 00-2-2zM16 16a4 4 0 114-4A4.0045 4.0045 0 0116 16zm0-6a2 2 0 102 2A2.002 2.002 0 0016 10zM8 10a2 2 0 102 2 2 2 0 00-2-2z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H4a2.0051,2.0051,0,0,1-2-2V6A2.0051,2.0051,0,0,1,4,4H28a2.0051,2.0051,0,0,1,2,2V18A2.0027,2.0027,0,0,1,28,20ZM28,6H4V18H28Z"
  })), children);
});
var Money16 = /*#__PURE__*/React.forwardRef(function Money16(_ref59, ref) {
  var children = _ref59.children,
      rest = _objectWithoutProperties(_ref59, _excluded59);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M2 22H30V24H2zM2 26H30V28H2zM24 10a2 2 0 102 2 2 2 0 00-2-2zM16 16a4 4 0 114-4A4.0045 4.0045 0 0116 16zm0-6a2 2 0 102 2A2.002 2.002 0 0016 10zM8 10a2 2 0 102 2 2 2 0 00-2-2z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H4a2.0051,2.0051,0,0,1-2-2V6A2.0051,2.0051,0,0,1,4,4H28a2.0051,2.0051,0,0,1,2,2V18A2.0027,2.0027,0,0,1,28,20ZM28,6H4V18H28Z"
  })), children);
});
var Monster32 = /*#__PURE__*/React.forwardRef(function Monster32(_ref60, ref) {
  var children = _ref60.children,
      rest = _objectWithoutProperties(_ref60, _excluded60);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M23 22L21 22 21 20 19 20 19 22 17 22 17 20 15 20 15 22 13 22 13 20 11 20 11 22 9 22 9 24 11 24 11 26 13 26 13 24 15 24 15 26 17 26 17 24 19 24 19 26 21 26 21 24 23 24 23 22z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M28,11H27V4a2.0025,2.0025,0,0,0-2-2H7A2.0025,2.0025,0,0,0,5,4v7H4a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2H5v4a7.0078,7.0078,0,0,0,7,7h8a7.0078,7.0078,0,0,0,7-7V19h1a2.0025,2.0025,0,0,0,2-2V13A2.0025,2.0025,0,0,0,28,11ZM25,4V7.3818L22.4473,6.1055a1.0008,1.0008,0,0,0-.8946,0L18,7.8818,14.4473,6.1055a1.0008,1.0008,0,0,0-.8946,0L10,7.8818l-3-1.5V4Zm3,13H25v6a5.0057,5.0057,0,0,1-5,5H12a5.0057,5.0057,0,0,1-5-5V17H4V13H7V8.6182L9.5527,9.8945a1.0008,1.0008,0,0,0,.8946,0L14,8.1182l3.5527,1.7763a1.001,1.001,0,0,0,.8946,0L22,8.1182l3,1.5V13h3Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14H14V16H9zM18 14H23V16H18z"
  })), children);
});
var Monster24 = /*#__PURE__*/React.forwardRef(function Monster24(_ref61, ref) {
  var children = _ref61.children,
      rest = _objectWithoutProperties(_ref61, _excluded61);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M23 22L21 22 21 20 19 20 19 22 17 22 17 20 15 20 15 22 13 22 13 20 11 20 11 22 9 22 9 24 11 24 11 26 13 26 13 24 15 24 15 26 17 26 17 24 19 24 19 26 21 26 21 24 23 24 23 22z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M28,11H27V4a2.0025,2.0025,0,0,0-2-2H7A2.0025,2.0025,0,0,0,5,4v7H4a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2H5v4a7.0078,7.0078,0,0,0,7,7h8a7.0078,7.0078,0,0,0,7-7V19h1a2.0025,2.0025,0,0,0,2-2V13A2.0025,2.0025,0,0,0,28,11ZM25,4V7.3818L22.4473,6.1055a1.0008,1.0008,0,0,0-.8946,0L18,7.8818,14.4473,6.1055a1.0008,1.0008,0,0,0-.8946,0L10,7.8818l-3-1.5V4Zm3,13H25v6a5.0057,5.0057,0,0,1-5,5H12a5.0057,5.0057,0,0,1-5-5V17H4V13H7V8.6182L9.5527,9.8945a1.0008,1.0008,0,0,0,.8946,0L14,8.1182l3.5527,1.7763a1.001,1.001,0,0,0,.8946,0L22,8.1182l3,1.5V13h3Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14H14V16H9zM18 14H23V16H18z"
  })), children);
});
var Monster20 = /*#__PURE__*/React.forwardRef(function Monster20(_ref62, ref) {
  var children = _ref62.children,
      rest = _objectWithoutProperties(_ref62, _excluded62);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M23 22L21 22 21 20 19 20 19 22 17 22 17 20 15 20 15 22 13 22 13 20 11 20 11 22 9 22 9 24 11 24 11 26 13 26 13 24 15 24 15 26 17 26 17 24 19 24 19 26 21 26 21 24 23 24 23 22z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M28,11H27V4a2.0025,2.0025,0,0,0-2-2H7A2.0025,2.0025,0,0,0,5,4v7H4a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2H5v4a7.0078,7.0078,0,0,0,7,7h8a7.0078,7.0078,0,0,0,7-7V19h1a2.0025,2.0025,0,0,0,2-2V13A2.0025,2.0025,0,0,0,28,11ZM25,4V7.3818L22.4473,6.1055a1.0008,1.0008,0,0,0-.8946,0L18,7.8818,14.4473,6.1055a1.0008,1.0008,0,0,0-.8946,0L10,7.8818l-3-1.5V4Zm3,13H25v6a5.0057,5.0057,0,0,1-5,5H12a5.0057,5.0057,0,0,1-5-5V17H4V13H7V8.6182L9.5527,9.8945a1.0008,1.0008,0,0,0,.8946,0L14,8.1182l3.5527,1.7763a1.001,1.001,0,0,0,.8946,0L22,8.1182l3,1.5V13h3Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14H14V16H9zM18 14H23V16H18z"
  })), children);
});
var Monster16 = /*#__PURE__*/React.forwardRef(function Monster16(_ref63, ref) {
  var children = _ref63.children,
      rest = _objectWithoutProperties(_ref63, _excluded63);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M23 22L21 22 21 20 19 20 19 22 17 22 17 20 15 20 15 22 13 22 13 20 11 20 11 22 9 22 9 24 11 24 11 26 13 26 13 24 15 24 15 26 17 26 17 24 19 24 19 26 21 26 21 24 23 24 23 22z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M28,11H27V4a2.0025,2.0025,0,0,0-2-2H7A2.0025,2.0025,0,0,0,5,4v7H4a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2H5v4a7.0078,7.0078,0,0,0,7,7h8a7.0078,7.0078,0,0,0,7-7V19h1a2.0025,2.0025,0,0,0,2-2V13A2.0025,2.0025,0,0,0,28,11ZM25,4V7.3818L22.4473,6.1055a1.0008,1.0008,0,0,0-.8946,0L18,7.8818,14.4473,6.1055a1.0008,1.0008,0,0,0-.8946,0L10,7.8818l-3-1.5V4Zm3,13H25v6a5.0057,5.0057,0,0,1-5,5H12a5.0057,5.0057,0,0,1-5-5V17H4V13H7V8.6182L9.5527,9.8945a1.0008,1.0008,0,0,0,.8946,0L14,8.1182l3.5527,1.7763a1.001,1.001,0,0,0,.8946,0L22,8.1182l3,1.5V13h3Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14H14V16H9zM18 14H23V16H18z"
  })), children);
});
var Monument32 = /*#__PURE__*/React.forwardRef(function Monument32(_ref64, ref) {
  var children = _ref64.children,
      rest = _objectWithoutProperties(_ref64, _excluded64);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M20,28V6L16,2,12,6V28H2v2H30V28Zm-6,0V6.8281l2-2,2,2V28Z"
  })), children);
});
var Monument24 = /*#__PURE__*/React.forwardRef(function Monument24(_ref65, ref) {
  var children = _ref65.children,
      rest = _objectWithoutProperties(_ref65, _excluded65);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M20,28V6L16,2,12,6V28H2v2H30V28Zm-6,0V6.8281l2-2,2,2V28Z"
  })), children);
});
var Monument20 = /*#__PURE__*/React.forwardRef(function Monument20(_ref66, ref) {
  var children = _ref66.children,
      rest = _objectWithoutProperties(_ref66, _excluded66);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M20,28V6L16,2,12,6V28H2v2H30V28Zm-6,0V6.8281l2-2,2,2V28Z"
  })), children);
});
var Monument16 = /*#__PURE__*/React.forwardRef(function Monument16(_ref67, ref) {
  var children = _ref67.children,
      rest = _objectWithoutProperties(_ref67, _excluded67);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M20,28V6L16,2,12,6V28H2v2H30V28Zm-6,0V6.8281l2-2,2,2V28Z"
  })), children);
});
var Moon32 = /*#__PURE__*/React.forwardRef(function Moon32(_ref68, ref) {
  var children = _ref68.children,
      rest = _objectWithoutProperties(_ref68, _excluded68);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5025,5.4136A15.0755,15.0755,0,0,0,25.096,23.6082a11.1134,11.1134,0,0,1-7.9749,3.3893c-.1385,0-.2782.0051-.4178,0A11.0944,11.0944,0,0,1,13.5025,5.4136M14.98,3a1.0024,1.0024,0,0,0-.1746.0156A13.0959,13.0959,0,0,0,16.63,28.9973c.1641.006.3282,0,.4909,0a13.0724,13.0724,0,0,0,10.702-5.5556,1.0094,1.0094,0,0,0-.7833-1.5644A13.08,13.08,0,0,1,15.8892,4.38,1.0149,1.0149,0,0,0,14.98,3Z"
  })), children);
});
var Moon24 = /*#__PURE__*/React.forwardRef(function Moon24(_ref69, ref) {
  var children = _ref69.children,
      rest = _objectWithoutProperties(_ref69, _excluded69);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5025,5.4136A15.0755,15.0755,0,0,0,25.096,23.6082a11.1134,11.1134,0,0,1-7.9749,3.3893c-.1385,0-.2782.0051-.4178,0A11.0944,11.0944,0,0,1,13.5025,5.4136M14.98,3a1.0024,1.0024,0,0,0-.1746.0156A13.0959,13.0959,0,0,0,16.63,28.9973c.1641.006.3282,0,.4909,0a13.0724,13.0724,0,0,0,10.702-5.5556,1.0094,1.0094,0,0,0-.7833-1.5644A13.08,13.08,0,0,1,15.8892,4.38,1.0149,1.0149,0,0,0,14.98,3Z"
  })), children);
});
var Moon20 = /*#__PURE__*/React.forwardRef(function Moon20(_ref70, ref) {
  var children = _ref70.children,
      rest = _objectWithoutProperties(_ref70, _excluded70);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5025,5.4136A15.0755,15.0755,0,0,0,25.096,23.6082a11.1134,11.1134,0,0,1-7.9749,3.3893c-.1385,0-.2782.0051-.4178,0A11.0944,11.0944,0,0,1,13.5025,5.4136M14.98,3a1.0024,1.0024,0,0,0-.1746.0156A13.0959,13.0959,0,0,0,16.63,28.9973c.1641.006.3282,0,.4909,0a13.0724,13.0724,0,0,0,10.702-5.5556,1.0094,1.0094,0,0,0-.7833-1.5644A13.08,13.08,0,0,1,15.8892,4.38,1.0149,1.0149,0,0,0,14.98,3Z"
  })), children);
});
var Moon16 = /*#__PURE__*/React.forwardRef(function Moon16(_ref71, ref) {
  var children = _ref71.children,
      rest = _objectWithoutProperties(_ref71, _excluded71);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5025,5.4136A15.0755,15.0755,0,0,0,25.096,23.6082a11.1134,11.1134,0,0,1-7.9749,3.3893c-.1385,0-.2782.0051-.4178,0A11.0944,11.0944,0,0,1,13.5025,5.4136M14.98,3a1.0024,1.0024,0,0,0-.1746.0156A13.0959,13.0959,0,0,0,16.63,28.9973c.1641.006.3282,0,.4909,0a13.0724,13.0724,0,0,0,10.702-5.5556,1.0094,1.0094,0,0,0-.7833-1.5644A13.08,13.08,0,0,1,15.8892,4.38,1.0149,1.0149,0,0,0,14.98,3Z"
  })), children);
});
var Moonrise32 = /*#__PURE__*/React.forwardRef(function Moonrise32(_ref72, ref) {
  var children = _ref72.children,
      rest = _objectWithoutProperties(_ref72, _excluded72);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M2 28H30V30H2zM26 26H24a7.987 7.987 0 00-2.0371-5.3335l1.49-1.334A9.9835 9.9835 0 0126 26zM16 26H14a9.9268 9.9268 0 013.7539-7.804A7.89 7.89 0 0016 18a8.0092 8.0092 0 00-8 8H6A10.0113 10.0113 0 0116 16a9.8923 9.8923 0 014.4458 1.0515 1 1 0 010 1.79A7.9567 7.9567 0 0016 26zM16 2L11 7 12.41 8.41 15 5.83 15 6 15 14 17 14 17 6 17 5.83 19.59 8.41 21 7 16 2z"
  })), children);
});
var Moonrise24 = /*#__PURE__*/React.forwardRef(function Moonrise24(_ref73, ref) {
  var children = _ref73.children,
      rest = _objectWithoutProperties(_ref73, _excluded73);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M2 28H30V30H2zM26 26H24a7.987 7.987 0 00-2.0371-5.3335l1.49-1.334A9.9835 9.9835 0 0126 26zM16 26H14a9.9268 9.9268 0 013.7539-7.804A7.89 7.89 0 0016 18a8.0092 8.0092 0 00-8 8H6A10.0113 10.0113 0 0116 16a9.8923 9.8923 0 014.4458 1.0515 1 1 0 010 1.79A7.9567 7.9567 0 0016 26zM16 2L11 7 12.41 8.41 15 5.83 15 6 15 14 17 14 17 6 17 5.83 19.59 8.41 21 7 16 2z"
  })), children);
});
var Moonrise20 = /*#__PURE__*/React.forwardRef(function Moonrise20(_ref74, ref) {
  var children = _ref74.children,
      rest = _objectWithoutProperties(_ref74, _excluded74);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M2 28H30V30H2zM26 26H24a7.987 7.987 0 00-2.0371-5.3335l1.49-1.334A9.9835 9.9835 0 0126 26zM16 26H14a9.9268 9.9268 0 013.7539-7.804A7.89 7.89 0 0016 18a8.0092 8.0092 0 00-8 8H6A10.0113 10.0113 0 0116 16a9.8923 9.8923 0 014.4458 1.0515 1 1 0 010 1.79A7.9567 7.9567 0 0016 26zM16 2L11 7 12.41 8.41 15 5.83 15 6 15 14 17 14 17 6 17 5.83 19.59 8.41 21 7 16 2z"
  })), children);
});
var Moonrise16 = /*#__PURE__*/React.forwardRef(function Moonrise16(_ref75, ref) {
  var children = _ref75.children,
      rest = _objectWithoutProperties(_ref75, _excluded75);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M2 28H30V30H2zM26 26H24a7.987 7.987 0 00-2.0371-5.3335l1.49-1.334A9.9835 9.9835 0 0126 26zM16 26H14a9.9268 9.9268 0 013.7539-7.804A7.89 7.89 0 0016 18a8.0092 8.0092 0 00-8 8H6A10.0113 10.0113 0 0116 16a9.8923 9.8923 0 014.4458 1.0515 1 1 0 010 1.79A7.9567 7.9567 0 0016 26zM16 2L11 7 12.41 8.41 15 5.83 15 6 15 14 17 14 17 6 17 5.83 19.59 8.41 21 7 16 2z"
  })), children);
});
var Moonset32 = /*#__PURE__*/React.forwardRef(function Moonset32(_ref76, ref) {
  var children = _ref76.children,
      rest = _objectWithoutProperties(_ref76, _excluded76);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M2 28H30V30H2zM26 26H24a7.987 7.987 0 00-2.0371-5.3335l1.49-1.334A9.9835 9.9835 0 0126 26zM16 26H14a9.9268 9.9268 0 013.7539-7.804A7.89 7.89 0 0016 18a8.0092 8.0092 0 00-8 8H6A10.0113 10.0113 0 0116 16a9.8923 9.8923 0 014.4458 1.0515 1 1 0 010 1.79A7.9567 7.9567 0 0016 26zM16 14L11 9 12.41 7.59 15 10.17 15 10 15 2 17 2 17 10 17 10.17 19.59 7.59 21 9 16 14z"
  })), children);
});
var Moonset24 = /*#__PURE__*/React.forwardRef(function Moonset24(_ref77, ref) {
  var children = _ref77.children,
      rest = _objectWithoutProperties(_ref77, _excluded77);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M2 28H30V30H2zM26 26H24a7.987 7.987 0 00-2.0371-5.3335l1.49-1.334A9.9835 9.9835 0 0126 26zM16 26H14a9.9268 9.9268 0 013.7539-7.804A7.89 7.89 0 0016 18a8.0092 8.0092 0 00-8 8H6A10.0113 10.0113 0 0116 16a9.8923 9.8923 0 014.4458 1.0515 1 1 0 010 1.79A7.9567 7.9567 0 0016 26zM16 14L11 9 12.41 7.59 15 10.17 15 10 15 2 17 2 17 10 17 10.17 19.59 7.59 21 9 16 14z"
  })), children);
});
var Moonset20 = /*#__PURE__*/React.forwardRef(function Moonset20(_ref78, ref) {
  var children = _ref78.children,
      rest = _objectWithoutProperties(_ref78, _excluded78);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M2 28H30V30H2zM26 26H24a7.987 7.987 0 00-2.0371-5.3335l1.49-1.334A9.9835 9.9835 0 0126 26zM16 26H14a9.9268 9.9268 0 013.7539-7.804A7.89 7.89 0 0016 18a8.0092 8.0092 0 00-8 8H6A10.0113 10.0113 0 0116 16a9.8923 9.8923 0 014.4458 1.0515 1 1 0 010 1.79A7.9567 7.9567 0 0016 26zM16 14L11 9 12.41 7.59 15 10.17 15 10 15 2 17 2 17 10 17 10.17 19.59 7.59 21 9 16 14z"
  })), children);
});
var Moonset16 = /*#__PURE__*/React.forwardRef(function Moonset16(_ref79, ref) {
  var children = _ref79.children,
      rest = _objectWithoutProperties(_ref79, _excluded79);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M2 28H30V30H2zM26 26H24a7.987 7.987 0 00-2.0371-5.3335l1.49-1.334A9.9835 9.9835 0 0126 26zM16 26H14a9.9268 9.9268 0 013.7539-7.804A7.89 7.89 0 0016 18a8.0092 8.0092 0 00-8 8H6A10.0113 10.0113 0 0116 16a9.8923 9.8923 0 014.4458 1.0515 1 1 0 010 1.79A7.9567 7.9567 0 0016 26zM16 14L11 9 12.41 7.59 15 10.17 15 10 15 2 17 2 17 10 17 10.17 19.59 7.59 21 9 16 14z"
  })), children);
});
var MostlyCloudy32 = /*#__PURE__*/React.forwardRef(function MostlyCloudy32(_ref80, ref) {
  var children = _ref80.children,
      rest = _objectWithoutProperties(_ref80, _excluded80);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M21.743,18.6872A6.05,6.05,0,0,0,22.8,17.6006a5.9977,5.9977,0,1,0-10.7334-4.4444,7.5568,7.5568,0,0,0-5.7158,5.0879A5.9926,5.9926,0,0,0,8,30H19a5.9854,5.9854,0,0,0,2.743-11.3128ZM18,10a4.0042,4.0042,0,0,1,4,4,3.9613,3.9613,0,0,1-.8,2.3994,4.0122,4.0122,0,0,1-.94.8917,7.5416,7.5416,0,0,0-6.1339-4.2395A3.9985,3.9985,0,0,1,18,10Zm1,18H8a3.9928,3.9928,0,0,1-.6729-7.93L7.99,19.958l.1456-.6562a5.4958,5.4958,0,0,1,10.729,0l.1464.6562.6622.1123A3.9928,3.9928,0,0,1,19,28Z",
    transform: "translate(0 .005)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M26 13.005H30V15.005H26z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M23.071 5.929H27.071V7.929H23.071z",
    transform: "rotate(-45 25.077 6.931)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M17 2.005H19V6.005H17z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M9.929 4.929H11.929V8.929H9.929z",
    transform: "rotate(-45 10.935 6.931)"
  })), children);
});
var MostlyCloudy24 = /*#__PURE__*/React.forwardRef(function MostlyCloudy24(_ref81, ref) {
  var children = _ref81.children,
      rest = _objectWithoutProperties(_ref81, _excluded81);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M21.743,18.6872A6.05,6.05,0,0,0,22.8,17.6006a5.9977,5.9977,0,1,0-10.7334-4.4444,7.5568,7.5568,0,0,0-5.7158,5.0879A5.9926,5.9926,0,0,0,8,30H19a5.9854,5.9854,0,0,0,2.743-11.3128ZM18,10a4.0042,4.0042,0,0,1,4,4,3.9613,3.9613,0,0,1-.8,2.3994,4.0122,4.0122,0,0,1-.94.8917,7.5416,7.5416,0,0,0-6.1339-4.2395A3.9985,3.9985,0,0,1,18,10Zm1,18H8a3.9928,3.9928,0,0,1-.6729-7.93L7.99,19.958l.1456-.6562a5.4958,5.4958,0,0,1,10.729,0l.1464.6562.6622.1123A3.9928,3.9928,0,0,1,19,28Z",
    transform: "translate(0 .005)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M26 13.005H30V15.005H26z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M23.071 5.929H27.071V7.929H23.071z",
    transform: "rotate(-45 25.077 6.931)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M17 2.005H19V6.005H17z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M9.929 4.929H11.929V8.929H9.929z",
    transform: "rotate(-45 10.935 6.931)"
  })), children);
});
var MostlyCloudy20 = /*#__PURE__*/React.forwardRef(function MostlyCloudy20(_ref82, ref) {
  var children = _ref82.children,
      rest = _objectWithoutProperties(_ref82, _excluded82);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M21.743,18.6872A6.05,6.05,0,0,0,22.8,17.6006a5.9977,5.9977,0,1,0-10.7334-4.4444,7.5568,7.5568,0,0,0-5.7158,5.0879A5.9926,5.9926,0,0,0,8,30H19a5.9854,5.9854,0,0,0,2.743-11.3128ZM18,10a4.0042,4.0042,0,0,1,4,4,3.9613,3.9613,0,0,1-.8,2.3994,4.0122,4.0122,0,0,1-.94.8917,7.5416,7.5416,0,0,0-6.1339-4.2395A3.9985,3.9985,0,0,1,18,10Zm1,18H8a3.9928,3.9928,0,0,1-.6729-7.93L7.99,19.958l.1456-.6562a5.4958,5.4958,0,0,1,10.729,0l.1464.6562.6622.1123A3.9928,3.9928,0,0,1,19,28Z",
    transform: "translate(0 .005)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M26 13.005H30V15.005H26z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M23.071 5.929H27.071V7.929H23.071z",
    transform: "rotate(-45 25.077 6.931)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M17 2.005H19V6.005H17z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M9.929 4.929H11.929V8.929H9.929z",
    transform: "rotate(-45 10.935 6.931)"
  })), children);
});
var MostlyCloudy16 = /*#__PURE__*/React.forwardRef(function MostlyCloudy16(_ref83, ref) {
  var children = _ref83.children,
      rest = _objectWithoutProperties(_ref83, _excluded83);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M21.743,18.6872A6.05,6.05,0,0,0,22.8,17.6006a5.9977,5.9977,0,1,0-10.7334-4.4444,7.5568,7.5568,0,0,0-5.7158,5.0879A5.9926,5.9926,0,0,0,8,30H19a5.9854,5.9854,0,0,0,2.743-11.3128ZM18,10a4.0042,4.0042,0,0,1,4,4,3.9613,3.9613,0,0,1-.8,2.3994,4.0122,4.0122,0,0,1-.94.8917,7.5416,7.5416,0,0,0-6.1339-4.2395A3.9985,3.9985,0,0,1,18,10Zm1,18H8a3.9928,3.9928,0,0,1-.6729-7.93L7.99,19.958l.1456-.6562a5.4958,5.4958,0,0,1,10.729,0l.1464.6562.6622.1123A3.9928,3.9928,0,0,1,19,28Z",
    transform: "translate(0 .005)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M26 13.005H30V15.005H26z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M23.071 5.929H27.071V7.929H23.071z",
    transform: "rotate(-45 25.077 6.931)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M17 2.005H19V6.005H17z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M9.929 4.929H11.929V8.929H9.929z",
    transform: "rotate(-45 10.935 6.931)"
  })), children);
});
var MostlyCloudyNight32 = /*#__PURE__*/React.forwardRef(function MostlyCloudyNight32(_ref84, ref) {
  var children = _ref84.children,
      rest = _objectWithoutProperties(_ref84, _excluded84);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8438,15.0347a1.5169,1.5169,0,0,0-1.23-.8658,5.3547,5.3547,0,0,1-3.4094-1.7158A6.4653,6.4653,0,0,1,23.918,6.0605a1.6025,1.6025,0,0,0-.2989-1.5459,1.4543,1.4543,0,0,0-1.36-.4931l-.0191.0039a7.927,7.927,0,0,0-6.22,7.4307A7.3638,7.3638,0,0,0,13.5,11a7.5511,7.5511,0,0,0-7.1494,5.2441A5.9926,5.9926,0,0,0,8,28H19a5.9771,5.9771,0,0,0,5.6147-8.0884,7.5054,7.5054,0,0,0,5.1324-3.3569A1.5372,1.5372,0,0,0,29.8438,15.0347ZM19,26H8a3.9926,3.9926,0,0,1-.6733-7.9292l.663-.1128.1456-.6562a5.496,5.496,0,0,1,10.7294,0l.1456.6562.6626.1128A3.9925,3.9925,0,0,1,19,26Zm4.4653-8.001h-.0217a5.9581,5.9581,0,0,0-2.7942-1.7549,7.5068,7.5068,0,0,0-2.6008-3.6767c-.01-.1016-.0361-.1978-.041-.3008a6.078,6.078,0,0,1,3.7907-6.05,8.4577,8.4577,0,0,0,1.94,7.5967A7.4007,7.4007,0,0,0,27.64,16.041,5.4286,5.4286,0,0,1,23.4653,17.999Z"
  })), children);
});
var MostlyCloudyNight24 = /*#__PURE__*/React.forwardRef(function MostlyCloudyNight24(_ref85, ref) {
  var children = _ref85.children,
      rest = _objectWithoutProperties(_ref85, _excluded85);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8438,15.0347a1.5169,1.5169,0,0,0-1.23-.8658,5.3547,5.3547,0,0,1-3.4094-1.7158A6.4653,6.4653,0,0,1,23.918,6.0605a1.6025,1.6025,0,0,0-.2989-1.5459,1.4543,1.4543,0,0,0-1.36-.4931l-.0191.0039a7.927,7.927,0,0,0-6.22,7.4307A7.3638,7.3638,0,0,0,13.5,11a7.5511,7.5511,0,0,0-7.1494,5.2441A5.9926,5.9926,0,0,0,8,28H19a5.9771,5.9771,0,0,0,5.6147-8.0884,7.5054,7.5054,0,0,0,5.1324-3.3569A1.5372,1.5372,0,0,0,29.8438,15.0347ZM19,26H8a3.9926,3.9926,0,0,1-.6733-7.9292l.663-.1128.1456-.6562a5.496,5.496,0,0,1,10.7294,0l.1456.6562.6626.1128A3.9925,3.9925,0,0,1,19,26Zm4.4653-8.001h-.0217a5.9581,5.9581,0,0,0-2.7942-1.7549,7.5068,7.5068,0,0,0-2.6008-3.6767c-.01-.1016-.0361-.1978-.041-.3008a6.078,6.078,0,0,1,3.7907-6.05,8.4577,8.4577,0,0,0,1.94,7.5967A7.4007,7.4007,0,0,0,27.64,16.041,5.4286,5.4286,0,0,1,23.4653,17.999Z"
  })), children);
});
var MostlyCloudyNight20 = /*#__PURE__*/React.forwardRef(function MostlyCloudyNight20(_ref86, ref) {
  var children = _ref86.children,
      rest = _objectWithoutProperties(_ref86, _excluded86);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8438,15.0347a1.5169,1.5169,0,0,0-1.23-.8658,5.3547,5.3547,0,0,1-3.4094-1.7158A6.4653,6.4653,0,0,1,23.918,6.0605a1.6025,1.6025,0,0,0-.2989-1.5459,1.4543,1.4543,0,0,0-1.36-.4931l-.0191.0039a7.927,7.927,0,0,0-6.22,7.4307A7.3638,7.3638,0,0,0,13.5,11a7.5511,7.5511,0,0,0-7.1494,5.2441A5.9926,5.9926,0,0,0,8,28H19a5.9771,5.9771,0,0,0,5.6147-8.0884,7.5054,7.5054,0,0,0,5.1324-3.3569A1.5372,1.5372,0,0,0,29.8438,15.0347ZM19,26H8a3.9926,3.9926,0,0,1-.6733-7.9292l.663-.1128.1456-.6562a5.496,5.496,0,0,1,10.7294,0l.1456.6562.6626.1128A3.9925,3.9925,0,0,1,19,26Zm4.4653-8.001h-.0217a5.9581,5.9581,0,0,0-2.7942-1.7549,7.5068,7.5068,0,0,0-2.6008-3.6767c-.01-.1016-.0361-.1978-.041-.3008a6.078,6.078,0,0,1,3.7907-6.05,8.4577,8.4577,0,0,0,1.94,7.5967A7.4007,7.4007,0,0,0,27.64,16.041,5.4286,5.4286,0,0,1,23.4653,17.999Z"
  })), children);
});
var MostlyCloudyNight16 = /*#__PURE__*/React.forwardRef(function MostlyCloudyNight16(_ref87, ref) {
  var children = _ref87.children,
      rest = _objectWithoutProperties(_ref87, _excluded87);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8438,15.0347a1.5169,1.5169,0,0,0-1.23-.8658,5.3547,5.3547,0,0,1-3.4094-1.7158A6.4653,6.4653,0,0,1,23.918,6.0605a1.6025,1.6025,0,0,0-.2989-1.5459,1.4543,1.4543,0,0,0-1.36-.4931l-.0191.0039a7.927,7.927,0,0,0-6.22,7.4307A7.3638,7.3638,0,0,0,13.5,11a7.5511,7.5511,0,0,0-7.1494,5.2441A5.9926,5.9926,0,0,0,8,28H19a5.9771,5.9771,0,0,0,5.6147-8.0884,7.5054,7.5054,0,0,0,5.1324-3.3569A1.5372,1.5372,0,0,0,29.8438,15.0347ZM19,26H8a3.9926,3.9926,0,0,1-.6733-7.9292l.663-.1128.1456-.6562a5.496,5.496,0,0,1,10.7294,0l.1456.6562.6626.1128A3.9925,3.9925,0,0,1,19,26Zm4.4653-8.001h-.0217a5.9581,5.9581,0,0,0-2.7942-1.7549,7.5068,7.5068,0,0,0-2.6008-3.6767c-.01-.1016-.0361-.1978-.041-.3008a6.078,6.078,0,0,1,3.7907-6.05,8.4577,8.4577,0,0,0,1.94,7.5967A7.4007,7.4007,0,0,0,27.64,16.041,5.4286,5.4286,0,0,1,23.4653,17.999Z"
  })), children);
});
var Mountain32 = /*#__PURE__*/React.forwardRef(function Mountain32(_ref88, ref) {
  var children = _ref88.children,
      rest = _objectWithoutProperties(_ref88, _excluded88);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6343,26,17.7888,5.1055a2,2,0,0,0-3.5879.021L4.3657,26H2v2H30V26ZM15.99,5.979,20.9473,16.5,19,17.7979l-3-2-3,2-1.9551-1.3033ZM10.1846,18.3247,13,20.2021l3-2,3,2,2.8091-1.873L25.4233,26H6.5752Z"
  })), children);
});
var Mountain24 = /*#__PURE__*/React.forwardRef(function Mountain24(_ref89, ref) {
  var children = _ref89.children,
      rest = _objectWithoutProperties(_ref89, _excluded89);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6343,26,17.7888,5.1055a2,2,0,0,0-3.5879.021L4.3657,26H2v2H30V26ZM15.99,5.979,20.9473,16.5,19,17.7979l-3-2-3,2-1.9551-1.3033ZM10.1846,18.3247,13,20.2021l3-2,3,2,2.8091-1.873L25.4233,26H6.5752Z"
  })), children);
});
var Mountain20 = /*#__PURE__*/React.forwardRef(function Mountain20(_ref90, ref) {
  var children = _ref90.children,
      rest = _objectWithoutProperties(_ref90, _excluded90);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6343,26,17.7888,5.1055a2,2,0,0,0-3.5879.021L4.3657,26H2v2H30V26ZM15.99,5.979,20.9473,16.5,19,17.7979l-3-2-3,2-1.9551-1.3033ZM10.1846,18.3247,13,20.2021l3-2,3,2,2.8091-1.873L25.4233,26H6.5752Z"
  })), children);
});
var Mountain16 = /*#__PURE__*/React.forwardRef(function Mountain16(_ref91, ref) {
  var children = _ref91.children,
      rest = _objectWithoutProperties(_ref91, _excluded91);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6343,26,17.7888,5.1055a2,2,0,0,0-3.5879.021L4.3657,26H2v2H30V26ZM15.99,5.979,20.9473,16.5,19,17.7979l-3-2-3,2-1.9551-1.3033ZM10.1846,18.3247,13,20.2021l3-2,3,2,2.8091-1.873L25.4233,26H6.5752Z"
  })), children);
});
var Mov32 = /*#__PURE__*/React.forwardRef(function Mov32(_ref92, ref) {
  var children = _ref92.children,
      rest = _objectWithoutProperties(_ref92, _excluded92);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M28 9L26 22 24 9 22 9 24.52 23 27.48 23 30 9 28 9zM18 23H14a2 2 0 01-2-2V11a2 2 0 012-2h4a2 2 0 012 2V21A2 2 0 0118 23zM14 11V21h4V11zM8 9L6.49 14 6 15.98 5.54 14 4 9 2 9 2 23 4 23 4 15 3.84 13 4.42 15 6 19.63 7.58 15 8.16 13 8 15 8 23 10 23 10 9 8 9z"
  })), children);
});
var Mov24 = /*#__PURE__*/React.forwardRef(function Mov24(_ref93, ref) {
  var children = _ref93.children,
      rest = _objectWithoutProperties(_ref93, _excluded93);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M28 9L26 22 24 9 22 9 24.52 23 27.48 23 30 9 28 9zM18 23H14a2 2 0 01-2-2V11a2 2 0 012-2h4a2 2 0 012 2V21A2 2 0 0118 23zM14 11V21h4V11zM8 9L6.49 14 6 15.98 5.54 14 4 9 2 9 2 23 4 23 4 15 3.84 13 4.42 15 6 19.63 7.58 15 8.16 13 8 15 8 23 10 23 10 9 8 9z"
  })), children);
});
var Mov20 = /*#__PURE__*/React.forwardRef(function Mov20(_ref94, ref) {
  var children = _ref94.children,
      rest = _objectWithoutProperties(_ref94, _excluded94);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M28 9L26 22 24 9 22 9 24.52 23 27.48 23 30 9 28 9zM18 23H14a2 2 0 01-2-2V11a2 2 0 012-2h4a2 2 0 012 2V21A2 2 0 0118 23zM14 11V21h4V11zM8 9L6.49 14 6 15.98 5.54 14 4 9 2 9 2 23 4 23 4 15 3.84 13 4.42 15 6 19.63 7.58 15 8.16 13 8 15 8 23 10 23 10 9 8 9z"
  })), children);
});
var Mov16 = /*#__PURE__*/React.forwardRef(function Mov16(_ref95, ref) {
  var children = _ref95.children,
      rest = _objectWithoutProperties(_ref95, _excluded95);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M28 9L26 22 24 9 22 9 24.52 23 27.48 23 30 9 28 9zM18 23H14a2 2 0 01-2-2V11a2 2 0 012-2h4a2 2 0 012 2V21A2 2 0 0118 23zM14 11V21h4V11zM8 9L6.49 14 6 15.98 5.54 14 4 9 2 9 2 23 4 23 4 15 3.84 13 4.42 15 6 19.63 7.58 15 8.16 13 8 15 8 23 10 23 10 9 8 9z"
  })), children);
});
var Move32 = /*#__PURE__*/React.forwardRef(function Move32(_ref96, ref) {
  var children = _ref96.children,
      rest = _objectWithoutProperties(_ref96, _excluded96);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M25 11L23.59 12.41 26.17 15 17 15 17 5.83 19.59 8.41 21 7 16 2 11 7 12.41 8.41 15 5.83 15 15 5.83 15 8.41 12.41 7 11 2 16 7 21 8.41 19.59 5.83 17 15 17 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17 17 17 26.17 17 23.59 19.59 25 21 30 16 25 11z"
  })), children);
});
var Move24 = /*#__PURE__*/React.forwardRef(function Move24(_ref97, ref) {
  var children = _ref97.children,
      rest = _objectWithoutProperties(_ref97, _excluded97);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M25 11L23.59 12.41 26.17 15 17 15 17 5.83 19.59 8.41 21 7 16 2 11 7 12.41 8.41 15 5.83 15 15 5.83 15 8.41 12.41 7 11 2 16 7 21 8.41 19.59 5.83 17 15 17 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17 17 17 26.17 17 23.59 19.59 25 21 30 16 25 11z"
  })), children);
});
var Move20 = /*#__PURE__*/React.forwardRef(function Move20(_ref98, ref) {
  var children = _ref98.children,
      rest = _objectWithoutProperties(_ref98, _excluded98);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M25 11L23.59 12.41 26.17 15 17 15 17 5.83 19.59 8.41 21 7 16 2 11 7 12.41 8.41 15 5.83 15 15 5.83 15 8.41 12.41 7 11 2 16 7 21 8.41 19.59 5.83 17 15 17 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17 17 17 26.17 17 23.59 19.59 25 21 30 16 25 11z"
  })), children);
});
var Move16 = /*#__PURE__*/React.forwardRef(function Move16(_ref99, ref) {
  var children = _ref99.children,
      rest = _objectWithoutProperties(_ref99, _excluded99);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M25 11L23.59 12.41 26.17 15 17 15 17 5.83 19.59 8.41 21 7 16 2 11 7 12.41 8.41 15 5.83 15 15 5.83 15 8.41 12.41 7 11 2 16 7 21 8.41 19.59 5.83 17 15 17 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17 17 17 26.17 17 23.59 19.59 25 21 30 16 25 11z"
  })), children);
});
var Movement32 = /*#__PURE__*/React.forwardRef(function Movement32(_ref100, ref) {
  var children = _ref100.children,
      rest = _objectWithoutProperties(_ref100, _excluded100);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M24,20l-1.41,1.41L26.17,25H10a4,4,0,0,1,0-8H22A6,6,0,0,0,22,5H5.83L9.41,1.41,8,0,2,6l6,6,1.41-1.41L5.83,7H22a4,4,0,0,1,0,8H10a6,6,0,0,0,0,12H26.17l-3.58,3.59L24,32l6-6Z"
  })), children);
});
var Movement24 = /*#__PURE__*/React.forwardRef(function Movement24(_ref101, ref) {
  var children = _ref101.children,
      rest = _objectWithoutProperties(_ref101, _excluded101);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M24,20l-1.41,1.41L26.17,25H10a4,4,0,0,1,0-8H22A6,6,0,0,0,22,5H5.83L9.41,1.41,8,0,2,6l6,6,1.41-1.41L5.83,7H22a4,4,0,0,1,0,8H10a6,6,0,0,0,0,12H26.17l-3.58,3.59L24,32l6-6Z"
  })), children);
});
var Movement20 = /*#__PURE__*/React.forwardRef(function Movement20(_ref102, ref) {
  var children = _ref102.children,
      rest = _objectWithoutProperties(_ref102, _excluded102);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M24,20l-1.41,1.41L26.17,25H10a4,4,0,0,1,0-8H22A6,6,0,0,0,22,5H5.83L9.41,1.41,8,0,2,6l6,6,1.41-1.41L5.83,7H22a4,4,0,0,1,0,8H10a6,6,0,0,0,0,12H26.17l-3.58,3.59L24,32l6-6Z"
  })), children);
});
var Movement16 = /*#__PURE__*/React.forwardRef(function Movement16(_ref103, ref) {
  var children = _ref103.children,
      rest = _objectWithoutProperties(_ref103, _excluded103);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M24,20l-1.41,1.41L26.17,25H10a4,4,0,0,1,0-8H22A6,6,0,0,0,22,5H5.83L9.41,1.41,8,0,2,6l6,6,1.41-1.41L5.83,7H22a4,4,0,0,1,0,8H10a6,6,0,0,0,0,12H26.17l-3.58,3.59L24,32l6-6Z"
  })), children);
});
var Mp332 = /*#__PURE__*/React.forwardRef(function Mp332(_ref104, ref) {
  var children = _ref104.children,
      rest = _objectWithoutProperties(_ref104, _excluded104);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M28 9H22v2h6v4H24v2h4v4H22v2h6a2 2 0 002-2V11A2 2 0 0028 9zM14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM8 9L6.49 14 6 15.98 5.54 14 4 9 2 9 2 23 4 23 4 15 3.84 13 4.42 15 6 19.63 7.58 15 8.16 13 8 15 8 23 10 23 10 9 8 9z"
  })), children);
});
var Mp324 = /*#__PURE__*/React.forwardRef(function Mp324(_ref105, ref) {
  var children = _ref105.children,
      rest = _objectWithoutProperties(_ref105, _excluded105);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M28 9H22v2h6v4H24v2h4v4H22v2h6a2 2 0 002-2V11A2 2 0 0028 9zM14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM8 9L6.49 14 6 15.98 5.54 14 4 9 2 9 2 23 4 23 4 15 3.84 13 4.42 15 6 19.63 7.58 15 8.16 13 8 15 8 23 10 23 10 9 8 9z"
  })), children);
});
var Mp320 = /*#__PURE__*/React.forwardRef(function Mp320(_ref106, ref) {
  var children = _ref106.children,
      rest = _objectWithoutProperties(_ref106, _excluded106);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M28 9H22v2h6v4H24v2h4v4H22v2h6a2 2 0 002-2V11A2 2 0 0028 9zM14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM8 9L6.49 14 6 15.98 5.54 14 4 9 2 9 2 23 4 23 4 15 3.84 13 4.42 15 6 19.63 7.58 15 8.16 13 8 15 8 23 10 23 10 9 8 9z"
  })), children);
});
var Mp316 = /*#__PURE__*/React.forwardRef(function Mp316(_ref107, ref) {
  var children = _ref107.children,
      rest = _objectWithoutProperties(_ref107, _excluded107);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M28 9H22v2h6v4H24v2h4v4H22v2h6a2 2 0 002-2V11A2 2 0 0028 9zM14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM8 9L6.49 14 6 15.98 5.54 14 4 9 2 9 2 23 4 23 4 15 3.84 13 4.42 15 6 19.63 7.58 15 8.16 13 8 15 8 23 10 23 10 9 8 9z"
  })), children);
});
var Mp432 = /*#__PURE__*/React.forwardRef(function Mp432(_ref108, ref) {
  var children = _ref108.children,
      rest = _objectWithoutProperties(_ref108, _excluded108);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M28 10v8h0V10m1-1H27v8H24V9H22V19h5v4h2V19h1V17H29V9zM14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM8 9L6.49 14 6 15.98 5.54 14 4 9 2 9 2 23 4 23 4 15 3.84 13 4.42 15 6 19.63 7.58 15 8.16 13 8 15 8 23 10 23 10 9 8 9z"
  })), children);
});
var Mp424 = /*#__PURE__*/React.forwardRef(function Mp424(_ref109, ref) {
  var children = _ref109.children,
      rest = _objectWithoutProperties(_ref109, _excluded109);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M28 10v8h0V10m1-1H27v8H24V9H22V19h5v4h2V19h1V17H29V9zM14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM8 9L6.49 14 6 15.98 5.54 14 4 9 2 9 2 23 4 23 4 15 3.84 13 4.42 15 6 19.63 7.58 15 8.16 13 8 15 8 23 10 23 10 9 8 9z"
  })), children);
});
var Mp420 = /*#__PURE__*/React.forwardRef(function Mp420(_ref110, ref) {
  var children = _ref110.children,
      rest = _objectWithoutProperties(_ref110, _excluded110);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M28 10v8h0V10m1-1H27v8H24V9H22V19h5v4h2V19h1V17H29V9zM14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM8 9L6.49 14 6 15.98 5.54 14 4 9 2 9 2 23 4 23 4 15 3.84 13 4.42 15 6 19.63 7.58 15 8.16 13 8 15 8 23 10 23 10 9 8 9z"
  })), children);
});
var Mp416 = /*#__PURE__*/React.forwardRef(function Mp416(_ref111, ref) {
  var children = _ref111.children,
      rest = _objectWithoutProperties(_ref111, _excluded111);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M28 10v8h0V10m1-1H27v8H24V9H22V19h5v4h2V19h1V17H29V9zM14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM8 9L6.49 14 6 15.98 5.54 14 4 9 2 9 2 23 4 23 4 15 3.84 13 4.42 15 6 19.63 7.58 15 8.16 13 8 15 8 23 10 23 10 9 8 9z"
  })), children);
});
var Mpeg32 = /*#__PURE__*/React.forwardRef(function Mpeg32(_ref112, ref) {
  var children = _ref112.children,
      rest = _objectWithoutProperties(_ref112, _excluded112);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M32 21H28a2.0023 2.0023 0 01-2-2V13a2.002 2.002 0 012-2h4v2H28v6h2V17H29l0-2h3zM24 13L24 11.024 18 11.024 18 21 24 21 24 19 20 19 20 17 22 17 22 15 20 15 20 13 24 13zM14 11H9V21h2V18h3a2.0027 2.0027 0 002-2V13A2.0023 2.0023 0 0014 11zm-3 5V13h3l.001 3zM7 11L5 11 3.5 15 2 11 0 11 0 21 2 21 2 14 3.5 18 5 14 5 21 7 21 7 11z"
  })), children);
});
var Mpeg24 = /*#__PURE__*/React.forwardRef(function Mpeg24(_ref113, ref) {
  var children = _ref113.children,
      rest = _objectWithoutProperties(_ref113, _excluded113);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M32 21H28a2.0023 2.0023 0 01-2-2V13a2.002 2.002 0 012-2h4v2H28v6h2V17H29l0-2h3zM24 13L24 11.024 18 11.024 18 21 24 21 24 19 20 19 20 17 22 17 22 15 20 15 20 13 24 13zM14 11H9V21h2V18h3a2.0027 2.0027 0 002-2V13A2.0023 2.0023 0 0014 11zm-3 5V13h3l.001 3zM7 11L5 11 3.5 15 2 11 0 11 0 21 2 21 2 14 3.5 18 5 14 5 21 7 21 7 11z"
  })), children);
});
var Mpeg20 = /*#__PURE__*/React.forwardRef(function Mpeg20(_ref114, ref) {
  var children = _ref114.children,
      rest = _objectWithoutProperties(_ref114, _excluded114);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M32 21H28a2.0023 2.0023 0 01-2-2V13a2.002 2.002 0 012-2h4v2H28v6h2V17H29l0-2h3zM24 13L24 11.024 18 11.024 18 21 24 21 24 19 20 19 20 17 22 17 22 15 20 15 20 13 24 13zM14 11H9V21h2V18h3a2.0027 2.0027 0 002-2V13A2.0023 2.0023 0 0014 11zm-3 5V13h3l.001 3zM7 11L5 11 3.5 15 2 11 0 11 0 21 2 21 2 14 3.5 18 5 14 5 21 7 21 7 11z"
  })), children);
});
var Mpeg16 = /*#__PURE__*/React.forwardRef(function Mpeg16(_ref115, ref) {
  var children = _ref115.children,
      rest = _objectWithoutProperties(_ref115, _excluded115);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M32 21H28a2.0023 2.0023 0 01-2-2V13a2.002 2.002 0 012-2h4v2H28v6h2V17H29l0-2h3zM24 13L24 11.024 18 11.024 18 21 24 21 24 19 20 19 20 17 22 17 22 15 20 15 20 13 24 13zM14 11H9V21h2V18h3a2.0027 2.0027 0 002-2V13A2.0023 2.0023 0 0014 11zm-3 5V13h3l.001 3zM7 11L5 11 3.5 15 2 11 0 11 0 21 2 21 2 14 3.5 18 5 14 5 21 7 21 7 11z"
  })), children);
});
var Mpg232 = /*#__PURE__*/React.forwardRef(function Mpg232(_ref116, ref) {
  var children = _ref116.children,
      rest = _objectWithoutProperties(_ref116, _excluded116);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M32 21H26V17a2.002 2.002 0 012-2h2V13H26V11h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H28v2h4zM24 21H20a2.0023 2.0023 0 01-2-2V13a2.002 2.002 0 012-2h4v2H20v6h2V17H21l0-2h3zM14 11H9V21h2V18h3a2.0027 2.0027 0 002-2V13A2.0023 2.0023 0 0014 11zm-3 5V13h3l.001 3zM7 11L5 11 3.5 15 2 11 0 11 0 21 2 21 2 14 3.5 18 5 14 5 21 7 21 7 11z"
  })), children);
});
var Mpg224 = /*#__PURE__*/React.forwardRef(function Mpg224(_ref117, ref) {
  var children = _ref117.children,
      rest = _objectWithoutProperties(_ref117, _excluded117);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M32 21H26V17a2.002 2.002 0 012-2h2V13H26V11h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H28v2h4zM24 21H20a2.0023 2.0023 0 01-2-2V13a2.002 2.002 0 012-2h4v2H20v6h2V17H21l0-2h3zM14 11H9V21h2V18h3a2.0027 2.0027 0 002-2V13A2.0023 2.0023 0 0014 11zm-3 5V13h3l.001 3zM7 11L5 11 3.5 15 2 11 0 11 0 21 2 21 2 14 3.5 18 5 14 5 21 7 21 7 11z"
  })), children);
});
var Mpg220 = /*#__PURE__*/React.forwardRef(function Mpg220(_ref118, ref) {
  var children = _ref118.children,
      rest = _objectWithoutProperties(_ref118, _excluded118);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M32 21H26V17a2.002 2.002 0 012-2h2V13H26V11h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H28v2h4zM24 21H20a2.0023 2.0023 0 01-2-2V13a2.002 2.002 0 012-2h4v2H20v6h2V17H21l0-2h3zM14 11H9V21h2V18h3a2.0027 2.0027 0 002-2V13A2.0023 2.0023 0 0014 11zm-3 5V13h3l.001 3zM7 11L5 11 3.5 15 2 11 0 11 0 21 2 21 2 14 3.5 18 5 14 5 21 7 21 7 11z"
  })), children);
});
var Mpg216 = /*#__PURE__*/React.forwardRef(function Mpg216(_ref119, ref) {
  var children = _ref119.children,
      rest = _objectWithoutProperties(_ref119, _excluded119);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M32 21H26V17a2.002 2.002 0 012-2h2V13H26V11h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H28v2h4zM24 21H20a2.0023 2.0023 0 01-2-2V13a2.002 2.002 0 012-2h4v2H20v6h2V17H21l0-2h3zM14 11H9V21h2V18h3a2.0027 2.0027 0 002-2V13A2.0023 2.0023 0 0014 11zm-3 5V13h3l.001 3zM7 11L5 11 3.5 15 2 11 0 11 0 21 2 21 2 14 3.5 18 5 14 5 21 7 21 7 11z"
  })), children);
});
var Music32 = /*#__PURE__*/React.forwardRef(function Music32(_ref120, ref) {
  var children = _ref120.children,
      rest = _objectWithoutProperties(_ref120, _excluded120);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M25,4H10A2.002,2.002,0,0,0,8,6V20.5563A3.9551,3.9551,0,0,0,6,20a4,4,0,1,0,4,4V12H25v8.5562A3.9545,3.9545,0,0,0,23,20a4,4,0,1,0,4,4V6A2.0023,2.0023,0,0,0,25,4ZM6,26a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,26Zm17,0a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,23,26ZM10,6H25v4H10Z"
  })), children);
});
var Music24 = /*#__PURE__*/React.forwardRef(function Music24(_ref121, ref) {
  var children = _ref121.children,
      rest = _objectWithoutProperties(_ref121, _excluded121);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M25,4H10A2.002,2.002,0,0,0,8,6V20.5563A3.9551,3.9551,0,0,0,6,20a4,4,0,1,0,4,4V12H25v8.5562A3.9545,3.9545,0,0,0,23,20a4,4,0,1,0,4,4V6A2.0023,2.0023,0,0,0,25,4ZM6,26a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,26Zm17,0a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,23,26ZM10,6H25v4H10Z"
  })), children);
});
var Music20 = /*#__PURE__*/React.forwardRef(function Music20(_ref122, ref) {
  var children = _ref122.children,
      rest = _objectWithoutProperties(_ref122, _excluded122);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M25,4H10A2.002,2.002,0,0,0,8,6V20.5563A3.9551,3.9551,0,0,0,6,20a4,4,0,1,0,4,4V12H25v8.5562A3.9545,3.9545,0,0,0,23,20a4,4,0,1,0,4,4V6A2.0023,2.0023,0,0,0,25,4ZM6,26a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,26Zm17,0a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,23,26ZM10,6H25v4H10Z"
  })), children);
});
var Music16 = /*#__PURE__*/React.forwardRef(function Music16(_ref123, ref) {
  var children = _ref123.children,
      rest = _objectWithoutProperties(_ref123, _excluded123);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M25,4H10A2.002,2.002,0,0,0,8,6V20.5563A3.9551,3.9551,0,0,0,6,20a4,4,0,1,0,4,4V12H25v8.5562A3.9545,3.9545,0,0,0,23,20a4,4,0,1,0,4,4V6A2.0023,2.0023,0,0,0,25,4ZM6,26a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,26Zm17,0a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,23,26ZM10,6H25v4H10Z"
  })), children);
});
var MusicAdd32 = /*#__PURE__*/React.forwardRef(function MusicAdd32(_ref124, ref) {
  var children = _ref124.children,
      rest = _objectWithoutProperties(_ref124, _excluded124);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M30 6L26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6zM24 15v7.5562A3.9552 3.9552 0 0022 22a4 4 0 104 4V15zM22 28a2 2 0 112-2A2.0027 2.0027 0 0122 28zM17 6H10A2.002 2.002 0 008 8V22.5562A3.9557 3.9557 0 006 22a4 4 0 104 4V8h7zM6 28a2 2 0 112-2A2.0023 2.0023 0 016 28z"
  })), children);
});
var MusicAdd24 = /*#__PURE__*/React.forwardRef(function MusicAdd24(_ref125, ref) {
  var children = _ref125.children,
      rest = _objectWithoutProperties(_ref125, _excluded125);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M30 6L26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6zM24 15v7.5562A3.9552 3.9552 0 0022 22a4 4 0 104 4V15zM22 28a2 2 0 112-2A2.0027 2.0027 0 0122 28zM17 6H10A2.002 2.002 0 008 8V22.5562A3.9557 3.9557 0 006 22a4 4 0 104 4V8h7zM6 28a2 2 0 112-2A2.0023 2.0023 0 016 28z"
  })), children);
});
var MusicAdd20 = /*#__PURE__*/React.forwardRef(function MusicAdd20(_ref126, ref) {
  var children = _ref126.children,
      rest = _objectWithoutProperties(_ref126, _excluded126);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M30 6L26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6zM24 15v7.5562A3.9552 3.9552 0 0022 22a4 4 0 104 4V15zM22 28a2 2 0 112-2A2.0027 2.0027 0 0122 28zM17 6H10A2.002 2.002 0 008 8V22.5562A3.9557 3.9557 0 006 22a4 4 0 104 4V8h7zM6 28a2 2 0 112-2A2.0023 2.0023 0 016 28z"
  })), children);
});
var MusicAdd16 = /*#__PURE__*/React.forwardRef(function MusicAdd16(_ref127, ref) {
  var children = _ref127.children,
      rest = _objectWithoutProperties(_ref127, _excluded127);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M30 6L26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6zM24 15v7.5562A3.9552 3.9552 0 0022 22a4 4 0 104 4V15zM22 28a2 2 0 112-2A2.0027 2.0027 0 0122 28zM17 6H10A2.002 2.002 0 008 8V22.5562A3.9557 3.9557 0 006 22a4 4 0 104 4V8h7zM6 28a2 2 0 112-2A2.0023 2.0023 0 016 28z"
  })), children);
});
var MusicRemove32 = /*#__PURE__*/React.forwardRef(function MusicRemove32(_ref128, ref) {
  var children = _ref128.children,
      rest = _objectWithoutProperties(_ref128, _excluded128);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M26.41 7L30 3.41 28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7zM24 15v7.5562A3.9552 3.9552 0 0022 22a4 4 0 104 4V15zM22 28a2 2 0 112-2A2.0027 2.0027 0 0122 28zM17 6H10A2.002 2.002 0 008 8V22.5562A3.9557 3.9557 0 006 22a4 4 0 104 4V8h7zM6 28a2 2 0 112-2A2.0023 2.0023 0 016 28z"
  })), children);
});
var MusicRemove24 = /*#__PURE__*/React.forwardRef(function MusicRemove24(_ref129, ref) {
  var children = _ref129.children,
      rest = _objectWithoutProperties(_ref129, _excluded129);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M26.41 7L30 3.41 28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7zM24 15v7.5562A3.9552 3.9552 0 0022 22a4 4 0 104 4V15zM22 28a2 2 0 112-2A2.0027 2.0027 0 0122 28zM17 6H10A2.002 2.002 0 008 8V22.5562A3.9557 3.9557 0 006 22a4 4 0 104 4V8h7zM6 28a2 2 0 112-2A2.0023 2.0023 0 016 28z"
  })), children);
});
var MusicRemove20 = /*#__PURE__*/React.forwardRef(function MusicRemove20(_ref130, ref) {
  var children = _ref130.children,
      rest = _objectWithoutProperties(_ref130, _excluded130);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M26.41 7L30 3.41 28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7zM24 15v7.5562A3.9552 3.9552 0 0022 22a4 4 0 104 4V15zM22 28a2 2 0 112-2A2.0027 2.0027 0 0122 28zM17 6H10A2.002 2.002 0 008 8V22.5562A3.9557 3.9557 0 006 22a4 4 0 104 4V8h7zM6 28a2 2 0 112-2A2.0023 2.0023 0 016 28z"
  })), children);
});
var MusicRemove16 = /*#__PURE__*/React.forwardRef(function MusicRemove16(_ref131, ref) {
  var children = _ref131.children,
      rest = _objectWithoutProperties(_ref131, _excluded131);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M26.41 7L30 3.41 28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7zM24 15v7.5562A3.9552 3.9552 0 0022 22a4 4 0 104 4V15zM22 28a2 2 0 112-2A2.0027 2.0027 0 0122 28zM17 6H10A2.002 2.002 0 008 8V22.5562A3.9557 3.9557 0 006 22a4 4 0 104 4V8h7zM6 28a2 2 0 112-2A2.0023 2.0023 0 016 28z"
  })), children);
});
var Mysql32 = /*#__PURE__*/React.forwardRef(function Mysql32(_ref132, ref) {
  var children = _ref132.children,
      rest = _objectWithoutProperties(_ref132, _excluded132);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2471 11.9248h3.1748l-4.6465 13.938c-.3066.9351-.7402 1.6255-1.2998 2.0703-.5596.4443-1.3604.667-2.4033.667h-2.1162v-2.645h2.2773l.4141-1.334-4.2324-12.6963h3.3818l1.7705 5.6353.874 3.4961h.1377l.8975-3.4961 1.7705-5.6353zM14.2178 13.4658L14.1484 13.4658 12.9756 15.812 9.8477 21.4932 6.7891 15.835 5.5693 13.3052 5.501 13.3052 5.501 24 2.2119 24 2.2119 7.9458 5.915 7.9458 9.8477 15.4668 9.8936 15.4668 13.7812 7.9458 17.5068 7.9458 17.5068 24 14.2178 24 14.2178 13.4658z"
  })), children);
});
var Mysql24 = /*#__PURE__*/React.forwardRef(function Mysql24(_ref133, ref) {
  var children = _ref133.children,
      rest = _objectWithoutProperties(_ref133, _excluded133);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2471 11.9248h3.1748l-4.6465 13.938c-.3066.9351-.7402 1.6255-1.2998 2.0703-.5596.4443-1.3604.667-2.4033.667h-2.1162v-2.645h2.2773l.4141-1.334-4.2324-12.6963h3.3818l1.7705 5.6353.874 3.4961h.1377l.8975-3.4961 1.7705-5.6353zM14.2178 13.4658L14.1484 13.4658 12.9756 15.812 9.8477 21.4932 6.7891 15.835 5.5693 13.3052 5.501 13.3052 5.501 24 2.2119 24 2.2119 7.9458 5.915 7.9458 9.8477 15.4668 9.8936 15.4668 13.7812 7.9458 17.5068 7.9458 17.5068 24 14.2178 24 14.2178 13.4658z"
  })), children);
});
var Mysql20 = /*#__PURE__*/React.forwardRef(function Mysql20(_ref134, ref) {
  var children = _ref134.children,
      rest = _objectWithoutProperties(_ref134, _excluded134);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2471 11.9248h3.1748l-4.6465 13.938c-.3066.9351-.7402 1.6255-1.2998 2.0703-.5596.4443-1.3604.667-2.4033.667h-2.1162v-2.645h2.2773l.4141-1.334-4.2324-12.6963h3.3818l1.7705 5.6353.874 3.4961h.1377l.8975-3.4961 1.7705-5.6353zM14.2178 13.4658L14.1484 13.4658 12.9756 15.812 9.8477 21.4932 6.7891 15.835 5.5693 13.3052 5.501 13.3052 5.501 24 2.2119 24 2.2119 7.9458 5.915 7.9458 9.8477 15.4668 9.8936 15.4668 13.7812 7.9458 17.5068 7.9458 17.5068 24 14.2178 24 14.2178 13.4658z"
  })), children);
});
var Mysql16 = /*#__PURE__*/React.forwardRef(function Mysql16(_ref135, ref) {
  var children = _ref135.children,
      rest = _objectWithoutProperties(_ref135, _excluded135);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2471 11.9248h3.1748l-4.6465 13.938c-.3066.9351-.7402 1.6255-1.2998 2.0703-.5596.4443-1.3604.667-2.4033.667h-2.1162v-2.645h2.2773l.4141-1.334-4.2324-12.6963h3.3818l1.7705 5.6353.874 3.4961h.1377l.8975-3.4961 1.7705-5.6353zM14.2178 13.4658L14.1484 13.4658 12.9756 15.812 9.8477 21.4932 6.7891 15.835 5.5693 13.3052 5.501 13.3052 5.501 24 2.2119 24 2.2119 7.9458 5.915 7.9458 9.8477 15.4668 9.8936 15.4668 13.7812 7.9458 17.5068 7.9458 17.5068 24 14.2178 24 14.2178 13.4658z"
  })), children);
});
var NameSpace32 = /*#__PURE__*/React.forwardRef(function NameSpace32(_ref136, ref) {
  var children = _ref136.children,
      rest = _objectWithoutProperties(_ref136, _excluded136);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12H4a2.0023 2.0023 0 01-2-2V6A2.0023 2.0023 0 014 4H7V6H4v4H7zM9 10H15V12H9zM17 10H23V12H17zM28 12H25V10h3V6H25V4h3a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0128 12zM17 4H23V6H17zM9 4H15V6H9zM28 28H4a2.0023 2.0023 0 01-2-2V22a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0128 28zM4 22v4H28V22zM2 15H30V17H2z"
  })), children);
});
var NameSpace24 = /*#__PURE__*/React.forwardRef(function NameSpace24(_ref137, ref) {
  var children = _ref137.children,
      rest = _objectWithoutProperties(_ref137, _excluded137);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12H4a2.0023 2.0023 0 01-2-2V6A2.0023 2.0023 0 014 4H7V6H4v4H7zM9 10H15V12H9zM17 10H23V12H17zM28 12H25V10h3V6H25V4h3a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0128 12zM17 4H23V6H17zM9 4H15V6H9zM28 28H4a2.0023 2.0023 0 01-2-2V22a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0128 28zM4 22v4H28V22zM2 15H30V17H2z"
  })), children);
});
var NameSpace20 = /*#__PURE__*/React.forwardRef(function NameSpace20(_ref138, ref) {
  var children = _ref138.children,
      rest = _objectWithoutProperties(_ref138, _excluded138);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12H4a2.0023 2.0023 0 01-2-2V6A2.0023 2.0023 0 014 4H7V6H4v4H7zM9 10H15V12H9zM17 10H23V12H17zM28 12H25V10h3V6H25V4h3a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0128 12zM17 4H23V6H17zM9 4H15V6H9zM28 28H4a2.0023 2.0023 0 01-2-2V22a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0128 28zM4 22v4H28V22zM2 15H30V17H2z"
  })), children);
});
var NameSpace16 = /*#__PURE__*/React.forwardRef(function NameSpace16(_ref139, ref) {
  var children = _ref139.children,
      rest = _objectWithoutProperties(_ref139, _excluded139);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12H4a2.0023 2.0023 0 01-2-2V6A2.0023 2.0023 0 014 4H7V6H4v4H7zM9 10H15V12H9zM17 10H23V12H17zM28 12H25V10h3V6H25V4h3a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0128 12zM17 4H23V6H17zM9 4H15V6H9zM28 28H4a2.0023 2.0023 0 01-2-2V22a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0128 28zM4 22v4H28V22zM2 15H30V17H2z"
  })), children);
});
var NavaidCivil32 = /*#__PURE__*/React.forwardRef(function NavaidCivil32(_ref140, ref) {
  var children = _ref140.children,
      rest = _objectWithoutProperties(_ref140, _excluded140);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M30,14H27.8193A12.0112,12.0112,0,0,0,18,4.1807V2H14V4.1807A12.0112,12.0112,0,0,0,4.1807,14H2v4H4.1807A12.0112,12.0112,0,0,0,14,27.8193V30h4V27.8193A12.0112,12.0112,0,0,0,27.8193,18H30ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
  })), children);
});
var NavaidCivil24 = /*#__PURE__*/React.forwardRef(function NavaidCivil24(_ref141, ref) {
  var children = _ref141.children,
      rest = _objectWithoutProperties(_ref141, _excluded141);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M30,14H27.8193A12.0112,12.0112,0,0,0,18,4.1807V2H14V4.1807A12.0112,12.0112,0,0,0,4.1807,14H2v4H4.1807A12.0112,12.0112,0,0,0,14,27.8193V30h4V27.8193A12.0112,12.0112,0,0,0,27.8193,18H30ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
  })), children);
});
var NavaidCivil20 = /*#__PURE__*/React.forwardRef(function NavaidCivil20(_ref142, ref) {
  var children = _ref142.children,
      rest = _objectWithoutProperties(_ref142, _excluded142);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M30,14H27.8193A12.0112,12.0112,0,0,0,18,4.1807V2H14V4.1807A12.0112,12.0112,0,0,0,4.1807,14H2v4H4.1807A12.0112,12.0112,0,0,0,14,27.8193V30h4V27.8193A12.0112,12.0112,0,0,0,27.8193,18H30ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
  })), children);
});
var NavaidCivil16 = /*#__PURE__*/React.forwardRef(function NavaidCivil16(_ref143, ref) {
  var children = _ref143.children,
      rest = _objectWithoutProperties(_ref143, _excluded143);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M30,14H27.8193A12.0112,12.0112,0,0,0,18,4.1807V2H14V4.1807A12.0112,12.0112,0,0,0,4.1807,14H2v4H4.1807A12.0112,12.0112,0,0,0,14,27.8193V30h4V27.8193A12.0112,12.0112,0,0,0,27.8193,18H30ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
  })), children);
});
var NavaidDme32 = /*#__PURE__*/React.forwardRef(function NavaidDme32(_ref144, ref) {
  var children = _ref144.children,
      rest = _objectWithoutProperties(_ref144, _excluded144);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,16,14Z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M24,24H8a2.0021,2.0021,0,0,1-2-2V10A2.0021,2.0021,0,0,1,8,8H24a2.0021,2.0021,0,0,1,2,2V22A2.0021,2.0021,0,0,1,24,24ZM8,10V22H24V10Z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M28,28H4a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,4,4H28a2.0021,2.0021,0,0,1,2,2V26A2.0021,2.0021,0,0,1,28,28ZM4,6V26H28V6Z"
  })), children);
});
var NavaidDme24 = /*#__PURE__*/React.forwardRef(function NavaidDme24(_ref145, ref) {
  var children = _ref145.children,
      rest = _objectWithoutProperties(_ref145, _excluded145);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,16,14Z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M24,24H8a2.0021,2.0021,0,0,1-2-2V10A2.0021,2.0021,0,0,1,8,8H24a2.0021,2.0021,0,0,1,2,2V22A2.0021,2.0021,0,0,1,24,24ZM8,10V22H24V10Z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M28,28H4a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,4,4H28a2.0021,2.0021,0,0,1,2,2V26A2.0021,2.0021,0,0,1,28,28ZM4,6V26H28V6Z"
  })), children);
});
var NavaidDme20 = /*#__PURE__*/React.forwardRef(function NavaidDme20(_ref146, ref) {
  var children = _ref146.children,
      rest = _objectWithoutProperties(_ref146, _excluded146);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,16,14Z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M24,24H8a2.0021,2.0021,0,0,1-2-2V10A2.0021,2.0021,0,0,1,8,8H24a2.0021,2.0021,0,0,1,2,2V22A2.0021,2.0021,0,0,1,24,24ZM8,10V22H24V10Z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M28,28H4a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,4,4H28a2.0021,2.0021,0,0,1,2,2V26A2.0021,2.0021,0,0,1,28,28ZM4,6V26H28V6Z"
  })), children);
});
var NavaidDme16 = /*#__PURE__*/React.forwardRef(function NavaidDme16(_ref147, ref) {
  var children = _ref147.children,
      rest = _objectWithoutProperties(_ref147, _excluded147);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,16,14Z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M24,24H8a2.0021,2.0021,0,0,1-2-2V10A2.0021,2.0021,0,0,1,8,8H24a2.0021,2.0021,0,0,1,2,2V22A2.0021,2.0021,0,0,1,24,24ZM8,10V22H24V10Z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M28,28H4a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,4,4H28a2.0021,2.0021,0,0,1,2,2V26A2.0021,2.0021,0,0,1,28,28ZM4,6V26H28V6Z"
  })), children);
});
var NavaidHelipad32 = /*#__PURE__*/React.forwardRef(function NavaidHelipad32(_ref148, ref) {
  var children = _ref148.children,
      rest = _objectWithoutProperties(_ref148, _excluded148);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9L18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
var NavaidHelipad24 = /*#__PURE__*/React.forwardRef(function NavaidHelipad24(_ref149, ref) {
  var children = _ref149.children,
      rest = _objectWithoutProperties(_ref149, _excluded149);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9L18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
var NavaidHelipad20 = /*#__PURE__*/React.forwardRef(function NavaidHelipad20(_ref150, ref) {
  var children = _ref150.children,
      rest = _objectWithoutProperties(_ref150, _excluded150);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9L18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
var NavaidHelipad16 = /*#__PURE__*/React.forwardRef(function NavaidHelipad16(_ref151, ref) {
  var children = _ref151.children,
      rest = _objectWithoutProperties(_ref151, _excluded151);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9L18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
var NavaidMilitary32 = /*#__PURE__*/React.forwardRef(function NavaidMilitary32(_ref152, ref) {
  var children = _ref152.children,
      rest = _objectWithoutProperties(_ref152, _excluded152);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Zm0-14a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,10Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), children);
});
var NavaidMilitary24 = /*#__PURE__*/React.forwardRef(function NavaidMilitary24(_ref153, ref) {
  var children = _ref153.children,
      rest = _objectWithoutProperties(_ref153, _excluded153);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Zm0-14a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,10Z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), children);
});
var NavaidMilitary20 = /*#__PURE__*/React.forwardRef(function NavaidMilitary20(_ref154, ref) {
  var children = _ref154.children,
      rest = _objectWithoutProperties(_ref154, _excluded154);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Zm0-14a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,10Z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), children);
});
var NavaidMilitary16 = /*#__PURE__*/React.forwardRef(function NavaidMilitary16(_ref155, ref) {
  var children = _ref155.children,
      rest = _objectWithoutProperties(_ref155, _excluded155);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Zm0-14a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,10Z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), children);
});
var NavaidMilitaryCivil32 = /*#__PURE__*/React.forwardRef(function NavaidMilitaryCivil32(_ref156, ref) {
  var children = _ref156.children,
      rest = _objectWithoutProperties(_ref156, _excluded156);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Zm0-14a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,10Z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M30,14H27.8193A12.0112,12.0112,0,0,0,18,4.1807V2H14V4.1807A12.0112,12.0112,0,0,0,4.1807,14H2v4H4.1807A12.0112,12.0112,0,0,0,14,27.8193V30h4V27.8193A12.0112,12.0112,0,0,0,27.8193,18H30ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
  })), children);
});
var NavaidMilitaryCivil24 = /*#__PURE__*/React.forwardRef(function NavaidMilitaryCivil24(_ref157, ref) {
  var children = _ref157.children,
      rest = _objectWithoutProperties(_ref157, _excluded157);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Zm0-14a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,10Z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M30,14H27.8193A12.0112,12.0112,0,0,0,18,4.1807V2H14V4.1807A12.0112,12.0112,0,0,0,4.1807,14H2v4H4.1807A12.0112,12.0112,0,0,0,14,27.8193V30h4V27.8193A12.0112,12.0112,0,0,0,27.8193,18H30ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
  })), children);
});
var NavaidMilitaryCivil20 = /*#__PURE__*/React.forwardRef(function NavaidMilitaryCivil20(_ref158, ref) {
  var children = _ref158.children,
      rest = _objectWithoutProperties(_ref158, _excluded158);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Zm0-14a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,10Z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M30,14H27.8193A12.0112,12.0112,0,0,0,18,4.1807V2H14V4.1807A12.0112,12.0112,0,0,0,4.1807,14H2v4H4.1807A12.0112,12.0112,0,0,0,14,27.8193V30h4V27.8193A12.0112,12.0112,0,0,0,27.8193,18H30ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
  })), children);
});
var NavaidMilitaryCivil16 = /*#__PURE__*/React.forwardRef(function NavaidMilitaryCivil16(_ref159, ref) {
  var children = _ref159.children,
      rest = _objectWithoutProperties(_ref159, _excluded159);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Zm0-14a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,10Z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M30,14H27.8193A12.0112,12.0112,0,0,0,18,4.1807V2H14V4.1807A12.0112,12.0112,0,0,0,4.1807,14H2v4H4.1807A12.0112,12.0112,0,0,0,14,27.8193V30h4V27.8193A12.0112,12.0112,0,0,0,27.8193,18H30ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
  })), children);
});
var NavaidNdb32 = /*#__PURE__*/React.forwardRef(function NavaidNdb32(_ref160, ref) {
  var children = _ref160.children,
      rest = _objectWithoutProperties(_ref160, _excluded160);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Zm0-14a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,10Z"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "4",
    r: "2"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "28",
    r: "2"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: "28",
    cy: "16",
    r: "2"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "16",
    r: "2"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: "7.515",
    cy: "7.515",
    r: "2"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: "24.485",
    cy: "24.485",
    r: "2"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: "24.485",
    cy: "7.515",
    r: "2"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: "7.515",
    cy: "24.485",
    r: "2"
  })), children);
});
var NavaidNdb24 = /*#__PURE__*/React.forwardRef(function NavaidNdb24(_ref161, ref) {
  var children = _ref161.children,
      rest = _objectWithoutProperties(_ref161, _excluded161);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Zm0-14a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,10Z"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "4",
    r: "2"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "28",
    r: "2"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: "28",
    cy: "16",
    r: "2"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "16",
    r: "2"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: "7.515",
    cy: "7.515",
    r: "2"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: "24.485",
    cy: "24.485",
    r: "2"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: "24.485",
    cy: "7.515",
    r: "2"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: "7.515",
    cy: "24.485",
    r: "2"
  })), children);
});
var NavaidNdb20 = /*#__PURE__*/React.forwardRef(function NavaidNdb20(_ref162, ref) {
  var children = _ref162.children,
      rest = _objectWithoutProperties(_ref162, _excluded162);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Zm0-14a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,10Z"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "4",
    r: "2"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "28",
    r: "2"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: "28",
    cy: "16",
    r: "2"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "16",
    r: "2"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: "7.515",
    cy: "7.515",
    r: "2"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: "24.485",
    cy: "24.485",
    r: "2"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: "24.485",
    cy: "7.515",
    r: "2"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: "7.515",
    cy: "24.485",
    r: "2"
  })), children);
});
var NavaidNdb16 = /*#__PURE__*/React.forwardRef(function NavaidNdb16(_ref163, ref) {
  var children = _ref163.children,
      rest = _objectWithoutProperties(_ref163, _excluded163);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Zm0-14a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,10Z"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "4",
    r: "2"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "28",
    r: "2"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: "28",
    cy: "16",
    r: "2"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "16",
    r: "2"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: "7.515",
    cy: "7.515",
    r: "2"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: "24.485",
    cy: "24.485",
    r: "2"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: "24.485",
    cy: "7.515",
    r: "2"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: "7.515",
    cy: "24.485",
    r: "2"
  })), children);
});
var NavaidNdbDme32 = /*#__PURE__*/React.forwardRef(function NavaidNdbDme32(_ref164, ref) {
  var children = _ref164.children,
      rest = _objectWithoutProperties(_ref164, _excluded164);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12H2V4A2.0021 2.0021 0 014 2h8V4H4zM12 30H4a2.0021 2.0021 0 01-2-2V20H4v8h8zM28 30H20V28h8V20h2v8A2.0021 2.0021 0 0128 30zM30 12H28V4H20V2h8a2.0021 2.0021 0 012 2zM16 22a6 6 0 116-6A6.0067 6.0067 0 0116 22zm0-10a4 4 0 104 4A4.0045 4.0045 0 0016 12z"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "7",
    r: "1"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "3",
    r: "1"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "25",
    r: "1"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "29",
    r: "1"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "16",
    r: "1"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: "29",
    cy: "16",
    r: "1"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "16",
    r: "1"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "16",
    r: "1"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: "9.636",
    cy: "9.636",
    r: "1"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "7",
    r: "1"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: "22.364",
    cy: "22.364",
    r: "1"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "25",
    r: "1"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: "22.364",
    cy: "9.636",
    r: "1"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "7",
    r: "1"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: "9.636",
    cy: "22.364",
    r: "1"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "25",
    r: "1"
  })), children);
});
var NavaidNdbDme24 = /*#__PURE__*/React.forwardRef(function NavaidNdbDme24(_ref165, ref) {
  var children = _ref165.children,
      rest = _objectWithoutProperties(_ref165, _excluded165);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12H2V4A2.0021 2.0021 0 014 2h8V4H4zM12 30H4a2.0021 2.0021 0 01-2-2V20H4v8h8zM28 30H20V28h8V20h2v8A2.0021 2.0021 0 0128 30zM30 12H28V4H20V2h8a2.0021 2.0021 0 012 2zM16 22a6 6 0 116-6A6.0067 6.0067 0 0116 22zm0-10a4 4 0 104 4A4.0045 4.0045 0 0016 12z"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "7",
    r: "1"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "3",
    r: "1"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "25",
    r: "1"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "29",
    r: "1"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "16",
    r: "1"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: "29",
    cy: "16",
    r: "1"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "16",
    r: "1"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "16",
    r: "1"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: "9.636",
    cy: "9.636",
    r: "1"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "7",
    r: "1"
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: "22.364",
    cy: "22.364",
    r: "1"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "25",
    r: "1"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: "22.364",
    cy: "9.636",
    r: "1"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "7",
    r: "1"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: "9.636",
    cy: "22.364",
    r: "1"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "25",
    r: "1"
  })), children);
});
var NavaidNdbDme20 = /*#__PURE__*/React.forwardRef(function NavaidNdbDme20(_ref166, ref) {
  var children = _ref166.children,
      rest = _objectWithoutProperties(_ref166, _excluded166);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12H2V4A2.0021 2.0021 0 014 2h8V4H4zM12 30H4a2.0021 2.0021 0 01-2-2V20H4v8h8zM28 30H20V28h8V20h2v8A2.0021 2.0021 0 0128 30zM30 12H28V4H20V2h8a2.0021 2.0021 0 012 2zM16 22a6 6 0 116-6A6.0067 6.0067 0 0116 22zm0-10a4 4 0 104 4A4.0045 4.0045 0 0016 12z"
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "7",
    r: "1"
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "3",
    r: "1"
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "25",
    r: "1"
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "29",
    r: "1"
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "16",
    r: "1"
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    cx: "29",
    cy: "16",
    r: "1"
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "16",
    r: "1"
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "16",
    r: "1"
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    cx: "9.636",
    cy: "9.636",
    r: "1"
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "7",
    r: "1"
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    cx: "22.364",
    cy: "22.364",
    r: "1"
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "25",
    r: "1"
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    cx: "22.364",
    cy: "9.636",
    r: "1"
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "7",
    r: "1"
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    cx: "9.636",
    cy: "22.364",
    r: "1"
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "25",
    r: "1"
  })), children);
});
var NavaidNdbDme16 = /*#__PURE__*/React.forwardRef(function NavaidNdbDme16(_ref167, ref) {
  var children = _ref167.children,
      rest = _objectWithoutProperties(_ref167, _excluded167);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12H2V4A2.0021 2.0021 0 014 2h8V4H4zM12 30H4a2.0021 2.0021 0 01-2-2V20H4v8h8zM28 30H20V28h8V20h2v8A2.0021 2.0021 0 0128 30zM30 12H28V4H20V2h8a2.0021 2.0021 0 012 2zM16 22a6 6 0 116-6A6.0067 6.0067 0 0116 22zm0-10a4 4 0 104 4A4.0045 4.0045 0 0016 12z"
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "7",
    r: "1"
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "3",
    r: "1"
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "25",
    r: "1"
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "29",
    r: "1"
  })), _circle101 || (_circle101 = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "16",
    r: "1"
  })), _circle102 || (_circle102 = /*#__PURE__*/React.createElement("circle", {
    cx: "29",
    cy: "16",
    r: "1"
  })), _circle103 || (_circle103 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "16",
    r: "1"
  })), _circle104 || (_circle104 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "16",
    r: "1"
  })), _circle105 || (_circle105 = /*#__PURE__*/React.createElement("circle", {
    cx: "9.636",
    cy: "9.636",
    r: "1"
  })), _circle106 || (_circle106 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "7",
    r: "1"
  })), _circle107 || (_circle107 = /*#__PURE__*/React.createElement("circle", {
    cx: "22.364",
    cy: "22.364",
    r: "1"
  })), _circle108 || (_circle108 = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "25",
    r: "1"
  })), _circle109 || (_circle109 = /*#__PURE__*/React.createElement("circle", {
    cx: "22.364",
    cy: "9.636",
    r: "1"
  })), _circle110 || (_circle110 = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "7",
    r: "1"
  })), _circle111 || (_circle111 = /*#__PURE__*/React.createElement("circle", {
    cx: "9.636",
    cy: "22.364",
    r: "1"
  })), _circle112 || (_circle112 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "25",
    r: "1"
  })), children);
});
var NavaidPrivate32 = /*#__PURE__*/React.forwardRef(function NavaidPrivate32(_ref168, ref) {
  var children = _ref168.children,
      rest = _objectWithoutProperties(_ref168, _excluded168);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M20,15V11a2.0023,2.0023,0,0,0-2-2H12V23h2V17h1.4807l2.3345,6H19.96l-2.333-6H18A2.0027,2.0027,0,0,0,20,15Zm-6-4h4v4H14Z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
var NavaidPrivate24 = /*#__PURE__*/React.forwardRef(function NavaidPrivate24(_ref169, ref) {
  var children = _ref169.children,
      rest = _objectWithoutProperties(_ref169, _excluded169);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M20,15V11a2.0023,2.0023,0,0,0-2-2H12V23h2V17h1.4807l2.3345,6H19.96l-2.333-6H18A2.0027,2.0027,0,0,0,20,15Zm-6-4h4v4H14Z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
var NavaidPrivate20 = /*#__PURE__*/React.forwardRef(function NavaidPrivate20(_ref170, ref) {
  var children = _ref170.children,
      rest = _objectWithoutProperties(_ref170, _excluded170);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M20,15V11a2.0023,2.0023,0,0,0-2-2H12V23h2V17h1.4807l2.3345,6H19.96l-2.333-6H18A2.0027,2.0027,0,0,0,20,15Zm-6-4h4v4H14Z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
var NavaidPrivate16 = /*#__PURE__*/React.forwardRef(function NavaidPrivate16(_ref171, ref) {
  var children = _ref171.children,
      rest = _objectWithoutProperties(_ref171, _excluded171);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M20,15V11a2.0023,2.0023,0,0,0-2-2H12V23h2V17h1.4807l2.3345,6H19.96l-2.333-6H18A2.0027,2.0027,0,0,0,20,15Zm-6-4h4v4H14Z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
var NavaidSeaplane32 = /*#__PURE__*/React.forwardRef(function NavaidSeaplane32(_ref172, ref) {
  var children = _ref172.children,
      rest = _objectWithoutProperties(_ref172, _excluded172);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M20,18a3.9962,3.9962,0,0,1-3,3.8579V17h2V15H17V13.8159a3.0007,3.0007,0,1,0-2,0V15H13v2h2v4.8579A3.9962,3.9962,0,0,1,12,18H10a6,6,0,0,0,12,0Zm-4-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,16,10Z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M30,14H27.8193A12.0112,12.0112,0,0,0,18,4.1807V2H14V4.1807A12.0112,12.0112,0,0,0,4.1807,14H2v4H4.1807A12.0112,12.0112,0,0,0,14,27.8193V30h4V27.8193A12.0112,12.0112,0,0,0,27.8193,18H30ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
  })), children);
});
var NavaidSeaplane24 = /*#__PURE__*/React.forwardRef(function NavaidSeaplane24(_ref173, ref) {
  var children = _ref173.children,
      rest = _objectWithoutProperties(_ref173, _excluded173);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M20,18a3.9962,3.9962,0,0,1-3,3.8579V17h2V15H17V13.8159a3.0007,3.0007,0,1,0-2,0V15H13v2h2v4.8579A3.9962,3.9962,0,0,1,12,18H10a6,6,0,0,0,12,0Zm-4-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,16,10Z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M30,14H27.8193A12.0112,12.0112,0,0,0,18,4.1807V2H14V4.1807A12.0112,12.0112,0,0,0,4.1807,14H2v4H4.1807A12.0112,12.0112,0,0,0,14,27.8193V30h4V27.8193A12.0112,12.0112,0,0,0,27.8193,18H30ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
  })), children);
});
var NavaidSeaplane20 = /*#__PURE__*/React.forwardRef(function NavaidSeaplane20(_ref174, ref) {
  var children = _ref174.children,
      rest = _objectWithoutProperties(_ref174, _excluded174);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M20,18a3.9962,3.9962,0,0,1-3,3.8579V17h2V15H17V13.8159a3.0007,3.0007,0,1,0-2,0V15H13v2h2v4.8579A3.9962,3.9962,0,0,1,12,18H10a6,6,0,0,0,12,0Zm-4-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,16,10Z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M30,14H27.8193A12.0112,12.0112,0,0,0,18,4.1807V2H14V4.1807A12.0112,12.0112,0,0,0,4.1807,14H2v4H4.1807A12.0112,12.0112,0,0,0,14,27.8193V30h4V27.8193A12.0112,12.0112,0,0,0,27.8193,18H30ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
  })), children);
});
var NavaidSeaplane16 = /*#__PURE__*/React.forwardRef(function NavaidSeaplane16(_ref175, ref) {
  var children = _ref175.children,
      rest = _objectWithoutProperties(_ref175, _excluded175);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M20,18a3.9962,3.9962,0,0,1-3,3.8579V17h2V15H17V13.8159a3.0007,3.0007,0,1,0-2,0V15H13v2h2v4.8579A3.9962,3.9962,0,0,1,12,18H10a6,6,0,0,0,12,0Zm-4-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,16,10Z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M30,14H27.8193A12.0112,12.0112,0,0,0,18,4.1807V2H14V4.1807A12.0112,12.0112,0,0,0,4.1807,14H2v4H4.1807A12.0112,12.0112,0,0,0,14,27.8193V30h4V27.8193A12.0112,12.0112,0,0,0,27.8193,18H30ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
  })), children);
});
var NavaidTacan32 = /*#__PURE__*/React.forwardRef(function NavaidTacan32(_ref176, ref) {
  var children = _ref176.children,
      rest = _objectWithoutProperties(_ref176, _excluded176);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle113 || (_circle113 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "14",
    r: "2"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M20,28H12a1,1,0,0,1-1-1V21.2656L7.2612,14.7231,2.4854,11.8574a1,1,0,0,1-.3536-1.3535l4-7a1,1,0,0,1,1.3828-.3613L12.2769,6h7.4462l4.7623-2.8574a1,1,0,0,1,1.3828.3613l4,7a1,1,0,0,1-.3536,1.3535l-4.7758,2.8657L21,21.2656V27A1,1,0,0,1,20,28Zm-7-2h6V20.7346l4.2616-7.4578,4.3844-2.6306L24.6387,5.3831,20.277,8H11.723L7.3613,5.3831,4.354,10.6462l4.3844,2.6306L13,20.7346Z"
  })), children);
});
var NavaidTacan24 = /*#__PURE__*/React.forwardRef(function NavaidTacan24(_ref177, ref) {
  var children = _ref177.children,
      rest = _objectWithoutProperties(_ref177, _excluded177);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle114 || (_circle114 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "14",
    r: "2"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M20,28H12a1,1,0,0,1-1-1V21.2656L7.2612,14.7231,2.4854,11.8574a1,1,0,0,1-.3536-1.3535l4-7a1,1,0,0,1,1.3828-.3613L12.2769,6h7.4462l4.7623-2.8574a1,1,0,0,1,1.3828.3613l4,7a1,1,0,0,1-.3536,1.3535l-4.7758,2.8657L21,21.2656V27A1,1,0,0,1,20,28Zm-7-2h6V20.7346l4.2616-7.4578,4.3844-2.6306L24.6387,5.3831,20.277,8H11.723L7.3613,5.3831,4.354,10.6462l4.3844,2.6306L13,20.7346Z"
  })), children);
});
var NavaidTacan20 = /*#__PURE__*/React.forwardRef(function NavaidTacan20(_ref178, ref) {
  var children = _ref178.children,
      rest = _objectWithoutProperties(_ref178, _excluded178);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle115 || (_circle115 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "14",
    r: "2"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M20,28H12a1,1,0,0,1-1-1V21.2656L7.2612,14.7231,2.4854,11.8574a1,1,0,0,1-.3536-1.3535l4-7a1,1,0,0,1,1.3828-.3613L12.2769,6h7.4462l4.7623-2.8574a1,1,0,0,1,1.3828.3613l4,7a1,1,0,0,1-.3536,1.3535l-4.7758,2.8657L21,21.2656V27A1,1,0,0,1,20,28Zm-7-2h6V20.7346l4.2616-7.4578,4.3844-2.6306L24.6387,5.3831,20.277,8H11.723L7.3613,5.3831,4.354,10.6462l4.3844,2.6306L13,20.7346Z"
  })), children);
});
var NavaidTacan16 = /*#__PURE__*/React.forwardRef(function NavaidTacan16(_ref179, ref) {
  var children = _ref179.children,
      rest = _objectWithoutProperties(_ref179, _excluded179);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle116 || (_circle116 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "14",
    r: "2"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M20,28H12a1,1,0,0,1-1-1V21.2656L7.2612,14.7231,2.4854,11.8574a1,1,0,0,1-.3536-1.3535l4-7a1,1,0,0,1,1.3828-.3613L12.2769,6h7.4462l4.7623-2.8574a1,1,0,0,1,1.3828.3613l4,7a1,1,0,0,1-.3536,1.3535l-4.7758,2.8657L21,21.2656V27A1,1,0,0,1,20,28Zm-7-2h6V20.7346l4.2616-7.4578,4.3844-2.6306L24.6387,5.3831,20.277,8H11.723L7.3613,5.3831,4.354,10.6462l4.3844,2.6306L13,20.7346Z"
  })), children);
});
var NavaidVhfor32 = /*#__PURE__*/React.forwardRef(function NavaidVhfor32(_ref180, ref) {
  var children = _ref180.children,
      rest = _objectWithoutProperties(_ref180, _excluded180);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M22,28H10a1,1,0,0,1-.8438-.4631l-7-11a1,1,0,0,1,0-1.0738l7-11A1,1,0,0,1,10,4H22a1,1,0,0,1,.8438.4631l7,11a1,1,0,0,1,0,1.0738l-7,11A1,1,0,0,1,22,28ZM10.5488,26H21.4512l6.3633-10L21.4512,6H10.5488L4.1855,16Z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5,24h-7a1.0005,1.0005,0,0,1-.8413-.4592l-4.5-7a1.0016,1.0016,0,0,1,0-1.0816l4.5-7A1.0005,1.0005,0,0,1,12.5,8h7a1.0005,1.0005,0,0,1,.8413.4592l4.5,7a1.0016,1.0016,0,0,1,0,1.0816l-4.5,7A1.0005,1.0005,0,0,1,19.5,24Zm-6.4541-2h5.9082l3.8569-6-3.8569-6H13.0459L9.189,16Z"
  })), children);
});
var NavaidVhfor24 = /*#__PURE__*/React.forwardRef(function NavaidVhfor24(_ref181, ref) {
  var children = _ref181.children,
      rest = _objectWithoutProperties(_ref181, _excluded181);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M22,28H10a1,1,0,0,1-.8438-.4631l-7-11a1,1,0,0,1,0-1.0738l7-11A1,1,0,0,1,10,4H22a1,1,0,0,1,.8438.4631l7,11a1,1,0,0,1,0,1.0738l-7,11A1,1,0,0,1,22,28ZM10.5488,26H21.4512l6.3633-10L21.4512,6H10.5488L4.1855,16Z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5,24h-7a1.0005,1.0005,0,0,1-.8413-.4592l-4.5-7a1.0016,1.0016,0,0,1,0-1.0816l4.5-7A1.0005,1.0005,0,0,1,12.5,8h7a1.0005,1.0005,0,0,1,.8413.4592l4.5,7a1.0016,1.0016,0,0,1,0,1.0816l-4.5,7A1.0005,1.0005,0,0,1,19.5,24Zm-6.4541-2h5.9082l3.8569-6-3.8569-6H13.0459L9.189,16Z"
  })), children);
});
var NavaidVhfor20 = /*#__PURE__*/React.forwardRef(function NavaidVhfor20(_ref182, ref) {
  var children = _ref182.children,
      rest = _objectWithoutProperties(_ref182, _excluded182);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M22,28H10a1,1,0,0,1-.8438-.4631l-7-11a1,1,0,0,1,0-1.0738l7-11A1,1,0,0,1,10,4H22a1,1,0,0,1,.8438.4631l7,11a1,1,0,0,1,0,1.0738l-7,11A1,1,0,0,1,22,28ZM10.5488,26H21.4512l6.3633-10L21.4512,6H10.5488L4.1855,16Z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5,24h-7a1.0005,1.0005,0,0,1-.8413-.4592l-4.5-7a1.0016,1.0016,0,0,1,0-1.0816l4.5-7A1.0005,1.0005,0,0,1,12.5,8h7a1.0005,1.0005,0,0,1,.8413.4592l4.5,7a1.0016,1.0016,0,0,1,0,1.0816l-4.5,7A1.0005,1.0005,0,0,1,19.5,24Zm-6.4541-2h5.9082l3.8569-6-3.8569-6H13.0459L9.189,16Z"
  })), children);
});
var NavaidVhfor16 = /*#__PURE__*/React.forwardRef(function NavaidVhfor16(_ref183, ref) {
  var children = _ref183.children,
      rest = _objectWithoutProperties(_ref183, _excluded183);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M22,28H10a1,1,0,0,1-.8438-.4631l-7-11a1,1,0,0,1,0-1.0738l7-11A1,1,0,0,1,10,4H22a1,1,0,0,1,.8438.4631l7,11a1,1,0,0,1,0,1.0738l-7,11A1,1,0,0,1,22,28ZM10.5488,26H21.4512l6.3633-10L21.4512,6H10.5488L4.1855,16Z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5,24h-7a1.0005,1.0005,0,0,1-.8413-.4592l-4.5-7a1.0016,1.0016,0,0,1,0-1.0816l4.5-7A1.0005,1.0005,0,0,1,12.5,8h7a1.0005,1.0005,0,0,1,.8413.4592l4.5,7a1.0016,1.0016,0,0,1,0,1.0816l-4.5,7A1.0005,1.0005,0,0,1,19.5,24Zm-6.4541-2h5.9082l3.8569-6-3.8569-6H13.0459L9.189,16Z"
  })), children);
});
var NavaidVor32 = /*#__PURE__*/React.forwardRef(function NavaidVor32(_ref184, ref) {
  var children = _ref184.children,
      rest = _objectWithoutProperties(_ref184, _excluded184);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle117 || (_circle117 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8638,15.4961l-7-12A1,1,0,0,0,23,3H9a1,1,0,0,0-.8638.4961l-7,12a1,1,0,0,0,0,1.0078l7,12A1,1,0,0,0,9,29H23a1,1,0,0,0,.8638-.4961l7-12a1,1,0,0,0,0-1.0078ZM22.4258,27H9.5742L3.1577,16,9.5742,5H22.4258l6.4165,11Z"
  })), children);
});
var NavaidVor24 = /*#__PURE__*/React.forwardRef(function NavaidVor24(_ref185, ref) {
  var children = _ref185.children,
      rest = _objectWithoutProperties(_ref185, _excluded185);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle118 || (_circle118 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8638,15.4961l-7-12A1,1,0,0,0,23,3H9a1,1,0,0,0-.8638.4961l-7,12a1,1,0,0,0,0,1.0078l7,12A1,1,0,0,0,9,29H23a1,1,0,0,0,.8638-.4961l7-12a1,1,0,0,0,0-1.0078ZM22.4258,27H9.5742L3.1577,16,9.5742,5H22.4258l6.4165,11Z"
  })), children);
});
var NavaidVor20 = /*#__PURE__*/React.forwardRef(function NavaidVor20(_ref186, ref) {
  var children = _ref186.children,
      rest = _objectWithoutProperties(_ref186, _excluded186);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle119 || (_circle119 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8638,15.4961l-7-12A1,1,0,0,0,23,3H9a1,1,0,0,0-.8638.4961l-7,12a1,1,0,0,0,0,1.0078l7,12A1,1,0,0,0,9,29H23a1,1,0,0,0,.8638-.4961l7-12a1,1,0,0,0,0-1.0078ZM22.4258,27H9.5742L3.1577,16,9.5742,5H22.4258l6.4165,11Z"
  })), children);
});
var NavaidVor16 = /*#__PURE__*/React.forwardRef(function NavaidVor16(_ref187, ref) {
  var children = _ref187.children,
      rest = _objectWithoutProperties(_ref187, _excluded187);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle120 || (_circle120 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8638,15.4961l-7-12A1,1,0,0,0,23,3H9a1,1,0,0,0-.8638.4961l-7,12a1,1,0,0,0,0,1.0078l7,12A1,1,0,0,0,9,29H23a1,1,0,0,0,.8638-.4961l7-12a1,1,0,0,0,0-1.0078ZM22.4258,27H9.5742L3.1577,16,9.5742,5H22.4258l6.4165,11Z"
  })), children);
});
var NavaidVordme32 = /*#__PURE__*/React.forwardRef(function NavaidVordme32(_ref188, ref) {
  var children = _ref188.children,
      rest = _objectWithoutProperties(_ref188, _excluded188);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle121 || (_circle121 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M30,6a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2Zm-2,6.9258L22.9636,6H28ZM27.7637,16,20.491,26H11.509L4.2363,16,11.509,6h8.982ZM9.0364,6,4,12.9248V6ZM4,19.0752,9.0364,26H4ZM22.9636,26l5.0374-6.9263L28,26Z"
  })), children);
});
var NavaidVordme24 = /*#__PURE__*/React.forwardRef(function NavaidVordme24(_ref189, ref) {
  var children = _ref189.children,
      rest = _objectWithoutProperties(_ref189, _excluded189);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle122 || (_circle122 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M30,6a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2Zm-2,6.9258L22.9636,6H28ZM27.7637,16,20.491,26H11.509L4.2363,16,11.509,6h8.982ZM9.0364,6,4,12.9248V6ZM4,19.0752,9.0364,26H4ZM22.9636,26l5.0374-6.9263L28,26Z"
  })), children);
});
var NavaidVordme20 = /*#__PURE__*/React.forwardRef(function NavaidVordme20(_ref190, ref) {
  var children = _ref190.children,
      rest = _objectWithoutProperties(_ref190, _excluded190);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle123 || (_circle123 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M30,6a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2Zm-2,6.9258L22.9636,6H28ZM27.7637,16,20.491,26H11.509L4.2363,16,11.509,6h8.982ZM9.0364,6,4,12.9248V6ZM4,19.0752,9.0364,26H4ZM22.9636,26l5.0374-6.9263L28,26Z"
  })), children);
});
var NavaidVordme16 = /*#__PURE__*/React.forwardRef(function NavaidVordme16(_ref191, ref) {
  var children = _ref191.children,
      rest = _objectWithoutProperties(_ref191, _excluded191);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle124 || (_circle124 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M30,6a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2Zm-2,6.9258L22.9636,6H28ZM27.7637,16,20.491,26H11.509L4.2363,16,11.509,6h8.982ZM9.0364,6,4,12.9248V6ZM4,19.0752,9.0364,26H4ZM22.9636,26l5.0374-6.9263L28,26Z"
  })), children);
});
var NavaidVortac32 = /*#__PURE__*/React.forwardRef(function NavaidVortac32(_ref192, ref) {
  var children = _ref192.children,
      rest = _objectWithoutProperties(_ref192, _excluded192);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle125 || (_circle125 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "14",
    r: "2"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8682,10.5039l-4-7a.9992.9992,0,0,0-1.3828-.3613L19.7231,6H12.2769L7.5146,3.1426a.9992.9992,0,0,0-1.3828.3613l-4,7a1,1,0,0,0,.3536,1.3535l4.7758,2.8657L11,21.2656V27a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V21.2656l3.7388-6.5425,4.7758-2.8657A1,1,0,0,0,29.8682,10.5039ZM18.8484,21H13.1516L8.5757,12.9922,11.4287,8h9.1426l2.853,4.9922Z"
  })), children);
});
var NavaidVortac24 = /*#__PURE__*/React.forwardRef(function NavaidVortac24(_ref193, ref) {
  var children = _ref193.children,
      rest = _objectWithoutProperties(_ref193, _excluded193);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle126 || (_circle126 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "14",
    r: "2"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8682,10.5039l-4-7a.9992.9992,0,0,0-1.3828-.3613L19.7231,6H12.2769L7.5146,3.1426a.9992.9992,0,0,0-1.3828.3613l-4,7a1,1,0,0,0,.3536,1.3535l4.7758,2.8657L11,21.2656V27a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V21.2656l3.7388-6.5425,4.7758-2.8657A1,1,0,0,0,29.8682,10.5039ZM18.8484,21H13.1516L8.5757,12.9922,11.4287,8h9.1426l2.853,4.9922Z"
  })), children);
});
var NavaidVortac20 = /*#__PURE__*/React.forwardRef(function NavaidVortac20(_ref194, ref) {
  var children = _ref194.children,
      rest = _objectWithoutProperties(_ref194, _excluded194);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle127 || (_circle127 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "14",
    r: "2"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8682,10.5039l-4-7a.9992.9992,0,0,0-1.3828-.3613L19.7231,6H12.2769L7.5146,3.1426a.9992.9992,0,0,0-1.3828.3613l-4,7a1,1,0,0,0,.3536,1.3535l4.7758,2.8657L11,21.2656V27a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V21.2656l3.7388-6.5425,4.7758-2.8657A1,1,0,0,0,29.8682,10.5039ZM18.8484,21H13.1516L8.5757,12.9922,11.4287,8h9.1426l2.853,4.9922Z"
  })), children);
});
var NavaidVortac16 = /*#__PURE__*/React.forwardRef(function NavaidVortac16(_ref195, ref) {
  var children = _ref195.children,
      rest = _objectWithoutProperties(_ref195, _excluded195);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle128 || (_circle128 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "14",
    r: "2"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8682,10.5039l-4-7a.9992.9992,0,0,0-1.3828-.3613L19.7231,6H12.2769L7.5146,3.1426a.9992.9992,0,0,0-1.3828.3613l-4,7a1,1,0,0,0,.3536,1.3535l4.7758,2.8657L11,21.2656V27a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V21.2656l3.7388-6.5425,4.7758-2.8657A1,1,0,0,0,29.8682,10.5039ZM18.8484,21H13.1516L8.5757,12.9922,11.4287,8h9.1426l2.853,4.9922Z"
  })), children);
});
var Need32 = /*#__PURE__*/React.forwardRef(function Need32(_ref196, ref) {
  var children = _ref196.children,
      rest = _objectWithoutProperties(_ref196, _excluded196);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1211 16.8789A2.98 2.98 0 0027.01 16H27a2.9774 2.9774 0 00-2.1211.8789L19.9778 21.78A2.9943 2.9943 0 0017 19H10a5.0059 5.0059 0 00-5 5v.667L2 28.6631l1.6 1.2L7 25.333V24a3.0033 3.0033 0 013-3h7a1 1 0 010 2H13v2h4.9287a3.9717 3.9717 0 002.8286-1.1719L26.293 18.293A.9929.9929 0 0127 18h.0034a1 1 0 01.7036 1.707l-7.414 7.4141A2.9791 2.9791 0 0118.1714 28H11v2h7.1714a4.9665 4.9665 0 003.5356-1.4648l7.4141-7.4141a2.9989 2.9989 0 000-4.2422zM21.586 8.586L18 12 18 2 16 2 16 12 12.414 8.586 11 10 17 16 23 10 21.586 8.586z"
  })), children);
});
var Need24 = /*#__PURE__*/React.forwardRef(function Need24(_ref197, ref) {
  var children = _ref197.children,
      rest = _objectWithoutProperties(_ref197, _excluded197);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1211 16.8789A2.98 2.98 0 0027.01 16H27a2.9774 2.9774 0 00-2.1211.8789L19.9778 21.78A2.9943 2.9943 0 0017 19H10a5.0059 5.0059 0 00-5 5v.667L2 28.6631l1.6 1.2L7 25.333V24a3.0033 3.0033 0 013-3h7a1 1 0 010 2H13v2h4.9287a3.9717 3.9717 0 002.8286-1.1719L26.293 18.293A.9929.9929 0 0127 18h.0034a1 1 0 01.7036 1.707l-7.414 7.4141A2.9791 2.9791 0 0118.1714 28H11v2h7.1714a4.9665 4.9665 0 003.5356-1.4648l7.4141-7.4141a2.9989 2.9989 0 000-4.2422zM21.586 8.586L18 12 18 2 16 2 16 12 12.414 8.586 11 10 17 16 23 10 21.586 8.586z"
  })), children);
});
var Need20 = /*#__PURE__*/React.forwardRef(function Need20(_ref198, ref) {
  var children = _ref198.children,
      rest = _objectWithoutProperties(_ref198, _excluded198);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1211 16.8789A2.98 2.98 0 0027.01 16H27a2.9774 2.9774 0 00-2.1211.8789L19.9778 21.78A2.9943 2.9943 0 0017 19H10a5.0059 5.0059 0 00-5 5v.667L2 28.6631l1.6 1.2L7 25.333V24a3.0033 3.0033 0 013-3h7a1 1 0 010 2H13v2h4.9287a3.9717 3.9717 0 002.8286-1.1719L26.293 18.293A.9929.9929 0 0127 18h.0034a1 1 0 01.7036 1.707l-7.414 7.4141A2.9791 2.9791 0 0118.1714 28H11v2h7.1714a4.9665 4.9665 0 003.5356-1.4648l7.4141-7.4141a2.9989 2.9989 0 000-4.2422zM21.586 8.586L18 12 18 2 16 2 16 12 12.414 8.586 11 10 17 16 23 10 21.586 8.586z"
  })), children);
});
var Need16 = /*#__PURE__*/React.forwardRef(function Need16(_ref199, ref) {
  var children = _ref199.children,
      rest = _objectWithoutProperties(_ref199, _excluded199);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1211 16.8789A2.98 2.98 0 0027.01 16H27a2.9774 2.9774 0 00-2.1211.8789L19.9778 21.78A2.9943 2.9943 0 0017 19H10a5.0059 5.0059 0 00-5 5v.667L2 28.6631l1.6 1.2L7 25.333V24a3.0033 3.0033 0 013-3h7a1 1 0 010 2H13v2h4.9287a3.9717 3.9717 0 002.8286-1.1719L26.293 18.293A.9929.9929 0 0127 18h.0034a1 1 0 01.7036 1.707l-7.414 7.4141A2.9791 2.9791 0 0118.1714 28H11v2h7.1714a4.9665 4.9665 0 003.5356-1.4648l7.4141-7.4141a2.9989 2.9989 0 000-4.2422zM21.586 8.586L18 12 18 2 16 2 16 12 12.414 8.586 11 10 17 16 23 10 21.586 8.586z"
  })), children);
});
var Network_132 = /*#__PURE__*/React.forwardRef(function Network_132(_ref200, ref) {
  var children = _ref200.children,
      rest = _objectWithoutProperties(_ref200, _excluded200);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20a4 4 0 114-4A4.0045 4.0045 0 0116 20zm0-6a2 2 0 102 2A2.0021 2.0021 0 0016 14zM5 20a4 4 0 114-4A4.0045 4.0045 0 015 20zm0-6a2 2 0 102 2A2.0023 2.0023 0 005 14zM10 31a4 4 0 114-4A4.0045 4.0045 0 0110 31zm0-6a2 2 0 102 2A2.0021 2.0021 0 0010 25zM22 31a4 4 0 114-4A4.0045 4.0045 0 0122 31zm0-6a2 2 0 102 2A2.0021 2.0021 0 0022 25zM27 20a4 4 0 114-4A4.0045 4.0045 0 0127 20zm0-6a2 2 0 102 2A2.0021 2.0021 0 0027 14zM22 9a4 4 0 114-4A4.0045 4.0045 0 0122 9zm0-6a2 2 0 102 2A2.0021 2.0021 0 0022 3zM10 9a4 4 0 114-4A4.0045 4.0045 0 0110 9zm0-6a2 2 0 102 2A2.0021 2.0021 0 0010 3z"
  })), children);
});
var Network_124 = /*#__PURE__*/React.forwardRef(function Network_124(_ref201, ref) {
  var children = _ref201.children,
      rest = _objectWithoutProperties(_ref201, _excluded201);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20a4 4 0 114-4A4.0045 4.0045 0 0116 20zm0-6a2 2 0 102 2A2.0021 2.0021 0 0016 14zM5 20a4 4 0 114-4A4.0045 4.0045 0 015 20zm0-6a2 2 0 102 2A2.0023 2.0023 0 005 14zM10 31a4 4 0 114-4A4.0045 4.0045 0 0110 31zm0-6a2 2 0 102 2A2.0021 2.0021 0 0010 25zM22 31a4 4 0 114-4A4.0045 4.0045 0 0122 31zm0-6a2 2 0 102 2A2.0021 2.0021 0 0022 25zM27 20a4 4 0 114-4A4.0045 4.0045 0 0127 20zm0-6a2 2 0 102 2A2.0021 2.0021 0 0027 14zM22 9a4 4 0 114-4A4.0045 4.0045 0 0122 9zm0-6a2 2 0 102 2A2.0021 2.0021 0 0022 3zM10 9a4 4 0 114-4A4.0045 4.0045 0 0110 9zm0-6a2 2 0 102 2A2.0021 2.0021 0 0010 3z"
  })), children);
});
var Network_120 = /*#__PURE__*/React.forwardRef(function Network_120(_ref202, ref) {
  var children = _ref202.children,
      rest = _objectWithoutProperties(_ref202, _excluded202);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20a4 4 0 114-4A4.0045 4.0045 0 0116 20zm0-6a2 2 0 102 2A2.0021 2.0021 0 0016 14zM5 20a4 4 0 114-4A4.0045 4.0045 0 015 20zm0-6a2 2 0 102 2A2.0023 2.0023 0 005 14zM10 31a4 4 0 114-4A4.0045 4.0045 0 0110 31zm0-6a2 2 0 102 2A2.0021 2.0021 0 0010 25zM22 31a4 4 0 114-4A4.0045 4.0045 0 0122 31zm0-6a2 2 0 102 2A2.0021 2.0021 0 0022 25zM27 20a4 4 0 114-4A4.0045 4.0045 0 0127 20zm0-6a2 2 0 102 2A2.0021 2.0021 0 0027 14zM22 9a4 4 0 114-4A4.0045 4.0045 0 0122 9zm0-6a2 2 0 102 2A2.0021 2.0021 0 0022 3zM10 9a4 4 0 114-4A4.0045 4.0045 0 0110 9zm0-6a2 2 0 102 2A2.0021 2.0021 0 0010 3z"
  })), children);
});
var Network_116 = /*#__PURE__*/React.forwardRef(function Network_116(_ref203, ref) {
  var children = _ref203.children,
      rest = _objectWithoutProperties(_ref203, _excluded203);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20a4 4 0 114-4A4.0045 4.0045 0 0116 20zm0-6a2 2 0 102 2A2.0021 2.0021 0 0016 14zM5 20a4 4 0 114-4A4.0045 4.0045 0 015 20zm0-6a2 2 0 102 2A2.0023 2.0023 0 005 14zM10 31a4 4 0 114-4A4.0045 4.0045 0 0110 31zm0-6a2 2 0 102 2A2.0021 2.0021 0 0010 25zM22 31a4 4 0 114-4A4.0045 4.0045 0 0122 31zm0-6a2 2 0 102 2A2.0021 2.0021 0 0022 25zM27 20a4 4 0 114-4A4.0045 4.0045 0 0127 20zm0-6a2 2 0 102 2A2.0021 2.0021 0 0027 14zM22 9a4 4 0 114-4A4.0045 4.0045 0 0122 9zm0-6a2 2 0 102 2A2.0021 2.0021 0 0022 3zM10 9a4 4 0 114-4A4.0045 4.0045 0 0110 9zm0-6a2 2 0 102 2A2.0021 2.0021 0 0010 3z"
  })), children);
});
var Network_232 = /*#__PURE__*/React.forwardRef(function Network_232(_ref204, ref) {
  var children = _ref204.children,
      rest = _objectWithoutProperties(_ref204, _excluded204);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M17,17h5.1421a4,4,0,1,0,0-2H17V7h5.1421a4,4,0,1,0,0-2H17a2.0023,2.0023,0,0,0-2,2v8H9.8579a4,4,0,1,0,0,2H15v8a2.0023,2.0023,0,0,0,2,2h5.1421a4,4,0,1,0,0-2H17Zm9-3a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,14ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM6,18a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,18Zm20,6a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,24Z"
  })), children);
});
var Network_224 = /*#__PURE__*/React.forwardRef(function Network_224(_ref205, ref) {
  var children = _ref205.children,
      rest = _objectWithoutProperties(_ref205, _excluded205);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M17,17h5.1421a4,4,0,1,0,0-2H17V7h5.1421a4,4,0,1,0,0-2H17a2.0023,2.0023,0,0,0-2,2v8H9.8579a4,4,0,1,0,0,2H15v8a2.0023,2.0023,0,0,0,2,2h5.1421a4,4,0,1,0,0-2H17Zm9-3a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,14ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM6,18a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,18Zm20,6a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,24Z"
  })), children);
});
var Network_220 = /*#__PURE__*/React.forwardRef(function Network_220(_ref206, ref) {
  var children = _ref206.children,
      rest = _objectWithoutProperties(_ref206, _excluded206);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M17,17h5.1421a4,4,0,1,0,0-2H17V7h5.1421a4,4,0,1,0,0-2H17a2.0023,2.0023,0,0,0-2,2v8H9.8579a4,4,0,1,0,0,2H15v8a2.0023,2.0023,0,0,0,2,2h5.1421a4,4,0,1,0,0-2H17Zm9-3a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,14ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM6,18a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,18Zm20,6a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,24Z"
  })), children);
});
var Network_216 = /*#__PURE__*/React.forwardRef(function Network_216(_ref207, ref) {
  var children = _ref207.children,
      rest = _objectWithoutProperties(_ref207, _excluded207);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M17,17h5.1421a4,4,0,1,0,0-2H17V7h5.1421a4,4,0,1,0,0-2H17a2.0023,2.0023,0,0,0-2,2v8H9.8579a4,4,0,1,0,0,2H15v8a2.0023,2.0023,0,0,0,2,2h5.1421a4,4,0,1,0,0-2H17Zm9-3a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,14ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM6,18a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,18Zm20,6a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,24Z"
  })), children);
});
var Network_332 = /*#__PURE__*/React.forwardRef(function Network_332(_ref208, ref) {
  var children = _ref208.children,
      rest = _objectWithoutProperties(_ref208, _excluded208);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M30 30H22V22h8zm-6-2h4V24H24zM20 27H8A6 6 0 018 15h2v2H8a4 4 0 000 8H20z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M20,20H12V12h8Zm-6-2h4V14H14Z"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M24 17H22V15h2a4 4 0 000-8H12V5H24a6 6 0 010 12zM10 10H2V2h8zM4 8H8V4H4z"
  })), children);
});
var Network_324 = /*#__PURE__*/React.forwardRef(function Network_324(_ref209, ref) {
  var children = _ref209.children,
      rest = _objectWithoutProperties(_ref209, _excluded209);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M30 30H22V22h8zm-6-2h4V24H24zM20 27H8A6 6 0 018 15h2v2H8a4 4 0 000 8H20z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M20,20H12V12h8Zm-6-2h4V14H14Z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M24 17H22V15h2a4 4 0 000-8H12V5H24a6 6 0 010 12zM10 10H2V2h8zM4 8H8V4H4z"
  })), children);
});
var Network_320 = /*#__PURE__*/React.forwardRef(function Network_320(_ref210, ref) {
  var children = _ref210.children,
      rest = _objectWithoutProperties(_ref210, _excluded210);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M30 30H22V22h8zm-6-2h4V24H24zM20 27H8A6 6 0 018 15h2v2H8a4 4 0 000 8H20z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M20,20H12V12h8Zm-6-2h4V14H14Z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M24 17H22V15h2a4 4 0 000-8H12V5H24a6 6 0 010 12zM10 10H2V2h8zM4 8H8V4H4z"
  })), children);
});
var Network_316 = /*#__PURE__*/React.forwardRef(function Network_316(_ref211, ref) {
  var children = _ref211.children,
      rest = _objectWithoutProperties(_ref211, _excluded211);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M30 30H22V22h8zm-6-2h4V24H24zM20 27H8A6 6 0 018 15h2v2H8a4 4 0 000 8H20z"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M20,20H12V12h8Zm-6-2h4V14H14Z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M24 17H22V15h2a4 4 0 000-8H12V5H24a6 6 0 010 12zM10 10H2V2h8zM4 8H8V4H4z"
  })), children);
});
var Network_3Reference32 = /*#__PURE__*/React.forwardRef(function Network_3Reference32(_ref212, ref) {
  var children = _ref212.children,
      rest = _objectWithoutProperties(_ref212, _excluded212);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM30 30H22V22h8zm-6-2h4V24H24zM20 20H12V12h8zm-6-2h4V14H14z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M24 17H22V15h2a4 4 0 000-8H12V5H24a6 6 0 010 12zM10 10H2V2h8zM4 8H8V4H4z"
  })), children);
});
var Network_3Reference24 = /*#__PURE__*/React.forwardRef(function Network_3Reference24(_ref213, ref) {
  var children = _ref213.children,
      rest = _objectWithoutProperties(_ref213, _excluded213);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM30 30H22V22h8zm-6-2h4V24H24zM20 20H12V12h8zm-6-2h4V14H14z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M24 17H22V15h2a4 4 0 000-8H12V5H24a6 6 0 010 12zM10 10H2V2h8zM4 8H8V4H4z"
  })), children);
});
var Network_3Reference20 = /*#__PURE__*/React.forwardRef(function Network_3Reference20(_ref214, ref) {
  var children = _ref214.children,
      rest = _objectWithoutProperties(_ref214, _excluded214);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM30 30H22V22h8zm-6-2h4V24H24zM20 20H12V12h8zm-6-2h4V14H14z"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M24 17H22V15h2a4 4 0 000-8H12V5H24a6 6 0 010 12zM10 10H2V2h8zM4 8H8V4H4z"
  })), children);
});
var Network_3Reference16 = /*#__PURE__*/React.forwardRef(function Network_3Reference16(_ref215, ref) {
  var children = _ref215.children,
      rest = _objectWithoutProperties(_ref215, _excluded215);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM30 30H22V22h8zm-6-2h4V24H24zM20 20H12V12h8zm-6-2h4V14H14z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M24 17H22V15h2a4 4 0 000-8H12V5H24a6 6 0 010 12zM10 10H2V2h8zM4 8H8V4H4z"
  })), children);
});
var Network_432 = /*#__PURE__*/React.forwardRef(function Network_432(_ref216, ref) {
  var children = _ref216.children,
      rest = _objectWithoutProperties(_ref216, _excluded216);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle129 || (_circle129 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "26",
    r: "2"
  })), _circle130 || (_circle130 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "6",
    r: "2"
  })), _circle131 || (_circle131 = /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "16",
    r: "2"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12a3.9962,3.9962,0,0,0-3.8579,3H19.8579a3.9655,3.9655,0,0,0-5.4914-2.6426L11.19,8.3872A3.9626,3.9626,0,0,0,12,6a4,4,0,1,0-4,4,3.96,3.96,0,0,0,1.6338-.3574l3.176,3.97a3.9239,3.9239,0,0,0,0,4.7744l-3.1758,3.97A3.96,3.96,0,0,0,8,22a4,4,0,1,0,4,4,3.9624,3.9624,0,0,0-.81-2.3872l3.1758-3.97A3.9658,3.9658,0,0,0,19.8579,17h4.2842A3.9934,3.9934,0,1,0,28,12ZM6,6A2,2,0,1,1,8,8,2.0023,2.0023,0,0,1,6,6ZM8,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,8,28Zm8-10a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,16,18Zm12,0a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,28,18Z"
  })), children);
});
var Network_424 = /*#__PURE__*/React.forwardRef(function Network_424(_ref217, ref) {
  var children = _ref217.children,
      rest = _objectWithoutProperties(_ref217, _excluded217);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle132 || (_circle132 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "26",
    r: "2"
  })), _circle133 || (_circle133 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "6",
    r: "2"
  })), _circle134 || (_circle134 = /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "16",
    r: "2"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12a3.9962,3.9962,0,0,0-3.8579,3H19.8579a3.9655,3.9655,0,0,0-5.4914-2.6426L11.19,8.3872A3.9626,3.9626,0,0,0,12,6a4,4,0,1,0-4,4,3.96,3.96,0,0,0,1.6338-.3574l3.176,3.97a3.9239,3.9239,0,0,0,0,4.7744l-3.1758,3.97A3.96,3.96,0,0,0,8,22a4,4,0,1,0,4,4,3.9624,3.9624,0,0,0-.81-2.3872l3.1758-3.97A3.9658,3.9658,0,0,0,19.8579,17h4.2842A3.9934,3.9934,0,1,0,28,12ZM6,6A2,2,0,1,1,8,8,2.0023,2.0023,0,0,1,6,6ZM8,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,8,28Zm8-10a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,16,18Zm12,0a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,28,18Z"
  })), children);
});
var Network_420 = /*#__PURE__*/React.forwardRef(function Network_420(_ref218, ref) {
  var children = _ref218.children,
      rest = _objectWithoutProperties(_ref218, _excluded218);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle135 || (_circle135 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "26",
    r: "2"
  })), _circle136 || (_circle136 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "6",
    r: "2"
  })), _circle137 || (_circle137 = /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "16",
    r: "2"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12a3.9962,3.9962,0,0,0-3.8579,3H19.8579a3.9655,3.9655,0,0,0-5.4914-2.6426L11.19,8.3872A3.9626,3.9626,0,0,0,12,6a4,4,0,1,0-4,4,3.96,3.96,0,0,0,1.6338-.3574l3.176,3.97a3.9239,3.9239,0,0,0,0,4.7744l-3.1758,3.97A3.96,3.96,0,0,0,8,22a4,4,0,1,0,4,4,3.9624,3.9624,0,0,0-.81-2.3872l3.1758-3.97A3.9658,3.9658,0,0,0,19.8579,17h4.2842A3.9934,3.9934,0,1,0,28,12ZM6,6A2,2,0,1,1,8,8,2.0023,2.0023,0,0,1,6,6ZM8,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,8,28Zm8-10a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,16,18Zm12,0a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,28,18Z"
  })), children);
});
var Network_416 = /*#__PURE__*/React.forwardRef(function Network_416(_ref219, ref) {
  var children = _ref219.children,
      rest = _objectWithoutProperties(_ref219, _excluded219);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle138 || (_circle138 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "26",
    r: "2"
  })), _circle139 || (_circle139 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "6",
    r: "2"
  })), _circle140 || (_circle140 = /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "16",
    r: "2"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12a3.9962,3.9962,0,0,0-3.8579,3H19.8579a3.9655,3.9655,0,0,0-5.4914-2.6426L11.19,8.3872A3.9626,3.9626,0,0,0,12,6a4,4,0,1,0-4,4,3.96,3.96,0,0,0,1.6338-.3574l3.176,3.97a3.9239,3.9239,0,0,0,0,4.7744l-3.1758,3.97A3.96,3.96,0,0,0,8,22a4,4,0,1,0,4,4,3.9624,3.9624,0,0,0-.81-2.3872l3.1758-3.97A3.9658,3.9658,0,0,0,19.8579,17h4.2842A3.9934,3.9934,0,1,0,28,12ZM6,6A2,2,0,1,1,8,8,2.0023,2.0023,0,0,1,6,6ZM8,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,8,28Zm8-10a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,16,18Zm12,0a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,28,18Z"
  })), children);
});
var Network_4Reference32 = /*#__PURE__*/React.forwardRef(function Network_4Reference32(_ref220, ref) {
  var children = _ref220.children,
      rest = _objectWithoutProperties(_ref220, _excluded220);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle141 || (_circle141 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "26",
    r: "2"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _circle142 || (_circle142 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "6",
    r: "2"
  })), _circle143 || (_circle143 = /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "16",
    r: "2"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12a3.9962,3.9962,0,0,0-3.8579,3H19.8579a3.9655,3.9655,0,0,0-5.4914-2.6426L11.19,8.3872A3.9624,3.9624,0,0,0,12,6a4,4,0,1,0-4,4,3.96,3.96,0,0,0,1.6338-.3574l3.176,3.97A3.9613,3.9613,0,0,0,12,16a3.9915,3.9915,0,0,0,7.8579,1h4.2842A3.9934,3.9934,0,1,0,28,12ZM8,8a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,8,8Zm8,10a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,16,18Zm12,0a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,28,18Z"
  })), children);
});
var Network_4Reference24 = /*#__PURE__*/React.forwardRef(function Network_4Reference24(_ref221, ref) {
  var children = _ref221.children,
      rest = _objectWithoutProperties(_ref221, _excluded221);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle144 || (_circle144 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "26",
    r: "2"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _circle145 || (_circle145 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "6",
    r: "2"
  })), _circle146 || (_circle146 = /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "16",
    r: "2"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12a3.9962,3.9962,0,0,0-3.8579,3H19.8579a3.9655,3.9655,0,0,0-5.4914-2.6426L11.19,8.3872A3.9624,3.9624,0,0,0,12,6a4,4,0,1,0-4,4,3.96,3.96,0,0,0,1.6338-.3574l3.176,3.97A3.9613,3.9613,0,0,0,12,16a3.9915,3.9915,0,0,0,7.8579,1h4.2842A3.9934,3.9934,0,1,0,28,12ZM8,8a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,8,8Zm8,10a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,16,18Zm12,0a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,28,18Z"
  })), children);
});
var Network_4Reference20 = /*#__PURE__*/React.forwardRef(function Network_4Reference20(_ref222, ref) {
  var children = _ref222.children,
      rest = _objectWithoutProperties(_ref222, _excluded222);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle147 || (_circle147 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "26",
    r: "2"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _circle148 || (_circle148 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "6",
    r: "2"
  })), _circle149 || (_circle149 = /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "16",
    r: "2"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12a3.9962,3.9962,0,0,0-3.8579,3H19.8579a3.9655,3.9655,0,0,0-5.4914-2.6426L11.19,8.3872A3.9624,3.9624,0,0,0,12,6a4,4,0,1,0-4,4,3.96,3.96,0,0,0,1.6338-.3574l3.176,3.97A3.9613,3.9613,0,0,0,12,16a3.9915,3.9915,0,0,0,7.8579,1h4.2842A3.9934,3.9934,0,1,0,28,12ZM8,8a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,8,8Zm8,10a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,16,18Zm12,0a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,28,18Z"
  })), children);
});
var Network_4Reference16 = /*#__PURE__*/React.forwardRef(function Network_4Reference16(_ref223, ref) {
  var children = _ref223.children,
      rest = _objectWithoutProperties(_ref223, _excluded223);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle150 || (_circle150 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "26",
    r: "2"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _circle151 || (_circle151 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "6",
    r: "2"
  })), _circle152 || (_circle152 = /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "16",
    r: "2"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12a3.9962,3.9962,0,0,0-3.8579,3H19.8579a3.9655,3.9655,0,0,0-5.4914-2.6426L11.19,8.3872A3.9624,3.9624,0,0,0,12,6a4,4,0,1,0-4,4,3.96,3.96,0,0,0,1.6338-.3574l3.176,3.97A3.9613,3.9613,0,0,0,12,16a3.9915,3.9915,0,0,0,7.8579,1h4.2842A3.9934,3.9934,0,1,0,28,12ZM8,8a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,8,8Zm8,10a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,16,18Zm12,0a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,28,18Z"
  })), children);
});
var NetworkAdminControl32 = /*#__PURE__*/React.forwardRef(function NetworkAdminControl32(_ref224, ref) {
  var children = _ref224.children,
      rest = _objectWithoutProperties(_ref224, _excluded224);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M27 20.415L25.586 19 23 21.587 20.414 19 19 20.415 21.586 23 19 25.586 20.414 27 23 24.414 25.586 27 27 25.586 24.414 23 27 20.415zM24 4a4.0045 4.0045 0 00-4 4 3.951 3.951 0 00.5669 2.019L10.019 20.5669A3.9521 3.9521 0 008 20a4 4 0 104 4 3.951 3.951 0 00-.5669-2.019L21.981 11.4331A3.9521 3.9521 0 0024 12a4 4 0 000-8zM8 26a2 2 0 112-2A2.0023 2.0023 0 018 26zM24 10a2 2 0 112-2A2.0023 2.0023 0 0124 10zM8 11.18L5.41 8.59 4 10 8 14 15 7 13.59 5.59 8 11.18z"
  })), children);
});
var NetworkAdminControl24 = /*#__PURE__*/React.forwardRef(function NetworkAdminControl24(_ref225, ref) {
  var children = _ref225.children,
      rest = _objectWithoutProperties(_ref225, _excluded225);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M27 20.415L25.586 19 23 21.587 20.414 19 19 20.415 21.586 23 19 25.586 20.414 27 23 24.414 25.586 27 27 25.586 24.414 23 27 20.415zM24 4a4.0045 4.0045 0 00-4 4 3.951 3.951 0 00.5669 2.019L10.019 20.5669A3.9521 3.9521 0 008 20a4 4 0 104 4 3.951 3.951 0 00-.5669-2.019L21.981 11.4331A3.9521 3.9521 0 0024 12a4 4 0 000-8zM8 26a2 2 0 112-2A2.0023 2.0023 0 018 26zM24 10a2 2 0 112-2A2.0023 2.0023 0 0124 10zM8 11.18L5.41 8.59 4 10 8 14 15 7 13.59 5.59 8 11.18z"
  })), children);
});
var NetworkAdminControl20 = /*#__PURE__*/React.forwardRef(function NetworkAdminControl20(_ref226, ref) {
  var children = _ref226.children,
      rest = _objectWithoutProperties(_ref226, _excluded226);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M27 20.415L25.586 19 23 21.587 20.414 19 19 20.415 21.586 23 19 25.586 20.414 27 23 24.414 25.586 27 27 25.586 24.414 23 27 20.415zM24 4a4.0045 4.0045 0 00-4 4 3.951 3.951 0 00.5669 2.019L10.019 20.5669A3.9521 3.9521 0 008 20a4 4 0 104 4 3.951 3.951 0 00-.5669-2.019L21.981 11.4331A3.9521 3.9521 0 0024 12a4 4 0 000-8zM8 26a2 2 0 112-2A2.0023 2.0023 0 018 26zM24 10a2 2 0 112-2A2.0023 2.0023 0 0124 10zM8 11.18L5.41 8.59 4 10 8 14 15 7 13.59 5.59 8 11.18z"
  })), children);
});
var NetworkAdminControl16 = /*#__PURE__*/React.forwardRef(function NetworkAdminControl16(_ref227, ref) {
  var children = _ref227.children,
      rest = _objectWithoutProperties(_ref227, _excluded227);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M27 20.415L25.586 19 23 21.587 20.414 19 19 20.415 21.586 23 19 25.586 20.414 27 23 24.414 25.586 27 27 25.586 24.414 23 27 20.415zM24 4a4.0045 4.0045 0 00-4 4 3.951 3.951 0 00.5669 2.019L10.019 20.5669A3.9521 3.9521 0 008 20a4 4 0 104 4 3.951 3.951 0 00-.5669-2.019L21.981 11.4331A3.9521 3.9521 0 0024 12a4 4 0 000-8zM8 26a2 2 0 112-2A2.0023 2.0023 0 018 26zM24 10a2 2 0 112-2A2.0023 2.0023 0 0124 10zM8 11.18L5.41 8.59 4 10 8 14 15 7 13.59 5.59 8 11.18z"
  })), children);
});
var NetworkEnterprise32 = /*#__PURE__*/React.forwardRef(function NetworkEnterprise32(_ref228, ref) {
  var children = _ref228.children,
      rest = _objectWithoutProperties(_ref228, _excluded228);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7983,10a10,10,0,0,0-19.62.124A7.4964,7.4964,0,0,0,7.5,25H8V23H7.5a5.4961,5.4961,0,0,1-.377-10.9795l.8365-.0571.09-.8335A7.9934,7.9934,0,0,1,23.7368,10Z"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12H18a2.0023,2.0023,0,0,0-2,2v4H12a2.0023,2.0023,0,0,0-2,2V30H30V14A2.0023,2.0023,0,0,0,28,12ZM12,28V20h4v8Zm16,0H18V14H28Z"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16H22V20H20zM24 16H26V20H24zM20 22H22V26H20zM24 22H26V26H24z"
  })), children);
});
var NetworkEnterprise24 = /*#__PURE__*/React.forwardRef(function NetworkEnterprise24(_ref229, ref) {
  var children = _ref229.children,
      rest = _objectWithoutProperties(_ref229, _excluded229);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7983,10a10,10,0,0,0-19.62.124A7.4964,7.4964,0,0,0,7.5,25H8V23H7.5a5.4961,5.4961,0,0,1-.377-10.9795l.8365-.0571.09-.8335A7.9934,7.9934,0,0,1,23.7368,10Z"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12H18a2.0023,2.0023,0,0,0-2,2v4H12a2.0023,2.0023,0,0,0-2,2V30H30V14A2.0023,2.0023,0,0,0,28,12ZM12,28V20h4v8Zm16,0H18V14H28Z"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16H22V20H20zM24 16H26V20H24zM20 22H22V26H20zM24 22H26V26H24z"
  })), children);
});
var NetworkEnterprise20 = /*#__PURE__*/React.forwardRef(function NetworkEnterprise20(_ref230, ref) {
  var children = _ref230.children,
      rest = _objectWithoutProperties(_ref230, _excluded230);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7983,10a10,10,0,0,0-19.62.124A7.4964,7.4964,0,0,0,7.5,25H8V23H7.5a5.4961,5.4961,0,0,1-.377-10.9795l.8365-.0571.09-.8335A7.9934,7.9934,0,0,1,23.7368,10Z"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12H18a2.0023,2.0023,0,0,0-2,2v4H12a2.0023,2.0023,0,0,0-2,2V30H30V14A2.0023,2.0023,0,0,0,28,12ZM12,28V20h4v8Zm16,0H18V14H28Z"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16H22V20H20zM24 16H26V20H24zM20 22H22V26H20zM24 22H26V26H24z"
  })), children);
});
var NetworkEnterprise16 = /*#__PURE__*/React.forwardRef(function NetworkEnterprise16(_ref231, ref) {
  var children = _ref231.children,
      rest = _objectWithoutProperties(_ref231, _excluded231);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7983,10a10,10,0,0,0-19.62.124A7.4964,7.4964,0,0,0,7.5,25H8V23H7.5a5.4961,5.4961,0,0,1-.377-10.9795l.8365-.0571.09-.8335A7.9934,7.9934,0,0,1,23.7368,10Z"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12H18a2.0023,2.0023,0,0,0-2,2v4H12a2.0023,2.0023,0,0,0-2,2V30H30V14A2.0023,2.0023,0,0,0,28,12ZM12,28V20h4v8Zm16,0H18V14H28Z"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16H22V20H20zM24 16H26V20H24zM20 22H22V26H20zM24 22H26V26H24z"
  })), children);
});
var NetworkOverlay32 = /*#__PURE__*/React.forwardRef(function NetworkOverlay32(_ref232, ref) {
  var children = _ref232.children,
      rest = _objectWithoutProperties(_ref232, _excluded232);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M22 23L13.83 23 16.41 20.41 15 19 10 24 15 29 16.41 27.59 13.83 25 22 25 22 23zM11 13L19.17 13 16.59 10.41 18 9 23 14 18 19 16.59 17.59 19.17 15 11 15 11 13z"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5,25H24V23h.5a5.4961,5.4961,0,0,0,.377-10.9795l-.8365-.0566-.09-.834a7.9979,7.9979,0,0,0-15.9014,0l-.09.834-.8365.0566A5.4961,5.4961,0,0,0,7.5,23H8v2H7.5A7.4964,7.4964,0,0,1,6.1782,10.124a9.9992,9.9992,0,0,1,19.6436,0A7.4964,7.4964,0,0,1,24.5,25Z"
  })), children);
});
var NetworkOverlay24 = /*#__PURE__*/React.forwardRef(function NetworkOverlay24(_ref233, ref) {
  var children = _ref233.children,
      rest = _objectWithoutProperties(_ref233, _excluded233);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M22 23L13.83 23 16.41 20.41 15 19 10 24 15 29 16.41 27.59 13.83 25 22 25 22 23zM11 13L19.17 13 16.59 10.41 18 9 23 14 18 19 16.59 17.59 19.17 15 11 15 11 13z"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5,25H24V23h.5a5.4961,5.4961,0,0,0,.377-10.9795l-.8365-.0566-.09-.834a7.9979,7.9979,0,0,0-15.9014,0l-.09.834-.8365.0566A5.4961,5.4961,0,0,0,7.5,23H8v2H7.5A7.4964,7.4964,0,0,1,6.1782,10.124a9.9992,9.9992,0,0,1,19.6436,0A7.4964,7.4964,0,0,1,24.5,25Z"
  })), children);
});
var NetworkOverlay20 = /*#__PURE__*/React.forwardRef(function NetworkOverlay20(_ref234, ref) {
  var children = _ref234.children,
      rest = _objectWithoutProperties(_ref234, _excluded234);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M22 23L13.83 23 16.41 20.41 15 19 10 24 15 29 16.41 27.59 13.83 25 22 25 22 23zM11 13L19.17 13 16.59 10.41 18 9 23 14 18 19 16.59 17.59 19.17 15 11 15 11 13z"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5,25H24V23h.5a5.4961,5.4961,0,0,0,.377-10.9795l-.8365-.0566-.09-.834a7.9979,7.9979,0,0,0-15.9014,0l-.09.834-.8365.0566A5.4961,5.4961,0,0,0,7.5,23H8v2H7.5A7.4964,7.4964,0,0,1,6.1782,10.124a9.9992,9.9992,0,0,1,19.6436,0A7.4964,7.4964,0,0,1,24.5,25Z"
  })), children);
});
var NetworkOverlay16 = /*#__PURE__*/React.forwardRef(function NetworkOverlay16(_ref235, ref) {
  var children = _ref235.children,
      rest = _objectWithoutProperties(_ref235, _excluded235);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M22 23L13.83 23 16.41 20.41 15 19 10 24 15 29 16.41 27.59 13.83 25 22 25 22 23zM11 13L19.17 13 16.59 10.41 18 9 23 14 18 19 16.59 17.59 19.17 15 11 15 11 13z"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5,25H24V23h.5a5.4961,5.4961,0,0,0,.377-10.9795l-.8365-.0566-.09-.834a7.9979,7.9979,0,0,0-15.9014,0l-.09.834-.8365.0566A5.4961,5.4961,0,0,0,7.5,23H8v2H7.5A7.4964,7.4964,0,0,1,6.1782,10.124a9.9992,9.9992,0,0,1,19.6436,0A7.4964,7.4964,0,0,1,24.5,25Z"
  })), children);
});
var NetworkPublic32 = /*#__PURE__*/React.forwardRef(function NetworkPublic32(_ref236, ref) {
  var children = _ref236.children,
      rest = _objectWithoutProperties(_ref236, _excluded236);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,13c-4.7,0-8.5,3.8-8.5,8.5s3.8,8.5,8.5,8.5s8.5-3.8,8.5-8.5S27.2,13,22.5,13z M29,21h-3c0-2-0.3-4-0.9-5.5\tC27.2,16.5,28.8,18.5,29,21z M22.5,28C22.5,28,22.5,28,22.5,28c-0.4-0.2-1.3-1.8-1.5-5h2.9C23.7,26.2,22.9,27.8,22.5,28z M21,21\tc0.1-3.8,1.1-5.8,1.4-6c0,0,0,0,0,0c0.4,0.2,1.4,2.2,1.5,6H21z M19.9,15.5C19.3,17,19.1,19,19,21h-3C16.2,18.5,17.8,16.5,19.9,15.5z M16.2,23H19c0.1,1.6,0.4,3.2,0.9,4.5C18.1,26.7,16.7,25,16.2,23z M25.1,27.5c0.5-1.3,0.8-2.8,0.9-4.5h2.9\tC28.3,25,26.9,26.7,25.1,27.5z"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8,10c-0.9-4.6-5-8-9.8-8c-4.8,0-8.9,3.4-9.8,8.1C2.7,10.8,0,13.8,0,17.5C0,21.6,3.4,25,7.5,25H11v-2H7.5\tc-3,0-5.5-2.5-5.5-5.5c0-2.9,2.2-5.3,5.1-5.5L8,12L8,11.1C8.5,7.1,11.9,4,16,4c3.7,0,6.8,2.6,7.7,6H25.8z"
  })), children);
});
var NetworkPublic24 = /*#__PURE__*/React.forwardRef(function NetworkPublic24(_ref237, ref) {
  var children = _ref237.children,
      rest = _objectWithoutProperties(_ref237, _excluded237);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,13c-4.7,0-8.5,3.8-8.5,8.5s3.8,8.5,8.5,8.5s8.5-3.8,8.5-8.5S27.2,13,22.5,13z M29,21h-3c0-2-0.3-4-0.9-5.5\tC27.2,16.5,28.8,18.5,29,21z M22.5,28C22.5,28,22.5,28,22.5,28c-0.4-0.2-1.3-1.8-1.5-5h2.9C23.7,26.2,22.9,27.8,22.5,28z M21,21\tc0.1-3.8,1.1-5.8,1.4-6c0,0,0,0,0,0c0.4,0.2,1.4,2.2,1.5,6H21z M19.9,15.5C19.3,17,19.1,19,19,21h-3C16.2,18.5,17.8,16.5,19.9,15.5z M16.2,23H19c0.1,1.6,0.4,3.2,0.9,4.5C18.1,26.7,16.7,25,16.2,23z M25.1,27.5c0.5-1.3,0.8-2.8,0.9-4.5h2.9\tC28.3,25,26.9,26.7,25.1,27.5z"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8,10c-0.9-4.6-5-8-9.8-8c-4.8,0-8.9,3.4-9.8,8.1C2.7,10.8,0,13.8,0,17.5C0,21.6,3.4,25,7.5,25H11v-2H7.5\tc-3,0-5.5-2.5-5.5-5.5c0-2.9,2.2-5.3,5.1-5.5L8,12L8,11.1C8.5,7.1,11.9,4,16,4c3.7,0,6.8,2.6,7.7,6H25.8z"
  })), children);
});
var NetworkPublic20 = /*#__PURE__*/React.forwardRef(function NetworkPublic20(_ref238, ref) {
  var children = _ref238.children,
      rest = _objectWithoutProperties(_ref238, _excluded238);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,13c-4.7,0-8.5,3.8-8.5,8.5s3.8,8.5,8.5,8.5s8.5-3.8,8.5-8.5S27.2,13,22.5,13z M29,21h-3c0-2-0.3-4-0.9-5.5\tC27.2,16.5,28.8,18.5,29,21z M22.5,28C22.5,28,22.5,28,22.5,28c-0.4-0.2-1.3-1.8-1.5-5h2.9C23.7,26.2,22.9,27.8,22.5,28z M21,21\tc0.1-3.8,1.1-5.8,1.4-6c0,0,0,0,0,0c0.4,0.2,1.4,2.2,1.5,6H21z M19.9,15.5C19.3,17,19.1,19,19,21h-3C16.2,18.5,17.8,16.5,19.9,15.5z M16.2,23H19c0.1,1.6,0.4,3.2,0.9,4.5C18.1,26.7,16.7,25,16.2,23z M25.1,27.5c0.5-1.3,0.8-2.8,0.9-4.5h2.9\tC28.3,25,26.9,26.7,25.1,27.5z"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8,10c-0.9-4.6-5-8-9.8-8c-4.8,0-8.9,3.4-9.8,8.1C2.7,10.8,0,13.8,0,17.5C0,21.6,3.4,25,7.5,25H11v-2H7.5\tc-3,0-5.5-2.5-5.5-5.5c0-2.9,2.2-5.3,5.1-5.5L8,12L8,11.1C8.5,7.1,11.9,4,16,4c3.7,0,6.8,2.6,7.7,6H25.8z"
  })), children);
});
var NetworkPublic16 = /*#__PURE__*/React.forwardRef(function NetworkPublic16(_ref239, ref) {
  var children = _ref239.children,
      rest = _objectWithoutProperties(_ref239, _excluded239);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,13c-4.7,0-8.5,3.8-8.5,8.5s3.8,8.5,8.5,8.5s8.5-3.8,8.5-8.5S27.2,13,22.5,13z M29,21h-3c0-2-0.3-4-0.9-5.5\tC27.2,16.5,28.8,18.5,29,21z M22.5,28C22.5,28,22.5,28,22.5,28c-0.4-0.2-1.3-1.8-1.5-5h2.9C23.7,26.2,22.9,27.8,22.5,28z M21,21\tc0.1-3.8,1.1-5.8,1.4-6c0,0,0,0,0,0c0.4,0.2,1.4,2.2,1.5,6H21z M19.9,15.5C19.3,17,19.1,19,19,21h-3C16.2,18.5,17.8,16.5,19.9,15.5z M16.2,23H19c0.1,1.6,0.4,3.2,0.9,4.5C18.1,26.7,16.7,25,16.2,23z M25.1,27.5c0.5-1.3,0.8-2.8,0.9-4.5h2.9\tC28.3,25,26.9,26.7,25.1,27.5z"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8,10c-0.9-4.6-5-8-9.8-8c-4.8,0-8.9,3.4-9.8,8.1C2.7,10.8,0,13.8,0,17.5C0,21.6,3.4,25,7.5,25H11v-2H7.5\tc-3,0-5.5-2.5-5.5-5.5c0-2.9,2.2-5.3,5.1-5.5L8,12L8,11.1C8.5,7.1,11.9,4,16,4c3.7,0,6.8,2.6,7.7,6H25.8z"
  })), children);
});
var NetworkInterface32 = /*#__PURE__*/React.forwardRef(function NetworkInterface32(_ref240, ref) {
  var children = _ref240.children,
      rest = _objectWithoutProperties(_ref240, _excluded240);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M28 18h-2V6h-13v-2h13c1.1028 0 2 .8972 2 2v12zM18 28H6c-1.1028 0-2-.8972-2-2v-13h2v13h12v2zM26 21l-1.793 1.793-5.5076-5.5078c.187-.3911.3005-.8232.3005-1.2852 0-1.6543-1.3457-3-3-3-.4617 0-.894.1133-1.2852.3008l-5.2817-5.2817c.3513-.5947.5669-1.2793.5669-2.019 0-2.2056-1.7944-4-4-4S2 3.7944 2 6s1.7944 4 4 4c.7395 0 1.4241-.2153 2.019-.5669l5.2815 5.2817c-.187.3911-.3005.8232-.3005 1.2852 0 1.6543 1.3457 3 3 3 .4617 0 .894-.1133 1.2852-.3008l5.5078 5.5078-1.793 1.793 5 5 5-5-5-5zM4 6c0-1.1025.8972-2 2-2s2 .8975 2 2-.8972 2-2 2-2-.8975-2-2zm11 10c0-.5513.4485-1 1-1s1 .4487 1 1-.4485 1-1 1-1-.4487-1-1zm8.8286 10l2.1714-2.1714 2.1714 2.1714-2.1714 2.1714-2.1714-2.1714z"
  })), children);
});
var NetworkInterface24 = /*#__PURE__*/React.forwardRef(function NetworkInterface24(_ref241, ref) {
  var children = _ref241.children,
      rest = _objectWithoutProperties(_ref241, _excluded241);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M28 18h-2V6h-13v-2h13c1.1028 0 2 .8972 2 2v12zM18 28H6c-1.1028 0-2-.8972-2-2v-13h2v13h12v2zM26 21l-1.793 1.793-5.5076-5.5078c.187-.3911.3005-.8232.3005-1.2852 0-1.6543-1.3457-3-3-3-.4617 0-.894.1133-1.2852.3008l-5.2817-5.2817c.3513-.5947.5669-1.2793.5669-2.019 0-2.2056-1.7944-4-4-4S2 3.7944 2 6s1.7944 4 4 4c.7395 0 1.4241-.2153 2.019-.5669l5.2815 5.2817c-.187.3911-.3005.8232-.3005 1.2852 0 1.6543 1.3457 3 3 3 .4617 0 .894-.1133 1.2852-.3008l5.5078 5.5078-1.793 1.793 5 5 5-5-5-5zM4 6c0-1.1025.8972-2 2-2s2 .8975 2 2-.8972 2-2 2-2-.8975-2-2zm11 10c0-.5513.4485-1 1-1s1 .4487 1 1-.4485 1-1 1-1-.4487-1-1zm8.8286 10l2.1714-2.1714 2.1714 2.1714-2.1714 2.1714-2.1714-2.1714z"
  })), children);
});
var NetworkInterface20 = /*#__PURE__*/React.forwardRef(function NetworkInterface20(_ref242, ref) {
  var children = _ref242.children,
      rest = _objectWithoutProperties(_ref242, _excluded242);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M28 18h-2V6h-13v-2h13c1.1028 0 2 .8972 2 2v12zM18 28H6c-1.1028 0-2-.8972-2-2v-13h2v13h12v2zM26 21l-1.793 1.793-5.5076-5.5078c.187-.3911.3005-.8232.3005-1.2852 0-1.6543-1.3457-3-3-3-.4617 0-.894.1133-1.2852.3008l-5.2817-5.2817c.3513-.5947.5669-1.2793.5669-2.019 0-2.2056-1.7944-4-4-4S2 3.7944 2 6s1.7944 4 4 4c.7395 0 1.4241-.2153 2.019-.5669l5.2815 5.2817c-.187.3911-.3005.8232-.3005 1.2852 0 1.6543 1.3457 3 3 3 .4617 0 .894-.1133 1.2852-.3008l5.5078 5.5078-1.793 1.793 5 5 5-5-5-5zM4 6c0-1.1025.8972-2 2-2s2 .8975 2 2-.8972 2-2 2-2-.8975-2-2zm11 10c0-.5513.4485-1 1-1s1 .4487 1 1-.4485 1-1 1-1-.4487-1-1zm8.8286 10l2.1714-2.1714 2.1714 2.1714-2.1714 2.1714-2.1714-2.1714z"
  })), children);
});
var NetworkInterface16 = /*#__PURE__*/React.forwardRef(function NetworkInterface16(_ref243, ref) {
  var children = _ref243.children,
      rest = _objectWithoutProperties(_ref243, _excluded243);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M28 18h-2V6h-13v-2h13c1.1028 0 2 .8972 2 2v12zM18 28H6c-1.1028 0-2-.8972-2-2v-13h2v13h12v2zM26 21l-1.793 1.793-5.5076-5.5078c.187-.3911.3005-.8232.3005-1.2852 0-1.6543-1.3457-3-3-3-.4617 0-.894.1133-1.2852.3008l-5.2817-5.2817c.3513-.5947.5669-1.2793.5669-2.019 0-2.2056-1.7944-4-4-4S2 3.7944 2 6s1.7944 4 4 4c.7395 0 1.4241-.2153 2.019-.5669l5.2815 5.2817c-.187.3911-.3005.8232-.3005 1.2852 0 1.6543 1.3457 3 3 3 .4617 0 .894-.1133 1.2852-.3008l5.5078 5.5078-1.793 1.793 5 5 5-5-5-5zM4 6c0-1.1025.8972-2 2-2s2 .8975 2 2-.8972 2-2 2-2-.8975-2-2zm11 10c0-.5513.4485-1 1-1s1 .4487 1 1-.4485 1-1 1-1-.4487-1-1zm8.8286 10l2.1714-2.1714 2.1714 2.1714-2.1714 2.1714-2.1714-2.1714z"
  })), children);
});
var NewTab32 = /*#__PURE__*/React.forwardRef(function NewTab32(_ref244, ref) {
  var children = _ref244.children,
      rest = _objectWithoutProperties(_ref244, _excluded244);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M26,26H6V6H16V4H6A2.002,2.002,0,0,0,4,6V26a2.002,2.002,0,0,0,2,2H26a2.002,2.002,0,0,0,2-2V16H26Z"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M26,26H6V6H16V4H6A2.002,2.002,0,0,0,4,6V26a2.002,2.002,0,0,0,2,2H26a2.002,2.002,0,0,0,2-2V16H26Z"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M26 6L26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6 26 6z"
  })), children);
});
var NewTab24 = /*#__PURE__*/React.forwardRef(function NewTab24(_ref245, ref) {
  var children = _ref245.children,
      rest = _objectWithoutProperties(_ref245, _excluded245);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M26,26H6V6H16V4H6A2.002,2.002,0,0,0,4,6V26a2.002,2.002,0,0,0,2,2H26a2.002,2.002,0,0,0,2-2V16H26Z"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M26,26H6V6H16V4H6A2.002,2.002,0,0,0,4,6V26a2.002,2.002,0,0,0,2,2H26a2.002,2.002,0,0,0,2-2V16H26Z"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M26 6L26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6 26 6z"
  })), children);
});
var NewTab20 = /*#__PURE__*/React.forwardRef(function NewTab20(_ref246, ref) {
  var children = _ref246.children,
      rest = _objectWithoutProperties(_ref246, _excluded246);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M26,26H6V6H16V4H6A2.002,2.002,0,0,0,4,6V26a2.002,2.002,0,0,0,2,2H26a2.002,2.002,0,0,0,2-2V16H26Z"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M26,26H6V6H16V4H6A2.002,2.002,0,0,0,4,6V26a2.002,2.002,0,0,0,2,2H26a2.002,2.002,0,0,0,2-2V16H26Z"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M26 6L26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6 26 6z"
  })), children);
});
var NewTab16 = /*#__PURE__*/React.forwardRef(function NewTab16(_ref247, ref) {
  var children = _ref247.children,
      rest = _objectWithoutProperties(_ref247, _excluded247);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M13,13H3V3h5V2H3C2.4,2,2,2.4,2,3v10c0,0.6,0.4,1,1,1h10c0.6,0,1-0.4,1-1V8h-1V13z"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M13 3L13 1 12 1 12 3 10 3 10 4 12 4 12 6 13 6 13 4 15 4 15 3z"
  })), children);
});
var NextFilled32 = /*#__PURE__*/React.forwardRef(function NextFilled32(_ref248, ref) {
  var children = _ref248.children,
      rest = _objectWithoutProperties(_ref248, _excluded248);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M2,16A14,14,0,1,0,16,2,14,14,0,0,0,2,16Zm6-1H20.15L14.57,9.3926,16,8l8,8-8,8-1.43-1.4272L20.15,17H8Z"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16 8L14.57 9.393 20.15 15 8 15 8 17 20.15 17 14.57 22.573 16 24 24 16 16 8z",
    "data-icon-path": "inner-path"
  })), children);
});
var NextFilled24 = /*#__PURE__*/React.forwardRef(function NextFilled24(_ref249, ref) {
  var children = _ref249.children,
      rest = _objectWithoutProperties(_ref249, _excluded249);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M2,16A14,14,0,1,0,16,2,14,14,0,0,0,2,16Zm6-1H20.15L14.57,9.3926,16,8l8,8-8,8-1.43-1.4272L20.15,17H8Z"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16 8L14.57 9.393 20.15 15 8 15 8 17 20.15 17 14.57 22.573 16 24 24 16 16 8z",
    "data-icon-path": "inner-path"
  })), children);
});
var NextFilled20 = /*#__PURE__*/React.forwardRef(function NextFilled20(_ref250, ref) {
  var children = _ref250.children,
      rest = _objectWithoutProperties(_ref250, _excluded250);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M2,16A14,14,0,1,0,16,2,14,14,0,0,0,2,16Zm6-1H20.15L14.57,9.3926,16,8l8,8-8,8-1.43-1.4272L20.15,17H8Z"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16 8L14.57 9.393 20.15 15 8 15 8 17 20.15 17 14.57 22.573 16 24 24 16 16 8z",
    "data-icon-path": "inner-path"
  })), children);
});

export { MobileDownload16, MobileDownload20, MobileDownload24, MobileEvent16, MobileEvent20, MobileEvent24, MobileEvent32, MobileLandscape16, MobileLandscape20, MobileLandscape24, MobileLandscape32, MobileRequest16, MobileRequest20, MobileRequest24, MobileRequest32, MobileSession16, MobileSession20, MobileSession24, MobileSession32, MobileView16, MobileView20, MobileView24, MobileView32, MobileViewOrientation16, MobileViewOrientation20, MobileViewOrientation24, MobileViewOrientation32, MobilityServices16, MobilityServices20, MobilityServices24, MobilityServices32, Model16, Model20, Model24, Model32, ModelAlt16, ModelAlt20, ModelAlt24, ModelAlt32, ModelBuilder16, ModelBuilder20, ModelBuilder24, ModelBuilder32, ModelBuilderReference16, ModelBuilderReference20, ModelBuilderReference24, ModelBuilderReference32, ModelReference16, ModelReference20, ModelReference24, ModelReference32, ModelTuned16, ModelTuned20, ModelTuned24, ModelTuned32, Money16, Money20, Money24, Money32, Monster16, Monster20, Monster24, Monster32, Monument16, Monument20, Monument24, Monument32, Moon16, Moon20, Moon24, Moon32, Moonrise16, Moonrise20, Moonrise24, Moonrise32, Moonset16, Moonset20, Moonset24, Moonset32, MostlyCloudy16, MostlyCloudy20, MostlyCloudy24, MostlyCloudy32, MostlyCloudyNight16, MostlyCloudyNight20, MostlyCloudyNight24, MostlyCloudyNight32, Mountain16, Mountain20, Mountain24, Mountain32, Mov16, Mov20, Mov24, Mov32, Move16, Move20, Move24, Move32, Movement16, Movement20, Movement24, Movement32, Mp316, Mp320, Mp324, Mp332, Mp416, Mp420, Mp424, Mp432, Mpeg16, Mpeg20, Mpeg24, Mpeg32, Mpg216, Mpg220, Mpg224, Mpg232, Music16, Music20, Music24, Music32, MusicAdd16, MusicAdd20, MusicAdd24, MusicAdd32, MusicRemove16, MusicRemove20, MusicRemove24, MusicRemove32, Mysql16, Mysql20, Mysql24, Mysql32, NameSpace16, NameSpace20, NameSpace24, NameSpace32, NavaidCivil16, NavaidCivil20, NavaidCivil24, NavaidCivil32, NavaidDme16, NavaidDme20, NavaidDme24, NavaidDme32, NavaidHelipad16, NavaidHelipad20, NavaidHelipad24, NavaidHelipad32, NavaidMilitary16, NavaidMilitary20, NavaidMilitary24, NavaidMilitary32, NavaidMilitaryCivil16, NavaidMilitaryCivil20, NavaidMilitaryCivil24, NavaidMilitaryCivil32, NavaidNdb16, NavaidNdb20, NavaidNdb24, NavaidNdb32, NavaidNdbDme16, NavaidNdbDme20, NavaidNdbDme24, NavaidNdbDme32, NavaidPrivate16, NavaidPrivate20, NavaidPrivate24, NavaidPrivate32, NavaidSeaplane16, NavaidSeaplane20, NavaidSeaplane24, NavaidSeaplane32, NavaidTacan16, NavaidTacan20, NavaidTacan24, NavaidTacan32, NavaidVhfor16, NavaidVhfor20, NavaidVhfor24, NavaidVhfor32, NavaidVor16, NavaidVor20, NavaidVor24, NavaidVor32, NavaidVordme16, NavaidVordme20, NavaidVordme24, NavaidVordme32, NavaidVortac16, NavaidVortac20, NavaidVortac24, NavaidVortac32, Need16, Need20, Need24, Need32, NetworkAdminControl16, NetworkAdminControl20, NetworkAdminControl24, NetworkAdminControl32, NetworkEnterprise16, NetworkEnterprise20, NetworkEnterprise24, NetworkEnterprise32, NetworkInterface16, NetworkInterface20, NetworkInterface24, NetworkInterface32, NetworkOverlay16, NetworkOverlay20, NetworkOverlay24, NetworkOverlay32, NetworkPublic16, NetworkPublic20, NetworkPublic24, NetworkPublic32, Network_116, Network_120, Network_124, Network_132, Network_216, Network_220, Network_224, Network_232, Network_316, Network_320, Network_324, Network_332, Network_3Reference16, Network_3Reference20, Network_3Reference24, Network_3Reference32, Network_416, Network_420, Network_424, Network_432, Network_4Reference16, Network_4Reference20, Network_4Reference24, Network_4Reference32, NewTab16, NewTab20, NewTab24, NewTab32, NextFilled20, NextFilled24, NextFilled32 };
